import * as Types from '../../../model/Sitecore.graphql.d';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type ArticleSearchSeriesQuery_search_ItemSearchResults_pageInfo_PageInfo = (
  { __typename?: 'PageInfo' }
  & Pick<Types.PageInfo, 'endCursor' | 'hasNext'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate = (
  { __typename?: 'ItemTemplate' }
  & Pick<Types.ItemTemplate, 'id'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory_name_1e4c2734dc754d528af8084e6c400e1f_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM = { __typename?: 'Accordion' | 'AccordionFolder' | 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' | 'AccordionItem' | 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' | 'AccordionParametersTemplate' | 'AccordionPresentation' | 'AccordionPresentationFolder' | 'Accordion_02d060598cc14423a9ac9ff2365176b7' | 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' | 'AddItem' | 'AddItem_1e1b739ec3784909941d171aca7362e5' | 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' | 'AddItem_de8c75222f3241288f20342f479894eb' | 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' | 'AddThisParameters' | 'AggregatedFacetFilter' | 'AlertMessage' | 'AlertMessageFolder' | 'AlertMessageParametersTemplate' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c9XozYxqaFC0frAPHPeq433LPynBF0XM1g0Uz5LICn8 = { __typename?: 'AlertMessageType' | 'AllertMessageTypeFolder' | 'Archive' | 'ArticleAuthor' | 'ArticleAuthorsFolder' | 'ArticleCategoriesFolder' | 'ArticleChapter' | 'ArticleChapters' | 'ArticleContentType' | 'ArticleContentTypesFolder' | 'ArticleFilter' | 'ArticleFilterOption' | 'ArticleFootnote' | 'ArticleFootnoteLink' | 'ArticleFootnoteText' | 'ArticleInfogramTile' | 'ArticleInfogramTileParametersTemplate' | 'ArticlePage' | 'ArticleRegion' | 'ArticleRegionsFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9VPlmQkQdt9l4maQ46Z5fMhr5w16NSqTADFDI2lIY9Q = { __typename?: 'ArticleSearchPage' | 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' | 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' | 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' | 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' | 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' | 'ArticleSeriesCollection' | 'ArticleSeriesFolder' | 'ArticleSettings' | 'ArticleSubscriptionBanner' | 'ArticleSubscriptionBannerFolder' | 'ArticleTag' | 'ArticleTagsFolder' | 'ArticleTeamAuthor' | 'ArticleTileParametersTemplate' | 'ArticleTilesParametersTemplate' | 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' | 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' | 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' | 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 = { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' | 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' | 'ArticlesGroupFolder' | 'AttachThemeExtension' | 'AutomaticDocumentListings' | 'AutomaticDocumentListingsFolder' | 'AvailableJSONRenderings' | 'AvailableMetaRenderings' | 'AvailableRenderings' | 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' | 'AwardsBanner' | 'AwardsBannerFolder' | 'AwardsBannerImage' | 'AwardsBannerParametersTemplate' | 'BYOCWrapperRenderingParameters' | 'BackgroundColorOption' | 'BackgroundColorOptionFolder' | 'BannerFolder' | 'BannerType' | 'BannerTypeFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw = { __typename?: 'BaseHeading' | 'BaseHeadingFolder' | 'BoolFacet' | 'BranchesFolder' | 'Breadcrumb' | 'BrowserTitleDefinition' | 'CORSEntry' | 'CORSGrouping' | 'CTAPresentationType' | 'CTAPresentationTypeFolder' | 'C__AbrdnPage' | 'C__ActionBase' | 'C__AdvancedParameter' | 'C__App' | 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' | 'C__ArticleWildcardPage' | 'C__AvailableRenderingsFolder' | 'C__BYOCRenderingParameters' | 'C__BackgroundParametersTemplate' | 'C__BaseCTA' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU = { __typename?: 'C__BasePage' | 'C__BasePage_037da552a5524fe4aeee331f57ac1378' | 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' | 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' | 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' | 'C__BasePage_728c97b5c56146d9807e21018a972bb5' | 'C__BasePage_6105875085f346729dfc8d133b481f26' | 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' | 'C__BaseRenderingParameters' | 'C__BaseTheme' | 'C__BaseVariantField' | 'C__Class' | 'C__CompositeGroup' | 'C__CompositeSection' | 'C__EloquaForm' | 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' | 'C__ExtendedOptions' | 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' | 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' | 'C__FEaaSRenderingParameters' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 = { __typename?: 'C__FacetSelectorConfigBase' | 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' | 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' | 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' | 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' | 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' | 'C__GlobalDatasourceBehavior' | 'C__GridDefinition' | 'C__GridItemBase' | 'C__GridParameters' | 'C__HeadlessSite' | 'C__HeadlessTenant' | 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' | 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' | 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' | 'C__IAllowEmpty' | 'C__IBaseVariantDefinition' | 'C__IBoosting' | 'C__ICacheable' | 'C__ICompatibleRenderings' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw = { __typename?: 'C__IComponentVariant' | 'C__IControlType' | 'C__IDynamicPlaceholder' | 'C__IFEaaSComponentsDataSourceTemplates' | 'C__IFEaaSComponentsEditorScriptURL' | 'C__IIcon' | 'C__ILocation' | 'C__IPaginable' | 'C__IPagination' | 'C__IPoi' | 'C__IRenderingId' | 'C__ISplitter' | 'C__IStyling' | 'C__IVariantDefinition' | 'C__InvestmentTrustPage' | 'C__JSONField' | 'C__JSONReference' | 'C__JSSData' | 'C__JSSSettings' | 'C__JSSSiteFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 = { __typename?: 'C__JssRootFolder' | 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' | 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' | 'C__Page' | 'C__PageData' | 'C__PageDesignFolder' | 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' | 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' | 'C__PartialDesign' | 'C__PartialDesignFolder' | 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' | 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' | 'C__PlaceholderWrapper' | 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' | 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' | 'C__RedirectMapGrouping' | 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' | 'C__Route' | 'C__SimpleVideo' | 'C__SiteSettingsFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jWiNNE8wAezwjVLEWn3IRc7x4WY9EKiEuZpBROPG4 = { __typename?: 'C__SitemapSettings' | 'C__StandardTemplate' | 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' | 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' | 'C__TrustFolder' | 'C__VariantDefinition' | 'C__VariantField' | 'C__VariantsGrouping' | 'C___AdvancedItem' | 'C___Arguments' | 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' | 'C___Article' | 'C___ArticlePageWorkflow' | 'C___ArticleSearchPage' | 'C___ArticleWildcard' | 'C___AssetServiceThemeMode' | 'C___BaseArticle' | 'C___BaseDataFolder' | 'C___BaseHelpArticle' | 'C___BaseInvestmentTrust' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BfCZy14f5vCYoKPvUvlJVRkotuL1gmUwjkgrggQ05A = { __typename?: 'C___BaseJSSTenant' | 'C___BasePage' | 'C___BasePageDesign' | 'C___BasePageDesignFolder' | 'C___BasePartialDesign' | 'C___BasePartialDesignFolder' | 'C___BasePlaceholder' | 'C___BasePlaceholderSettingsFolder' | 'C___BasePresentation' | 'C___BasePressRelease' | 'C___BaseRenderingParameters' | 'C___BaseSXAStandardValuesFolder' | 'C___BaseSettings' | 'C___BaseSharedSitesSettings' | 'C___BaseSiteDefinition' | 'C___BaseSiteFolder' | 'C___BaseSiteGrouping' | 'C___BaseSiteRoot' | 'C___BaseTenant' | 'C___BaseTenantFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_PHLgvBFZABTRngNRTYYUi9KBdwe9p7W4YDlCj72fOIs = { __typename?: 'C___BucketRules' | 'C___CORS' | 'C___Content' | 'C___ContentType' | 'C___DataAttributes' | 'C___DatasourceWorkflow' | 'C___Dependencies' | 'C___Description' | 'C___DesignTemplateMapping' | 'C___Designable' | 'C___EditType' | 'C___EditType_8a9f84baaa124c5d9096935714809da4' | 'C___EditingTheme' | 'C___Enabled' | 'C___ErrorHandling' | 'C___ExternalArticle' | 'C___Fields' | 'C___FilteredArticlesParent' | 'C___FilteredArticlesWildcard' | 'C___Footnotes' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_KL7bf4QPLQ7mpyzzvQk5f6piwJk1PES0rcP7Uy9x0M = { __typename?: 'C___FundDetailsWildcard' | 'C___FundFormAvailability' | 'C___FundMetadataPage' | 'C___FundSearchPage' | 'C___FundsFolder' | 'C___FundsFormsFolder' | 'C___FundsLiteratureFolder' | 'C___FundsShareclassesDetailsWildcard' | 'C___GridMapping' | 'C___HelpArticle' | 'C___HelpArticleSearchPage' | 'C___HelpArticleWildcard' | 'C___HorizonDatasourceGrouping' | 'C___Icon' | 'C___IncludeByDefault' | 'C___IncludeIfInstalled' | 'C___InternalArticle' | 'C___InternetExplorerCompatibilityMode' | 'C___IsSystemModule' | 'C___JSONVariantPaging' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_iqnu4DMOAGlC9sVDpDbjHWwyB7ysXrKwlOhFHAyC0 = { __typename?: 'C___JSONVariantsBase' | 'C___LimitedDisplay' | 'C___LinkAttributes' | 'C___LinkSettings' | 'C___LiteratureHubSearchPage' | 'C___ManualKeyInformation' | 'C___MemberOf' | 'C___MetadataPage' | 'C___Modules' | 'C___Name' | 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' | 'C___Name_299cdb154745448a807868d401248eaa' | 'C___Name_b88cf88159a54a19991e71038751cb60' | 'C___Navigable' | 'C___NavigablePage' | 'C___PageContent' | 'C___PageWorkflow' | 'C___PerSiteStandardValues' | 'C___Podcast' | 'C___PodcastPressRelease' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_umgzCXtgi1WMowaNMDJnNsdrdDP4Ie7qfWy2owTqtI = { __typename?: 'C___PremiumContentPage' | 'C___PressRelease' | 'C___PressReleaseContentType' | 'C___PressReleaseSearchPage' | 'C___PressReleaseWildcard' | 'C___ProtectedTheme' | 'C___PublishingGroupingTemplate' | 'C___RenderingRelatedParameters' | 'C___RenderingVariantsBase' | 'C___RenderingsList' | 'C___RobotsContent' | 'C___RoleDomain' | 'C___RoleName' | 'C___RoleType' | 'C___SalesforceCommonValidations' | 'C___SalesforceFieldId' | 'C___SalesforceFieldTitle' | 'C___SalesforceFieldValue' | 'C___Script' | 'C___SearchSignature' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c8gc72G7Xyo5xvM63VPyvhGmiUxe0BFuVTVAj9su0 = { __typename?: 'C___Searchable' | 'C___SecurityItemPointer' | 'C___SharedArticles' | 'C___SharedContent' | 'C___SharedHelpArticles' | 'C___SharedPage' | 'C___SharedPressReleases' | 'C___SharedRoot' | 'C___SharedSettings' | 'C___SiteContent' | 'C___SiteFolder' | 'C___SiteMediaLibrary' | 'C___SiteSettings' | 'C___SiteTemplate' | 'C___SitecoreClientSiteManaging' | 'C___Sitemap' | 'C___SitemapMediaItems' | 'C___SlidersRangeSettings' | 'C___SolutionTemplateContent' | 'C___SolutionTemplateDescription' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VtfJ6wYpLDTemXJEIB7XJw2duFCBCMgGB8vlYx6hsc0 = { __typename?: 'C___SolutionTemplateName' | 'C___SortOrder' | 'C___StackBreakpoint' | 'C___Statistics' | 'C___SupportedLanguages' | 'C___Taggable' | 'C___TeamMembersParentPage' | 'C___TeamMembersWildcard' | 'C___TechzoneArticle' | 'C___Template' | 'C___Title' | 'C___Type' | 'C___Validation' | 'C___VariantPaging' | 'C___VectorTile' | 'C___VectorTileLink' | 'C___Video' | 'C___VideoPressRelease' | 'C___Width' | 'C___WildcardPage' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_1BpmAGsjLrkU4cexVLSJ4OyM81tByZRfH3Rlj3t6CE = { __typename?: 'CacheSetting' | 'Caching_26fce9bf0256458d8281a713a5bf5520' | 'CalendarEvent' | 'CallOutSection' | 'CallOutSectionDropdownOption' | 'CallOutSectionFolder' | 'CallOutSectionParametersTemplate' | 'CallToAction' | 'CallToActionFolder' | 'CapabilitiesFolder' | 'Capability' | 'CapabilityMap' | 'CapabilityMappings' | 'Carousel' | 'CarouselFolder' | 'CarouselSlide' | 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' | 'Checkbox' | 'ChecklistFilter' | 'ChecklistFilterFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NyEECiwuus0IEb5R3ZHyvXsBaUAVp6zWfQGtLdoaAU = { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' | 'ColumnSplitter' | 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' | 'CompatibilityMode' | 'ComponentConfiguration' | 'ComponentThemeConfiguration' | 'ComponentThemesConfiguration' | 'ComponentsConfigurations' | 'ConfigurationFolder' | 'Container' | 'ContainerOption' | 'ContainerOptionsFolder' | 'ContainerParametersTemplate' | 'Container_45130bdbbae34edcaea87b68b9d94c7f' | 'ContentBlock' | 'ContentBlockFolder' | 'ContentToken' | 'ContentTokenFolder' | 'ContentType' | 'CorporateTheme' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Fj4L99iVJxbVnFn7srvABth7WlFSHNzZENorwzE = { __typename?: 'CorporateThemesFolder' | 'Country' | 'CountryISOCode' | 'CountryISOCodesFolder' | 'CustomerReviewFolder' | 'CustomerReviewTile' | 'CustomerReviewTileParametersTemplate' | 'DataBridgeDocumentCategoryMap' | 'DataBridgeFund' | 'DataBridgeFundRangeName' | 'DataBridgeSettingsFolder' | 'DataBridgeShareClass' | 'DataFolder' | 'DatasourceConfiguration' | 'DatasourceConfigurations' | 'DatasourceWorkflowAction' | 'DateFacet' | 'DateFilter' | 'DateFilterFolder' | 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ANdBVC6KFTlUcJhSibUfyWTFtLta5lsMUp9qlxcVurI = { __typename?: 'DefaultColumnLayout' | 'DefaultShareclassMapping' | 'DefaultShareclassMappings' | 'DescriptiveHighlight' | 'DescriptiveHighlightFolder' | 'DescriptiveHighlightItem' | 'DescriptiveHighlightParametersTemplate' | 'Device' | 'Device_7c27ec70f42e40428a0fabaa2f8eda18' | 'Devices' | 'DictionaryFolder' | 'DisqusParameters' | 'DistanceFacet' | 'Divider' | 'DocumentItem' | 'DocumentListings' | 'DocumentListingsFolder' | 'DocumentTypeFolder' | 'DominantLanguageMapping' | 'Dropdown' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_xbvRLMKOfZhwK7StDx4pk8GufekPnO6TlKVuKDWc0 = { __typename?: 'DropdownFilter' | 'DropdownFilterFolder' | 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' | 'EditEditingTheme' | 'EditFrame' | 'EditModePanel' | 'EditSiteItem' | 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' | 'EditSiteTheme' | 'EditTenantTemplate' | 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' | 'EditType' | 'EloquaFormFolder' | 'EloquaFundForm' | 'Enum' | 'Enums' | 'ErrorPage' | 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' | 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' | 'ErrorPage_45d797cc048740ffb693214883ff35c2' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_C7jD2H7yOuHKbYSq1WvlnNO2zZ9k33Tt60j7wVs4 = { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' | 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' | 'EventCalendarParameters' | 'EventList' | 'EventListParameters' | 'EventTypes' | 'EventsFolder' | 'ExecuteScript' | 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' | 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' | 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' | 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' | 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' | 'ExtendSiteTheme' | 'ExternalLiterature' | 'FEaaSWrapperRenderingParameters' | 'FacebookCommentsParametersTemplate' | 'FacetSlider' | 'FacetSliderFolder' | 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_6hn5PudNLAFVxgpoCeIRzlxkBlB8a1pSQwG8cmE = { __typename?: 'FacetSummary' | 'FacetSummaryFolder' | 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' | 'FacetsGrouping' | 'FakeNavigationItem' | 'FeatureBanner' | 'FeatureBannerParametersTemplate' | 'FeaturedArticles' | 'FeaturedArticlesFolder' | 'FeaturedTheme' | 'FeaturedThemesFolder' | 'Feed' | 'FeedFolder' | 'FeedParameters' | 'FieldEditor' | 'FieldRenderer' | 'FileList' | 'FileListFolder' | 'FileListParametersTemplate' | 'File_04129321770849c1801baee196e1c0a8' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_u7BRZVBhheosXLCSBWQJBOivuyXVuOOaFBBIAa5UQdc = { __typename?: 'FilterCriteria' | 'FilterCriteriaFolder' | 'FilterTaxonomyOption' | 'FilterTaxonomyOptions' | 'FilteredArticlesParentPage' | 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' | 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' | 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' | 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' | 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' | 'FilteredArticlesWildcardPage' | 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' | 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' | 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' | 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' | 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' | 'Flip' | 'FlipFolder' | 'Flip_5ef078504c044b839dafefd752cfaba8' | 'Flipside' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dpqtGMeZVSGVIy9q5ldacew1cWo2gELfnm77xVZDIg = { __typename?: 'FloatFacet' | 'Footer' | 'FooterFolder' | 'FooterLink' | 'FormRenderingParameters' | 'FundAssetClass' | 'FundAssetClassesFolder' | 'FundDetailsWildcardPage' | 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' | 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' | 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' | 'FundFormsFolder' | 'FundInFocus' | 'FundInFocusShareClass' | 'FundSearchPage' | 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' | 'FundSearchPage_5806f83c03bc443380678ff955f4310f' | 'FundSearchPage_7432205c04214a419ca064c4cb37501c' | 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' | 'FundSettings' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_lalHkBPxpftIF8HuYXqfDXnzifCeKVwttYezsBbL6A = { __typename?: 'FundShareclassDetailsWildcardPage' | 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' | 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' | 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' | 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' | 'FundSubAssetClass' | 'FundSubAssetClassesFolder' | 'FundsExternalLiteratureFolder' | 'FundsFolder' | 'FundsInFocusFolder' | 'FundsInFocusParametersTemplate' | 'FundsLiteratureFolder' | 'FundsLiteratureMappingsFolder' | 'Gallery' | 'GalleryFolder' | 'GalleryImage' | 'GalleryParametersTemplate' | 'GalleryVideo' | 'GatedAccordionContainer' | 'GlobalLanguageSelector' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Q9MXc9RjR2M267DgK6zxTNUiUi6NIPijp0dZLLIgk = { __typename?: 'GlobalNavigationBar' | 'GoogleAnalytics' | 'GoogleTagManager' | 'GoogleTagManagerFolder' | 'GridSetup' | 'GridTheme' | 'HTMLCode' | 'HTMLCodeFolder' | 'HTMLInclude' | 'HTMLIncludesFolder' | 'HTMLSnippet' | 'HTMLSnippetFolder' | 'HTMLTag' | 'Header' | 'HeaderFolder' | 'Heading' | 'HeadlessSiteSetupRoot' | 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' | 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' | 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dMUje5zuPQ5cTfsHsP483FXiZjLZOp5y7mQEffnH1xw = { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' | 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' | 'HeadlessSite_229484893ca144958b9937167dfb5064' | 'HeadlessSite_b28055626acc45a2913a9617398c9730' | 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' | 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' | 'HeadlessSolutionTemplateFolder' | 'HeadlessTenantSetupRoot' | 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' | 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' | 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' | 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' | 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' | 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' | 'HeadlessTenant_94824ac390d748499e5af0275d10811f' | 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' | 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' | 'HeadlessTrustSite' | 'HeadlessVariants' | 'HeadlessVariantsGrouping' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_hb7aIiGiWMscK3W1w04Vy90EkNWrFzDyfbrTjKcNK2s = { __typename?: 'HelpArticlePage' | 'HelpArticlePlatform' | 'HelpArticlePlatformMap' | 'HelpArticlePlatformMappings' | 'HelpArticlePlatformsFolder' | 'HelpArticleSearchPage' | 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' | 'HelpArticleTag' | 'HelpArticleTagsFolder' | 'HelpArticleWildcardPage' | 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' | 'HelpArticlesGroupFolder' | 'HelpTagMap' | 'HelpTagMappings' | 'HeroBanner' | 'Highlight' | 'HighlightBlock' | 'HighlightBlockFolder' | 'HighlightBlockParametersTemplate' | 'HighlightFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mlJlKCHse9oAGb81rXrwxNMBDoalRluBpSZ2wf1jcU = { __typename?: 'HighlightItem' | 'HighlightParametersTemplate' | 'Home' | 'HomePage' | 'HomePage_0d3963a8171d4080b5f808618578b631' | 'HomePage_6d95c7d946c74a70be07304cc73a2010' | 'HomePage_b407f259b4e34c7db9a06e8907a56b17' | 'HomePage_cde13c51062d426b95569e8202edc963' | 'HomePage_de9353283a3e41c495ba386aed0540c6' | 'IFrame' | 'IFrameFolder' | 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' | 'IFrameParametersTemplate' | 'IFrame_0da12d476de24dfeb4d0f513489bfea1' | 'IFrame_88a6f65f2b78491bb3770b06e48883e1' | 'Icon' | 'IconFolder' | 'Image' | 'ImageFolder' | 'ImageFolder_edc00e86cef24d0cbfa264460becc323' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bpyH1qQmSBBKUyiskmVf3nBxPfFJ3ja7QnVcUd6KZro = { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' | 'ImageParametersTemplate' | 'Image_83bc563c6320490092f8204bff81586a' | 'Image_15185b0e641844499f934ff03b7ee032' | 'Image_d885df8cb2d64007b34b2bbafb527304' | 'Infographics' | 'InfographicsFolder' | 'InputValidationStep' | 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' | 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' | 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' | 'IntegerFacet' | 'IntroCopy' | 'IntroCopyFolder' | 'InvestmentTrustAssetClass' | 'InvestmentTrustAssetClassFolder' | 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' | 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' | 'InvestmentTrustRegion' | 'InvestmentTrustRegionFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg = { __typename?: 'InvestmentTrustStyle' | 'InvestmentTrustStyleFolder' | 'InvestorType' | 'InvestorTypesFolder' | 'ItemQueriesFolder' | 'ItemRights' | 'JSBeaconSettings' | 'JSONCheckbox' | 'JSONContent' | 'JSONDate' | 'JSONFile' | 'JSONImage' | 'JSONLayout' | 'JSONList' | 'JSONMultilistReference' | 'JSONPlaceholder' | 'JSONQuery' | 'JSONResults' | 'JSONRichText' | 'JSONScriban' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY = { __typename?: 'JSONSection' | 'JSONTemplate' | 'JSONText' | 'JSONToken' | 'JSONVariantDefinition' | 'JSONVariants' | 'JSSLayout' | 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' | 'JSSSettings_6b328292f8314ab79885d89a054ca10a' | 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' | 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' | 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' | 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' | 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' | 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' | 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' | 'JSSSiteGrouping' | 'JSSTenantFolder' | 'JavaScriptRendering' | 'JsonRendering' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q = { __typename?: 'JurisdictionStatus' | 'JurisdictionsFolder' | 'KeyHighlightItem' | 'KeyHighlights' | 'KeyHighlightsFolder' | 'KeyHighlightsParametersTemplate' | 'Language' | 'LanguageSelector' | 'LanguagesFolder' | 'LatestPressReleasesParametersTemplate' | 'LayoutServiceVariants' | 'LimitedDisplayFolder' | 'LimitedDisplayOption' | 'Link' | 'LinkList' | 'LinkListFolder' | 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' | 'LinkList_33c9207e3b0446068ef54ca99a97c776' | 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' | 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA = { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' | 'Link_930f134d56784b35bfd1b77f9d0115f1' | 'Link_e24e0789a05848bfabb6c69c0e60b6b7' | 'LinksFolder' | 'List' | 'ListFacet' | 'ListFolder' | 'ListItem' | 'ListParametersTemplate' | 'ListStyle' | 'ListStyleItem' | 'ListingHeroBanner' | 'ListingHeroParametersTemplate' | 'LiteratureAuthorization' | 'LiteratureAuthorizationsFolder' | 'LiteratureHubSearchPage' | 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' | 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' | 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' | 'LoadMore' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM = { __typename?: 'LoadMoreFolder' | 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' | 'LocationFilter' | 'LocationFilterFolder' | 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' | 'Log' | 'Login' | 'Login_abed54dc4f7840ddac562289c9c849d8' | 'LogoTextBlockItem' | 'LogoTextBlocks' | 'LogoTextBlocksFolder' | 'Logout' | 'Logout_c2294d8235a6452a94b15eb5e543b602' | 'ManagedRangeFilter' | 'ManagedRangeFilterFolder' | 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' | 'ManagedRangeItem' | 'Map' | 'MapParameters' | 'MapsFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 = { __typename?: 'MapsProvider' | 'MediaBlock' | 'MediaBlockFolder' | 'MediaBlockParametersTemplate' | 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' | 'MediaLinkParameters' | 'MediaVirtualFolder' | 'MegaNavigation' | 'MegaNavigationFolder' | 'MetaBranding' | 'MetaRenderingParameters' | 'MetadataPartialDesign' | 'Model' | 'ModelIterator' | 'MyLocationPOI' | 'Navigation' | 'NavigationCategory' | 'NavigationFilter' | 'NavigationFilterFolder' | 'NavigationLink' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs = { __typename?: 'NavigationSubcategory' | 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' | 'OneTrustSettings' | 'OptimiserConfiguration' | 'OptimiserConfigurationSection' | 'OptimizedFile' | 'OracleCDPSettings' | 'OverlayContent' | 'OverlayFolderTemplate' | 'Ownership' | 'OwnershipFolder' | 'POI' | 'POIFolder' | 'POIType' | 'POIs' | 'PageBranchesFolder' | 'PageContent' | 'PageContentFolder' | 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' | 'PageDesign' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M = { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' | 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' | 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' | 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' | 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' | 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' | 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' | 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' | 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' | 'PageDesign_1105b8f81e00426bbf1fc840742d827b' | 'PageDesigns' | 'PageDesigns_3af52e70e982424b9c85e355542500c9' | 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' | 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' | 'PageDesigns_99a71bba507746729c3fb29b04abee23' | 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' | 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' | 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' | 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' | 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY = { __typename?: 'PageLevelTabs' | 'PageLevelTabsFolder' | 'PageList' | 'PageSelector' | 'PageSelectorConfiguration' | 'PageSelectorFolder' | 'PageSelector_59a7bb775f8c435ab810291abde80e63' | 'PageSize' | 'PageSizeFolder' | 'PageSize_b682562e0af64b3e9e3b45273bbe152d' | 'PageTheme' | 'PageThemesFolder' | 'Page_4f49a81db3664f198b89cab92f377d7a' | 'Page_5e66d86353544fe6a27d3b894984d50f' | 'Page_84f342ad2d0646b9aa9a818201145ca2' | 'Page_718df200be51463d93edf4d77ab7a49e' | 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' | 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' | 'Page_dae7821153e14dbabb0ddf0b53a90aaf' | 'Page_fa608b3e6aeb426388a059d89caabada' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc = { __typename?: 'Pagging' | 'Pagination' | 'PaginationFolder' | 'Paragraph' | 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' | 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' | 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' | 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' | 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' | 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' | 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' | 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' | 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' | 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' | 'PartialDesigns' | 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' | 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' | 'PartialDesigns_36c869ded22040929ce829f6ed643c66' | 'PartialDesigns_1943dc73710a430895515a342c84b037' | 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es = { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' | 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' | 'PartialDesigns_d216303f58d8425688da8cd30d00afab' | 'PartialDesigns_facda26791204fa9a0363344348f2c42' | 'PerformanceChartSettings' | 'PerformanceChartTimePeriod' | 'PerformanceChartTimePeriodFolder' | 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' | 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' | 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' | 'Placeholder_1ca0304be5b64810821154426f1752c2' | 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' | 'PlainHtmlParametersTemplate' | 'Playlist' | 'PlaylistFolder' | 'PlaylistParametersTemplate' | 'Podcast' | 'PodcastFolder' | 'PodcastPage' | 'PodcastPressReleasePage' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM = { __typename?: 'PoiTypes' | 'PostDeleteStep' | 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' | 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' | 'PostDeleteStep_b20857895385413883f096f3767cb156' | 'PostSetupStep' | 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' | 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' | 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' | 'PreDeleteStep' | 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' | 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' | 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' | 'PreDeleteValidationStep' | 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' | 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' | 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' | 'Presentation' | 'Presentation_0a70fa7389234a6eabf34134f25f3221' | 'PressReleaseContentType' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk = { __typename?: 'PressReleaseContentTypesFolder' | 'PressReleaseFilter' | 'PressReleasePage' | 'PressReleasePlatform' | 'PressReleasePlatformsFolder' | 'PressReleaseSearchPage' | 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' | 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' | 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' | 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' | 'PressReleaseWildcardPage' | 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' | 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' | 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' | 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' | 'PressReleasesGroupFolder' | 'PrivacyWarning' | 'ProjectFolder' | 'Promo' | 'PromoFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU = { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' | 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' | 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' | 'Promo_dfed4457d760457abec1c0dccdc44381' | 'PromotedContent' | 'PromotedContentFolder' | 'PropertyListingCard' | 'PropertyListingCards' | 'PropertyListingCategory' | 'PropertyListingFolder' | 'Query_98b413525a4b4067b92418a4b50f0a53' | 'QuickLinks' | 'QuickLinksFolder' | 'QuickLinksParametersTemplate' | 'QuotationBlockItem' | 'QuotationBlocks' | 'QuotationBlocksFolder' | 'QuotationBlocksParametersTemplate' | 'Quote' | 'QuoteFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 = { __typename?: 'QuoteParametersTemplate' | 'RadiusFilter' | 'RadiusFilterFolder' | 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' | 'RadiusScheme' | 'RadiusSchemeValue' | 'RangeSliderFilter' | 'RangeSliderFilterFolder' | 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' | 'RecentArticles' | 'Redirect' | 'RedirectMap' | 'RedirectMaps' | 'Region' | 'RegionLanguages' | 'RegionLanguagesFolder' | 'RelatedArticles' | 'RelatedArticlesParametersTemplate' | 'RenderEngineType' | 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg = { __typename?: 'RenderingHost' | 'ResizableIFramePage' | 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' | 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' | 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' | 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' | 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' | 'ResponsiveImage' | 'ResultsCount' | 'ResultsCountFolder' | 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' | 'ResultsVariantSelector' | 'RichText' | 'RichTextFolder' | 'RichText_0f3b73366112418c8bbab0526f3887ce' | 'RichText_efcfd8f6596745f48f85b5421928205d' | 'RiskImageMapping' | 'RiskImageMappings' | 'RiskLevelOption' | 'RiskLevelOptionFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc = { __typename?: 'RiskWarning' | 'RiskWarningFolder' | 'RiskWarningParametersTemplate' | 'RolePlaceholder' | 'RowSplitter' | 'RowSplitter_340c887da1d1415b9678c763af74ea97' | 'Rule' | 'SDRLogoMapping' | 'SDRLogoMappings' | 'SDRTypeOption' | 'SDRTypeOptionFolder' | 'SXAJSSLayout' | 'SXARole' | 'SXAStandardValuesFolder' | 'SalesforceAlertMessage' | 'SalesforceCheckBox' | 'SalesforceCheckBoxType' | 'SalesforceConditionalRadioButton' | 'SalesforceConditionalRadioButtons' | 'SalesforceDateInput' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM = { __typename?: 'SalesforceDropdown' | 'SalesforceDropdownOption' | 'SalesforceHiddenField' | 'SalesforceInput' | 'SalesforceInputType' | 'SalesforceIntegratedForm' | 'SalesforceIntegratedFormTypesFolder' | 'SalesforceRepeatableSubSection' | 'SalesforceRichTextArea' | 'SalesforceSection' | 'SalesforceSortCodeInput' | 'SalesforceSubmissionType' | 'Scope' | 'ScopesFolder' | 'Scriban' | 'Scripts' | 'SearchBox' | 'SearchBoxFolder' | 'SearchBox_1c04fd611d874590acfe9cc186865ab3' | 'SearchFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo = { __typename?: 'SearchResults' | 'SearchResultsFolder' | 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' | 'SecondaryHeroBannerParametersTemplate' | 'SectionHeading' | 'SectionHeadingFolder' | 'SectionHeadingParametersTemplate' | 'SectionHeadingType' | 'SectionHeadingTypeFolder' | 'SectionSelector' | 'SectionSelectorFolder' | 'SectionSelectorTab' | 'Security_33077d51ebad4d1cb4a83b79f51dba13' | 'Series' | 'SeriesFolder' | 'Settings' | 'SettingsFolder' | 'Settings_6c82caca67dc464195698faad083230e' | 'SharePriceSettings' | 'SharedArticlesFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs = { __typename?: 'SharedContentFolder' | 'SharedFolder' | 'SharedHelpArticlesFolder' | 'SharedPressReleasesFolder' | 'SharedSettingsFolder' | 'SharedSitesSettings' | 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' | 'Showcase' | 'ShowcaseFolder' | 'ShowcaseItem' | 'ShowcaseParametersTemplate' | 'Site' | 'SiteContentFolder' | 'SiteDefinition' | 'SiteEntryDisclaimer' | 'SiteFolder' | 'SiteGrouping' | 'SiteManagement' | 'SiteSecurityItemPointer' | 'SiteSelector' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo = { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' | 'SiteSetupRoot' | 'SiteTheme' | 'Site_e46f3af239fa4866a1577017c4b2a40c' | 'SitecoreFormWrapperParametersTemplate' | 'SitecoreRole' | 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' | 'SkipLink' | 'SkipLinkParameters' | 'SkipLinksFolder' | 'Snippet' | 'SnippetItem' | 'SnippetsFolder' | 'SocialLoginWrapper' | 'SocialMediaButtons' | 'SocialMediaFolder' | 'SocialMediaShare' | 'SocialMediaTemplate' | 'SocialNetwork' | 'SocialNetworkFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU = { __typename?: 'SocialNetworkLink' | 'SolutionTemplate' | 'SortResults' | 'SortResultsFolder' | 'Sorting' | 'SortingGroups' | 'SpotifyPodcast' | 'SpotifyPodcastFolder' | 'StickyCTA' | 'StickyCTAFolder' | 'StickyCTAParametersTemplate' | 'StrategiesInFocusFolder' | 'StrategyInFocus' | 'Style' | 'Styles' | 'Styles_9c0dac2808aa4b44bc2153363206f6a5' | 'SubscriptionBannerParametersTemplate' | 'Tab' | 'TabItem' | 'TableOfContents' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 = { __typename?: 'TableOfContentsFolder' | 'TableOfContentsSection' | 'TableOfContentsSubsection' | 'Tabs' | 'TabsFolder' | 'Tabs_f26a9560ccf148c59542800e837caf7a' | 'Tag' | 'TagCloud' | 'TagFolder' | 'TagList' | 'TeamBiographySettings' | 'TeamListingCards' | 'TeamListingCardsFolder' | 'TeamMember' | 'TeamMemberCard' | 'TeamMembers' | 'TeamMembersParentPage' | 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' | 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' | 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk = { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' | 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' | 'TeamMembersWildcardPage' | 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' | 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' | 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' | 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' | 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' | 'TeamProfileCards' | 'TeamProfileCardsFolder' | 'TechzoneArticlePage' | 'Tenant' | 'TenantFolder' | 'TenantSecurityItemPointer' | 'TenantSetupRoot' | 'TertieryHeroBanner' | 'TertieryHeroBannerParametersTemplate' | 'Text' | 'TextBlock' | 'TextBlockHeadingParametersTemplate' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 = { __typename?: 'TextBlockHeadingType' | 'TextBlockHeadingTypeFolder' | 'TextBlockLinkType' | 'TextBlockLinkTypeFolder' | 'TextBlocks' | 'TextBlocksFolder' | 'TextBlocksParametersTemplate' | 'TextFolder' | 'TextFolder_b762d56787f5493cbb480c455d834457' | 'Text_b8f5894cb4934016bf784090b0a2fd16' | 'Theme' | 'ThemeTag' | 'ThemeTagsFolder' | 'ThemingMode' | 'ThemingModes' | 'Tile' | 'TileLink' | 'TileParametersTemplate' | 'TileSizeOption' | 'TileSizeOptionFolder' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 = { __typename?: 'TilesFolder' | 'TilesParametersTemplate' | 'Title' | 'Title_a82e893105754175917de904ef7e6dbe' | 'Toggle' | 'ToggleFolder' | 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' | 'Transformation' | 'TrustArticleHeroParametersTemplate' | 'TrustFinder' | 'TrustFinderFilterOption' | 'TrustRegion' | 'TrustType' | 'TrustTypesFolder' | 'Twitter' | 'TwitterApp' | 'TwitterApps' | 'TwitterFolder' | 'TwitterParametersTemplate' | 'TwitterSettings' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w = { __typename?: 'UnknownItem' | 'UnminifiedFile' | 'UpgradeScript' | 'UpgradeScriptLibrary' | 'VariantComponentField' | 'VariantDateField' | 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' | 'VariantPlaceholder' | 'VariantReference' | 'VariantSection' | 'VariantTemplate' | 'VariantText' | 'VariantToken' | 'Variants' | 'VectorFolder' | 'VectorTile' | 'VectorTileLink' | 'VectorTilesFolder' | 'VectorTilesParametersTemplate' | 'Version_95ebc23204774dc38ad3465d5fe8da2f' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU = { __typename?: 'Video' | 'VideoCountOption' | 'VideoCountOptions' | 'VideoFolder' | 'VideoFolder_bba49474673e468186ba8b1a20e067a9' | 'VideoPage' | 'VideoParameters' | 'VideoParametersTemplate' | 'VideoPressReleasePage' | 'Video_4bc649610a894242be2dc5026090cf49' | '_AssetsOptimization' | '_BackgroundImage' | '_CompatibleThemes' | '_CompositeTheme' | '_CustomMetadata' | '_CustomRenderingViewPath' | '_DatasourceBehaviour' | '_Favicon' | '_FormsFolderLocation' | '_FundSettings' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 = { __typename?: '_HasValidUrlName' | '_LocalDataLink' | '_Login' | '_OpenGraphMetadata' | '_PageDesignTheme' | '_PageSearchScope' | '_SearchCriteria' | '_SearchableWithoutRelatedItems' | '_SeoMetadata' | '_SiteTheme' | '_SitemapSettings' | '_StickyNote' | '_Styleable' | '_TwitterMetadata' | '_Webinar' | '_WildcardSource' };

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & { name_1e4c2734dc754d528af8084e6c400e1f: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory_name_1e4c2734dc754d528af8084e6c400e1f_TextField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem = ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_DYs1ksGYYCrvxaXhjPM6OUwdCvGvprMvFTBqgM5oM | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c9XozYxqaFC0frAPHPeq433LPynBF0XM1g0Uz5LICn8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9VPlmQkQdt9l4maQ46Z5fMhr5w16NSqTADFDI2lIY9Q | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5Bp8CGD6gBt5zmgrKJRqS8sSurv5NB60wKLFzTr1j8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_vgM8szlOwwreWnyZ96extC1BJblr1vJelIcjuF6Tw | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_shlDQDRBXfEV2IMt8Q7OnzROWrVF0nQMSI8rkrSZU | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_0SYpviiyXX3BRforwncXG3pexVXYcIm4fmQoeSPcK4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_JuL8MVaWzToSlJIakCO1bigqoAcm1EGyklGo3wRrRLw | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_aqw7j7oAQM5GJ9oIWaOAyiGli5atrgfmQJoQe8rDt4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jWiNNE8wAezwjVLEWn3IRc7x4WY9EKiEuZpBROPG4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BfCZy14f5vCYoKPvUvlJVRkotuL1gmUwjkgrggQ05A | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_PHLgvBFZABTRngNRTYYUi9KBdwe9p7W4YDlCj72fOIs | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_KL7bf4QPLQ7mpyzzvQk5f6piwJk1PES0rcP7Uy9x0M | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_iqnu4DMOAGlC9sVDpDbjHWwyB7ysXrKwlOhFHAyC0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_umgzCXtgi1WMowaNMDJnNsdrdDP4Ie7qfWy2owTqtI | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_c8gc72G7Xyo5xvM63VPyvhGmiUxe0BFuVTVAj9su0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VtfJ6wYpLDTemXJEIB7XJw2duFCBCMgGB8vlYx6hsc0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_1BpmAGsjLrkU4cexVLSJ4OyM81tByZRfH3Rlj3t6CE | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NyEECiwuus0IEb5R3ZHyvXsBaUAVp6zWfQGtLdoaAU | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Fj4L99iVJxbVnFn7srvABth7WlFSHNzZENorwzE | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ANdBVC6KFTlUcJhSibUfyWTFtLta5lsMUp9qlxcVurI | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_xbvRLMKOfZhwK7StDx4pk8GufekPnO6TlKVuKDWc0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_C7jD2H7yOuHKbYSq1WvlnNO2zZ9k33Tt60j7wVs4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_6hn5PudNLAFVxgpoCeIRzlxkBlB8a1pSQwG8cmE | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_u7BRZVBhheosXLCSBWQJBOivuyXVuOOaFBBIAa5UQdc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dpqtGMeZVSGVIy9q5ldacew1cWo2gELfnm77xVZDIg | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_lalHkBPxpftIF8HuYXqfDXnzifCeKVwttYezsBbL6A | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_Q9MXc9RjR2M267DgK6zxTNUiUi6NIPijp0dZLLIgk | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_dMUje5zuPQ5cTfsHsP483FXiZjLZOp5y7mQEffnH1xw | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_hb7aIiGiWMscK3W1w04Vy90EkNWrFzDyfbrTjKcNK2s | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mlJlKCHse9oAGb81rXrwxNMBDoalRluBpSZ2wf1jcU | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bpyH1qQmSBBKUyiskmVf3nBxPfFJ3ja7QnVcUd6KZro | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_TFM8XAFL3R0W5BBj4PhNwCAwPErC6NwFNoclkK5Ozfg | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_bMHrVLsz7zTHT5CwjCPyMlvDh8syp5BNhgLmOFWY | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_uHyHdgbeup55x4fJn0iMgtziabR3eN1yEsBEkbjb5Q | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_T3o1wLwUnreOMfGErcoS5389oEEJtqeZlHP8vd3gA | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BiFBNsNFG239ill5wF74Fp0WARoTWU8lZUEROfPJZvM | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_G1e6Uvc81Pa7r6RKtchIZa50YYxIpwUNf0ONxBs4Bl0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_WDgsk5S4YhtQoVJsDxcSUkTfZcwxXcb1NO0cFSqYNGs | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_IWJynIRPteI7yBdYHGdbMI4cyxoxfNlbtSN7B20y4M | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_D3YGmHHw8WNoPLjhaKccTYlBxHImWKx0FJmY7FY | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_5d6qs4EGU5QLch38FcFTz9usooPsSE3WceHdwYputc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_B9w2udyDmdxORyQ5clNDVxDKQqarcHNAPO2AP3es | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_AdqeB4aKdR2MyUECPtovrc95H3CJ6Ig98U7CdiLGaIM | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_drzV1CJMhZ88IeARb30GphbrzYOHnyNZjm3CgUbIWk | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ENQdzvbQNrNiryOm2NPQhFnmc18Yh4Fp0f0gQFYmFlU | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_QZDJyPms3T6lDHYCbvQFF0sD1nHC1HRs1Ix54YZ6i8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_mWrj2tqhhIY9lLuI74Ks4zGGWP7srZO3klxwJMlgsg | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ymNqvHCuEcVRQEfysJpY2kBJE9KwGVyjeu958mFrrlc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_4gcPHSCwc2XVOWBJzhReq136cuwdsEF53c96SP5CiZM | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_RcDqArSfGfaeZn2uKE95hARLsahajiVremCkGWPo | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_VFjXTBzpd79LHDBOD35cNMZmSFq180m1mHusZcXs | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_MkuFXTU9755HLQp8UalGqsyAeKcQHfKk57YtkZFDXo | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ikuxXHO2arpTpiusmpYBomyF1zAxK7cnXIVR5AyNU | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_NMn3JVcthxkgiQKXEWsmBod9iH6Hnr1ycy3Ortftdx0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_kYbw3Mn6uGrgzxBEykA9MbbLXnIvoKhO2ctQ2PcwVk | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_eW0uqh0FJREFmMD7whlQHSyAhOj6irJCqObW4aiI4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_sMoHaQ0vl3goS076Rk1HRy3vPbwvd1ZUPxUpMfGI060 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_jHUccxnc96VFbPApwlbfl6lTh5VJX08wTcEabw81G1w | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_9IBNDu4RucbrcxK05T6CyGrZY6xBu9u2f1A7W17QDU | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_BPtRTuHp8rlvvWHijPSgBpGrAuzCnDphRfUgAxwLC8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem_ArticleCategory;

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField = (
  { __typename?: 'LookupField' }
  & { targetItem: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField_targetItem> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField = (
  { __typename?: 'TextField' }
  & Pick<Types.TextField, 'value'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField = (
  { __typename?: 'DateField' }
  & Pick<Types.DateField, 'value' | 'formattedDateValue'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField = (
  { __typename?: 'ImageField' }
  & Pick<Types.ImageField, 'src' | 'alt'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField = (
  { __typename?: 'IntegerField' }
  & Pick<Types.IntegerField, 'value'>
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionFolder = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionItem = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionParametersTemplate = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionPresentation = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionPresentationFolder = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddThisParameters = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AggregatedFacetFilter = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessage = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessageFolder = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessageType = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AllertMessageTypeFolder = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Archive = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleAuthor = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleAuthorsFolder = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleCategoriesFolder = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleCategory = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleChapter = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleChapters = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleContentType = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleContentTypesFolder = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFilter = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFilterOption = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFootnote = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFootnoteLink = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFootnoteText = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleInfogramTile = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleRegion = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleRegionsFolder = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSeriesCollection = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSeriesFolder = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSettings = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTag = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTagsFolder = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTeamAuthor = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlesGroupFolder = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AttachThemeExtension = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AutomaticDocumentListings = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableJSONRenderings = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableMetaRenderings = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableRenderings = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBanner = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBannerFolder = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBannerImage = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BackgroundColorOption = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BannerFolder = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BannerType = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BannerTypeFolder = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BaseHeading = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BaseHeadingFolder = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BoolFacet = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BranchesFolder = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Breadcrumb = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_BrowserTitleDefinition = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CORSEntry = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CORSGrouping = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CTAPresentationType = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__AbrdnPage = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ActionBase = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__AdvancedParameter = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__App = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ArticleWildcardPage = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseCTA = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseRenderingParameters = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseTheme = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseVariantField = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Class = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__CompositeGroup = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__CompositeSection = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__EloquaForm = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ExtendedOptions = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GridDefinition = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GridItemBase = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GridParameters = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HeadlessSite = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HeadlessTenant = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IAllowEmpty = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IBoosting = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ICacheable = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ICompatibleRenderings = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IComponentVariant = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IControlType = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IIcon = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ILocation = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IPaginable = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IPagination = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IPoi = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IRenderingId = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ISplitter = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IStyling = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IVariantDefinition = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__InvestmentTrustPage = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSONField = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSONReference = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSSData = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSSSettings = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSSSiteFolder = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JssRootFolder = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Page = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageData = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageDesignFolder = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesign = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesignFolder = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PlaceholderWrapper = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__RedirectMapGrouping = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Route = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__SimpleVideo = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__SiteSettingsFolder = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__SitemapSettings = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__StandardTemplate = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__TrustFolder = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__VariantDefinition = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__VariantField = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__VariantsGrouping = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___AdvancedItem = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Arguments = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Article = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ArticleSearchPage = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ArticleWildcard = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseArticle = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseDataFolder = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseHelpArticle = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseJSSTenant = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePage = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePageDesign = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePageDesignFolder = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePartialDesign = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePlaceholder = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePresentation = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePressRelease = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseRenderingParameters = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSettings = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteDefinition = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteFolder = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteGrouping = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteRoot = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseTenant = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseTenantFolder = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BucketRules = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___CORS = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Content = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ContentType = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___DataAttributes = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___DatasourceWorkflow = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Dependencies = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Description = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___DesignTemplateMapping = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Designable = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___EditType = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___EditingTheme = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Enabled = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ErrorHandling = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ExternalArticle = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Fields = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FilteredArticlesParent = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Footnotes = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundDetailsWildcard = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundFormAvailability = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundMetadataPage = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundSearchPage = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsFolder = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsFormsFolder = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___GridMapping = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HelpArticle = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HelpArticleWildcard = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Icon = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___IncludeByDefault = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___IncludeIfInstalled = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___InternalArticle = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___IsSystemModule = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___JSONVariantPaging = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___JSONVariantsBase = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LimitedDisplay = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LinkAttributes = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LinkSettings = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ManualKeyInformation = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___MemberOf = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___MetadataPage = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Modules = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Navigable = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___NavigablePage = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PageContent = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PageWorkflow = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PerSiteStandardValues = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Podcast = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PodcastPressRelease = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PremiumContentPage = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressRelease = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressReleaseContentType = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressReleaseWildcard = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ProtectedTheme = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RenderingVariantsBase = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RenderingsList = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RobotsContent = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RoleDomain = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RoleName = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RoleType = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceFieldId = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceFieldValue = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Script = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SearchSignature = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Searchable = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SecurityItemPointer = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedArticles = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedContent = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedHelpArticles = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedPage = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedPressReleases = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedRoot = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedSettings = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteContent = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteFolder = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteMediaLibrary = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteSettings = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteTemplate = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Sitemap = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SitemapMediaItems = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SlidersRangeSettings = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SolutionTemplateContent = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SolutionTemplateName = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SortOrder = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___StackBreakpoint = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Statistics = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SupportedLanguages = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Taggable = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___TeamMembersParentPage = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___TeamMembersWildcard = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___TechzoneArticle = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Template = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Title = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Type = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Validation = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VariantPaging = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VectorTile = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VectorTileLink = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Video = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VideoPressRelease = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Width = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___WildcardPage = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CacheSetting = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CalendarEvent = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSection = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSectionFolder = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallToAction = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallToActionFolder = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CapabilitiesFolder = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Capability = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CapabilityMap = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CapabilityMappings = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Carousel = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CarouselFolder = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CarouselSlide = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Checkbox = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ChecklistFilter = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ChecklistFilterFolder = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ColumnSplitter = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CompatibilityMode = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentConfiguration = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentThemeConfiguration = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentThemesConfiguration = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentsConfigurations = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ConfigurationFolder = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Container = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContainerOption = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContainerOptionsFolder = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContainerParametersTemplate = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentBlock = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentBlockFolder = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentToken = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentTokenFolder = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentType = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CorporateTheme = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CorporateThemesFolder = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Country = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CountryISOCode = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CountryISOCodesFolder = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CustomerReviewFolder = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CustomerReviewTile = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeFund = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeFundRangeName = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeShareClass = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataFolder = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DatasourceConfiguration = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DatasourceConfigurations = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DatasourceWorkflowAction = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFacet = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFilter = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFilterFolder = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DefaultColumnLayout = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DefaultShareclassMapping = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DefaultShareclassMappings = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlight = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlightItem = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Device = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Devices = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DictionaryFolder = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DisqusParameters = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DistanceFacet = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Divider = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentItem = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentListings = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentListingsFolder = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentTypeFolder = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DominantLanguageMapping = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Dropdown = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DropdownFilter = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DropdownFilterFolder = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditEditingTheme = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditFrame = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditModePanel = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditSiteItem = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditSiteTheme = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditTenantTemplate = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditType = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EloquaFormFolder = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EloquaFundForm = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Enum = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Enums = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventCalendarParameters = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventList = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventListParameters = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventTypes = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventsFolder = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExtendSiteTheme = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExternalLiterature = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSlider = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSliderFolder = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSummary = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSummaryFolder = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetsGrouping = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FakeNavigationItem = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeatureBanner = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedArticles = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedArticlesFolder = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedTheme = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedThemesFolder = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Feed = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeedFolder = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeedParameters = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FieldEditor = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FieldRenderer = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FileList = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FileListFolder = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FileListParametersTemplate = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterCriteria = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterCriteriaFolder = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterTaxonomyOption = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterTaxonomyOptions = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Flip = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FlipFolder = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Flipside = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FloatFacet = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Footer = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FooterFolder = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FooterLink = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FormRenderingParameters = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundAssetClass = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundAssetClassesFolder = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundFormsFolder = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundInFocus = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundInFocusShareClass = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSettings = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSubAssetClass = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsFolder = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsInFocusFolder = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsLiteratureFolder = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Gallery = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryFolder = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryImage = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryParametersTemplate = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryVideo = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GatedAccordionContainer = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GlobalLanguageSelector = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GlobalNavigationBar = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GoogleAnalytics = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GoogleTagManager = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GoogleTagManagerFolder = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GridSetup = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_GridTheme = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLCode = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLCodeFolder = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLInclude = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLIncludesFolder = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLSnippet = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLSnippetFolder = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLTag = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Header = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeaderFolder = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Heading = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTrustSite = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessVariants = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePage = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatform = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatformMap = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleSearchPage = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleTag = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleTagsFolder = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleWildcardPage = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpTagMap = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpTagMappings = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeroBanner = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Highlight = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightBlock = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightBlockFolder = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightFolder = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightItem = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightParametersTemplate = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Home = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrame = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrameFolder = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrameParametersTemplate = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Icon = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IconFolder = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageFolder = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageParametersTemplate = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Infographics = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InfographicsFolder = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IntegerFacet = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IntroCopy = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_IntroCopyFolder = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustRegion = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustStyle = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestorType = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestorTypesFolder = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ItemQueriesFolder = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ItemRights = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSBeaconSettings = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONCheckbox = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONContent = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONDate = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONFile = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONImage = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONLayout = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONList = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONMultilistReference = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONPlaceholder = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONQuery = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONResults = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONRichText = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONScriban = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONSection = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONTemplate = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONText = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONToken = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONVariantDefinition = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONVariants = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSLayout = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSiteGrouping = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSTenantFolder = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JavaScriptRendering = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JsonRendering = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JurisdictionStatus = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_JurisdictionsFolder = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlightItem = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlights = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlightsFolder = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Language = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LanguageSelector = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LanguagesFolder = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LayoutServiceVariants = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LimitedDisplayFolder = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LimitedDisplayOption = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkListFolder = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinksFolder = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_List = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListFacet = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListFolder = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListItem = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListParametersTemplate = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListStyle = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListStyleItem = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListingHeroBanner = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureAuthorization = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LoadMore = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LoadMoreFolder = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LocationFilter = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LocationFilterFolder = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Log = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Login = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LogoTextBlockItem = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LogoTextBlocks = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_LogoTextBlocksFolder = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Logout = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeFilter = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeItem = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Map = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MapParameters = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MapsFolder = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MapsProvider = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaBlock = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaBlockFolder = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaLinkParameters = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaVirtualFolder = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MegaNavigation = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MegaNavigationFolder = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MetaBranding = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MetaRenderingParameters = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MetadataPartialDesign = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Model = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ModelIterator = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_MyLocationPOI = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Navigation = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationCategory = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationFilter = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationFilterFolder = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationLink = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationSubcategory = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OneTrustSettings = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OptimiserConfiguration = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OptimiserConfigurationSection = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OptimizedFile = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OracleCDPSettings = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OverlayContent = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OverlayFolderTemplate = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Ownership = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_OwnershipFolder = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_POI = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_POIFolder = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_POIType = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_POIs = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageBranchesFolder = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageContent = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageContentFolder = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesign = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageLevelTabs = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageLevelTabsFolder = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageList = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelector = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelectorConfiguration = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelectorFolder = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSize = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSizeFolder = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageTheme = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageThemesFolder = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Pagging = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Pagination = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PaginationFolder = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Paragraph = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PerformanceChartSettings = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Playlist = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaylistFolder = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaylistParametersTemplate = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Podcast = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PodcastFolder = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PodcastPage = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PodcastPressReleasePage = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PoiTypes = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Presentation = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseContentType = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseFilter = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasePage = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasePlatform = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasesGroupFolder = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PrivacyWarning = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ProjectFolder = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromoFolder = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromotedContent = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromotedContentFolder = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingCard = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingCards = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingCategory = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingFolder = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuickLinks = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuickLinksFolder = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlockItem = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlocks = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlocksFolder = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Quote = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuoteFolder = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuoteParametersTemplate = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusFilter = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusFilterFolder = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusScheme = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusSchemeValue = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RangeSliderFilter = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RangeSliderFilterFolder = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RecentArticles = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Redirect = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RedirectMap = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RedirectMaps = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Region = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RegionLanguages = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RegionLanguagesFolder = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RelatedArticles = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RenderEngineType = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RenderingHost = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResponsiveImage = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsCount = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsCountFolder = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsVariantSelector = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichText = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichTextFolder = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskImageMapping = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskImageMappings = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskLevelOption = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskLevelOptionFolder = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskWarning = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskWarningFolder = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RolePlaceholder = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RowSplitter = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Rule = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRLogoMapping = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRLogoMappings = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRTypeOption = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRTypeOptionFolder = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SXAJSSLayout = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SXARole = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SXAStandardValuesFolder = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceAlertMessage = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceCheckBox = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceCheckBoxType = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceDateInput = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceDropdown = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceDropdownOption = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceHiddenField = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceInput = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceInputType = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceIntegratedForm = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceRichTextArea = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceSection = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceSortCodeInput = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceSubmissionType = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Scope = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ScopesFolder = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Scriban = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Scripts = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchBox = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchBoxFolder = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchFolder = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchResults = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchResultsFolder = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeading = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingFolder = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingType = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionSelector = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionSelectorFolder = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionSelectorTab = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Series = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SeriesFolder = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Settings = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SettingsFolder = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharePriceSettings = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedArticlesFolder = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedContentFolder = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedFolder = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedPressReleasesFolder = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedSettingsFolder = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedSitesSettings = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Showcase = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ShowcaseFolder = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ShowcaseItem = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Site = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteContentFolder = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteDefinition = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteEntryDisclaimer = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteFolder = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteGrouping = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteManagement = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSecurityItemPointer = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSelector = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSetupRoot = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteTheme = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SitecoreRole = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SkipLink = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SkipLinkParameters = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SkipLinksFolder = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Snippet = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SnippetItem = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SnippetsFolder = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialLoginWrapper = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaButtons = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaFolder = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaShare = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaTemplate = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialNetwork = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialNetworkFolder = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialNetworkLink = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SolutionTemplate = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SortResults = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SortResultsFolder = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Sorting = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SortingGroups = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SpotifyPodcast = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SpotifyPodcastFolder = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_StickyCTA = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_StickyCTAFolder = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_StrategiesInFocusFolder = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_StrategyInFocus = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Style = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Styles = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tab = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TabItem = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContents = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContentsFolder = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContentsSection = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContentsSubsection = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tabs = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TabsFolder = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tag = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TagCloud = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TagFolder = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TagList = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamBiographySettings = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamListingCards = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamListingCardsFolder = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMember = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMemberCard = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembers = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamProfileCards = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamProfileCardsFolder = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TechzoneArticlePage = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tenant = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TenantFolder = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TenantSecurityItemPointer = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TenantSetupRoot = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TertieryHeroBanner = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Text = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlock = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockHeadingType = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockLinkType = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlocks = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlocksFolder = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextFolder = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Theme = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemeTag = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemeTagsFolder = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemingMode = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemingModes = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tile = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileLink = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileParametersTemplate = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileSizeOption = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileSizeOptionFolder = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TilesFolder = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TilesParametersTemplate = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Title = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Toggle = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_ToggleFolder = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Transformation = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustFinder = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustFinderFilterOption = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustRegion = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustType = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustTypesFolder = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Twitter = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterApp = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterApps = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterFolder = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterParametersTemplate = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterSettings = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_UnknownItem = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_UnminifiedFile = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_UpgradeScript = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_UpgradeScriptLibrary = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantComponentField = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantDateField = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantPlaceholder = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantReference = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantSection = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantTemplate = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantText = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantToken = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Variants = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorFolder = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTile = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTileLink = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTilesFolder = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Video = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoCountOption = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoCountOptions = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoFolder = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoPage = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField>, duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoParameters = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoParametersTemplate = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoPressReleasePage = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__AssetsOptimization = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__BackgroundImage = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__CompatibleThemes = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__CompositeTheme = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__CustomMetadata = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__CustomRenderingViewPath = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__DatasourceBehaviour = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__Favicon = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__FormsFolderLocation = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__FundSettings = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__HasValidUrlName = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__LocalDataLink = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__Login = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__OpenGraphMetadata = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__PageDesignTheme = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__PageSearchScope = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__SearchCriteria = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__SeoMetadata = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__SiteTheme = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__SitemapSettings = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__StickyNote = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__Styleable = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__TwitterMetadata = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__Webinar = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate, articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results__WildcardSource = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type ArticleSearchSeriesQuery_search_ItemSearchResults_results = ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionItem_8cf671721b2d489e809f4c23db5ab2da | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionPresentation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AccordionPresentationFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_02d060598cc14423a9ac9ff2365176b7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_1e1b739ec3784909941d171aca7362e5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_3aea335cd06d45b1841acbc8d2d1ce40 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_de8c75222f3241288f20342f479894eb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddItem_ea8a3f269ccd443a95f571b868a94bd0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AddThisParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AggregatedFacetFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessageFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessageParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AlertMessageType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AllertMessageTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Archive | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleAuthor | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleAuthorsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleCategoriesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleCategory | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleChapter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleChapters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleContentType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleContentTypesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFilterOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFootnote | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFootnoteLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleFootnoteText | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleInfogramTile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleInfogramTileParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleRegion | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleRegionsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_be414ff574ac4203abb2694811443e25 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSeriesCollection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSeriesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSubscriptionBanner | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleSubscriptionBannerFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTag | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTagsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTeamAuthor | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTileParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleTilesParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_405b20252077400383d3b47f09f88b47 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlesGroupFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AttachThemeExtension | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AutomaticDocumentListings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AutomaticDocumentListingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableJSONRenderings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableMetaRenderings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableRenderings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBanner | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBannerFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBannerImage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_AwardsBannerParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BYOCWrapperRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BackgroundColorOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BackgroundColorOptionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BannerFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BannerType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BannerTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BaseHeading | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BaseHeadingFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BoolFacet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BranchesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Breadcrumb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_BrowserTitleDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CORSEntry | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CORSGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CTAPresentationType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CTAPresentationTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__AbrdnPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ActionBase | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__AdvancedParameter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__App | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ArticleWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__AvailableRenderingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BYOCRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BackgroundParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseCTA | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_037da552a5524fe4aeee331f57ac1378 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_315fd21bebf04c9d9f00bae191442f1d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_728c97b5c56146d9807e21018a972bb5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_6105875085f346729dfc8d133b481f26 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__BaseVariantField | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Class | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__CompositeGroup | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__CompositeSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__EloquaForm | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ExtendedOptions | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ExtendedOptions_2964fb4257a6440fb192218443904c90 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FEaaSRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FacetSelectorConfigBase | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GlobalDatasourceBehavior | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GridDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GridItemBase | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__GridParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HeadlessSite | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HeadlessTenant | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IAllowEmpty | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IBaseVariantDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IBoosting | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ICacheable | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ICompatibleRenderings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IComponentVariant | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IControlType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IDynamicPlaceholder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IFEaaSComponentsDataSourceTemplates | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IFEaaSComponentsEditorScriptURL | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IIcon | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ILocation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IPaginable | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IPagination | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IPoi | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IRenderingId | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ISplitter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IStyling | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__IVariantDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__InvestmentTrustPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSONField | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSONReference | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSSData | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSSSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JSSSiteFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__JssRootFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Navigation_e6d98f24d01c419e871a4617125a49ed | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Page | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageData | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageDesignFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PageDesigns_daaf41fd96db4892be99f62f16d036c4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesign | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesignFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PlaceholderWrapper | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__RedirectMapGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__Route | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__SimpleVideo | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__SiteSettingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__SitemapSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__StandardTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__TrustFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__VariantDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__VariantField | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C__VariantsGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___AdvancedItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Arguments | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Arguments_33fab87cd52f44319a1f589ba7c1e287 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Article | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ArticlePageWorkflow | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ArticleSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ArticleWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___AssetServiceThemeMode | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseArticle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseDataFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseHelpArticle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseInvestmentTrust | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseJSSTenant | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePageDesign | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePageDesignFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePartialDesign | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePartialDesignFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePlaceholder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePlaceholderSettingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePresentation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BasePressRelease | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSXAStandardValuesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSharedSitesSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseSiteRoot | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseTenant | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BaseTenantFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___BucketRules | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___CORS | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Content | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ContentType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___DataAttributes | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___DatasourceWorkflow | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Dependencies | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Description | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___DesignTemplateMapping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Designable | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___EditType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___EditType_8a9f84baaa124c5d9096935714809da4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___EditingTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Enabled | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ErrorHandling | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ExternalArticle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Fields | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FilteredArticlesParent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FilteredArticlesWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Footnotes | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundDetailsWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundFormAvailability | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundMetadataPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsFormsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsLiteratureFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___FundsShareclassesDetailsWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___GridMapping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HelpArticle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HelpArticleSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HelpArticleWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___HorizonDatasourceGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Icon | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___IncludeByDefault | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___IncludeIfInstalled | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___InternalArticle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___InternetExplorerCompatibilityMode | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___IsSystemModule | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___JSONVariantPaging | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___JSONVariantsBase | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LimitedDisplay | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LinkAttributes | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LinkSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___LiteratureHubSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ManualKeyInformation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___MemberOf | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___MetadataPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Modules | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name_299cdb154745448a807868d401248eaa | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Name_b88cf88159a54a19991e71038751cb60 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Navigable | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___NavigablePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PageContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PageWorkflow | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PerSiteStandardValues | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Podcast | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PodcastPressRelease | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PremiumContentPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressRelease | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressReleaseContentType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressReleaseSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PressReleaseWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___ProtectedTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___PublishingGroupingTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RenderingRelatedParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RenderingVariantsBase | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RenderingsList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RobotsContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RoleDomain | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RoleName | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___RoleType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceCommonValidations | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceFieldId | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceFieldTitle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SalesforceFieldValue | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Script | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SearchSignature | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Searchable | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SecurityItemPointer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedArticles | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedHelpArticles | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedPressReleases | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedRoot | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SharedSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteMediaLibrary | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SiteTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SitecoreClientSiteManaging | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Sitemap | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SitemapMediaItems | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SlidersRangeSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SolutionTemplateContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SolutionTemplateDescription | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SolutionTemplateName | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SortOrder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___StackBreakpoint | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Statistics | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___SupportedLanguages | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Taggable | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___TeamMembersParentPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___TeamMembersWildcard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___TechzoneArticle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Template | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Title | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Type | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Validation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VariantPaging | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VectorTile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VectorTileLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Video | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___VideoPressRelease | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Width | ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___WildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CacheSetting | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Caching_26fce9bf0256458d8281a713a5bf5520 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CalendarEvent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSectionDropdownOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSectionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallOutSectionParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallToAction | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CallToActionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CapabilitiesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Capability | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CapabilityMap | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CapabilityMappings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Carousel | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CarouselFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CarouselSlide | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Carousel_2b65f0d87ec54834b4aa1753c0f7036b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Checkbox | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ChecklistFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ChecklistFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ColumnSplitter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CompatibilityMode | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentConfiguration | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentThemeConfiguration | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentThemesConfiguration | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ComponentsConfigurations | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ConfigurationFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Container | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContainerOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContainerOptionsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContainerParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Container_45130bdbbae34edcaea87b68b9d94c7f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentBlock | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentBlockFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentToken | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentTokenFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ContentType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CorporateTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CorporateThemesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Country | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CountryISOCode | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CountryISOCodesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CustomerReviewFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CustomerReviewTile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_CustomerReviewTileParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeDocumentCategoryMap | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeFund | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeFundRangeName | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeSettingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataBridgeShareClass | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DataFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DatasourceConfiguration | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DatasourceConfigurations | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DatasourceWorkflowAction | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFacet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DateFilter_ad89c1f1e99148ef865938ab13aa28f1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DefaultColumnLayout | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DefaultShareclassMapping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DefaultShareclassMappings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlight | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlightFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlightItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DescriptiveHighlightParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Device | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Device_7c27ec70f42e40428a0fabaa2f8eda18 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Devices | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DictionaryFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DisqusParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DistanceFacet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Divider | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentListings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentListingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DocumentTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DominantLanguageMapping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Dropdown | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DropdownFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DropdownFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditEditingTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditFrame | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditModePanel | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditSiteItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditSiteItem_f040db0387fe4e10ae4053c63175e31b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditSiteTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditTenantTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EditType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EloquaFormFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EloquaFundForm | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Enum | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Enums | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_4dbccce416d1491f94198496e3f77c6d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_45d797cc048740ffb693214883ff35c2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ErrorPage_a7dfa49761224679bf9949fffacd5fa1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventCalendarParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventListParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventTypes | ArticleSearchSeriesQuery_search_ItemSearchResults_results_EventsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_bc9bb68436df4285888bd8b4d87b10de | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExtendSiteTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ExternalLiterature | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FEaaSWrapperRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacebookCommentsParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSlider | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSliderFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSlider_995ce2c7319f478b84fe22053ac85bb7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSummary | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSummaryFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetSummary_cd5c935c1f604d899a6b88ce28305cf2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FacetsGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FakeNavigationItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeatureBanner | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeatureBannerParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedArticles | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedArticlesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeaturedThemesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Feed | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeedFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FeedParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FieldEditor | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FieldRenderer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FileList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FileListFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FileListParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_File_04129321770849c1801baee196e1c0a8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterCriteria | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterCriteriaFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterTaxonomyOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilterTaxonomyOptions | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Flip | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FlipFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Flip_5ef078504c044b839dafefd752cfaba8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Flipside | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FloatFacet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Footer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FooterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FooterLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FormRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundAssetClass | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundAssetClassesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundFormsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundInFocus | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundInFocusShareClass | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_5505b84dba1f47c7b8054749d802d926 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_5806f83c03bc443380678ff955f4310f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_7432205c04214a419ca064c4cb37501c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSubAssetClass | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundSubAssetClassesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsExternalLiteratureFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsInFocusFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsInFocusParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsLiteratureFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_FundsLiteratureMappingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Gallery | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryImage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GalleryVideo | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GatedAccordionContainer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GlobalLanguageSelector | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GlobalNavigationBar | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GoogleAnalytics | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GoogleTagManager | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GoogleTagManagerFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GridSetup | ArticleSearchSeriesQuery_search_ItemSearchResults_results_GridTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLCode | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLCodeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLInclude | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLIncludesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLSnippet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLSnippetFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HTMLTag | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Header | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeaderFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Heading | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSiteSetupRoot | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_68ffa40c5aab45548f774742b163f318 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_229484893ca144958b9937167dfb5064 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_b28055626acc45a2913a9617398c9730 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_f1cab1661abb450d84d55d938e7699cb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSite_f3884baa0e1548f59a6d7154a4559604 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessSolutionTemplateFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenantSetupRoot | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_07248c4700af499eb2a9cb7789f72372 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_5d72df6049c74324969205b55767ad7b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_77a403a2094e48afafa60943d349d23d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_94824ac390d748499e5af0275d10811f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_4797571864fd40929cf2412c39757ec3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessTrustSite | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessVariants | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeadlessVariantsGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatform | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatformMap | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatformMappings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlePlatformsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleTag | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleTagsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpArticlesGroupFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpTagMap | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HelpTagMappings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HeroBanner | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Highlight | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightBlock | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightBlockFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightBlockParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HighlightParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Home | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_0d3963a8171d4080b5f808618578b631 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_6d95c7d946c74a70be07304cc73a2010 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_b407f259b4e34c7db9a06e8907a56b17 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_cde13c51062d426b95569e8202edc963 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_HomePage_de9353283a3e41c495ba386aed0540c6 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrame | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrameFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrameParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrame_0da12d476de24dfeb4d0f513489bfea1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IFrame_88a6f65f2b78491bb3770b06e48883e1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Icon | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IconFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageFolder_edc00e86cef24d0cbfa264460becc323 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ImageParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image_83bc563c6320490092f8204bff81586a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image_15185b0e641844499f934ff03b7ee032 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Image_d885df8cb2d64007b34b2bbafb527304 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Infographics | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InfographicsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep_088928cf558e40ec87f3342aa9e66757 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InputValidationStep_d028fef2babf4ad1bbe74d62a977992f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IntegerFacet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IntroCopy | ArticleSearchSeriesQuery_search_ItemSearchResults_results_IntroCopyFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustAssetClass | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustAssetClassFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustRegion | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustRegionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustStyle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestmentTrustStyleFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestorType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_InvestorTypesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ItemQueriesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ItemRights | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSBeaconSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONCheckbox | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONDate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONFile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONImage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONLayout | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONMultilistReference | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONPlaceholder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONQuery | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONResults | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONRichText | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONScriban | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONText | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONToken | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONVariantDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSONVariants | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSLayout | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_6b328292f8314ab79885d89a054ca10a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_457c9d0b61b84adfaf7f82561ed275ff | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_5045bf85d2ea430b9f41c2e348436e5d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_b001fd725bb1476496825a8cb9e995cd | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_c643bc8630d14d61a173c7870f5dbbad | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSettings_ef855d0ba8b04a8e87851d1298266d90 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSSiteGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JSSTenantFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JavaScriptRendering | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JsonRendering | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JurisdictionStatus | ArticleSearchSeriesQuery_search_ItemSearchResults_results_JurisdictionsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlightItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlights | ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlightsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_KeyHighlightsParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Language | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LanguageSelector | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LanguagesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LatestPressReleasesParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LayoutServiceVariants | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LimitedDisplayFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LimitedDisplayOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkListFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkListFolder_c237d144647a4afeaa7b1570f3e3f139 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList_33c9207e3b0446068ef54ca99a97c776 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList_97a593ad273141dc80bfceb5ef6a33b7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinkList_f7561ffcc0d8477fb53d2703a4060be1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link_68bd1cb5a7624a969ac6cb16ab5882a3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link_930f134d56784b35bfd1b77f9d0115f1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Link_e24e0789a05848bfabb6c69c0e60b6b7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LinksFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_List | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListFacet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListStyle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListStyleItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListingHeroBanner | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ListingHeroParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureAuthorization | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureAuthorizationsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LoadMore | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LoadMoreFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LocationFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LocationFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LocationFilter_aaad4aad290744dc90b69e4e83a661ec | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Log | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Login | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Login_abed54dc4f7840ddac562289c9c849d8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LogoTextBlockItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LogoTextBlocks | ArticleSearchSeriesQuery_search_ItemSearchResults_results_LogoTextBlocksFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Logout | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Logout_c2294d8235a6452a94b15eb5e543b602 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ManagedRangeItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Map | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MapParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MapsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MapsProvider | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaBlock | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaBlockFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaBlockParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaFolder_81150e5837f5443fa3c075e14a9321e7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaLinkParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MediaVirtualFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MegaNavigation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MegaNavigationFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MetaBranding | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MetaRenderingParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MetadataPartialDesign | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Model | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ModelIterator | ArticleSearchSeriesQuery_search_ItemSearchResults_results_MyLocationPOI | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Navigation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationCategory | ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_NavigationSubcategory | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Navigation_9ce34bf95c934dff841d8f649c2bd6c8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OneTrustSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OptimiserConfiguration | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OptimiserConfigurationSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OptimizedFile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OracleCDPSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OverlayContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OverlayFolderTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Ownership | ArticleSearchSeriesQuery_search_ItemSearchResults_results_OwnershipFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_POI | ArticleSearchSeriesQuery_search_ItemSearchResults_results_POIFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_POIType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_POIs | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageBranchesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageContentFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageContent_ef87e73bc7ff49a2ac599b0be83755c3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesign | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_14161ec204984aa7a2a46decadf669f5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesignFolder_d84605f786ea482da6ff683f6572821c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesign_1105b8f81e00426bbf1fc840742d827b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_3af52e70e982424b9c85e355542500c9 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_48d2d50a150c4f6283603a4fed5646e0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_99a71bba507746729c3fb29b04abee23 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_a0f265b42d6241968b65d3ede7cb59c3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_abe5ce6a82ff4433b4973bc50f192e11 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_b8d9b352c1694b31bd506848b47ca884 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_d3b2e1466f744df0900bec314f699ef3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageLevelTabs | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageLevelTabsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelector | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelectorConfiguration | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelectorFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSelector_59a7bb775f8c435ab810291abde80e63 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSize | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSizeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageSize_b682562e0af64b3e9e3b45273bbe152d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PageThemesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_4f49a81db3664f198b89cab92f377d7a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_5e66d86353544fe6a27d3b894984d50f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_84f342ad2d0646b9aa9a818201145ca2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_718df200be51463d93edf4d77ab7a49e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_b61d5babe46f4ef39f27b57c4ccefdf7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_cfd6e04697e24f3cb9eb41b79afc35dc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_dae7821153e14dbabb0ddf0b53a90aaf | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Page_fa608b3e6aeb426388a059d89caabada | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Pagging | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Pagination | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PaginationFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Paragraph | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_89098e3089aa4062a77346d608caac90 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_1695576fb93647d7842ed17730278c32 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesign_fd2059fd60434dfe8c04e2437ce87634 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_36c869ded22040929ce829f6ed643c66 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_1943dc73710a430895515a342c84b037 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_b1e2a6790a1442d8bafa66317b8be117 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_d52704ed3b704a53abb4292105f687ad | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_d216303f58d8425688da8cd30d00afab | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PartialDesigns_facda26791204fa9a0363344348f2c42 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PerformanceChartSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PerformanceChartTimePeriod | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PerformanceChartTimePeriodFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Placeholder_1ca0304be5b64810821154426f1752c2 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Placeholder_d2a6884c04d54089a64ed27ca9d68d4c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlainHtmlParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Playlist | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaylistFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PlaylistParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Podcast | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PodcastFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PodcastPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PodcastPressReleasePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PoiTypes | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostDeleteStep_b20857895385413883f096f3767cb156 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep_6fac654e22154a419a1d59197bebc0fe | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PostSetupStep_341738aa44fe490e90ff7010a3c2463b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteStep_f0daf401190f45468bda8568d08e161d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Presentation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Presentation_0a70fa7389234a6eabf34134f25f3221 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseContentType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseContentTypesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasePlatform | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasePlatformsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PressReleasesGroupFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PrivacyWarning | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ProjectFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromoFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromoFolder_f07cbe8973ae4de692172570260cac6e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo_7f21f14d096b4f27bbccf115c6e6f6f1 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo_881869ca7f5845ea8b34ad1bfd3551a8 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Promo_dfed4457d760457abec1c0dccdc44381 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromotedContent | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PromotedContentFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingCard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingCards | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingCategory | ArticleSearchSeriesQuery_search_ItemSearchResults_results_PropertyListingFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Query_98b413525a4b4067b92418a4b50f0a53 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuickLinks | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuickLinksFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuickLinksParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlockItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlocks | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlocksFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuotationBlocksParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Quote | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuoteFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_QuoteParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusScheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RadiusSchemeValue | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RangeSliderFilter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RangeSliderFilterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RecentArticles | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Redirect | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RedirectMap | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RedirectMaps | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Region | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RegionLanguages | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RegionLanguagesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RelatedArticles | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RelatedArticlesParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RenderEngineType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RenderingFolder_840d4a46550349ecbf9dbd090946c63d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RenderingHost | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_b58eacfb27f5417bb536141f94b92521 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResizableIFramePage_f460ab055585441892023750e7cef6b7 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResponsiveImage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsCount | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsCountFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ResultsVariantSelector | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichText | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichTextFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichText_0f3b73366112418c8bbab0526f3887ce | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RichText_efcfd8f6596745f48f85b5421928205d | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskImageMapping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskImageMappings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskLevelOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskLevelOptionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskWarning | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskWarningFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RiskWarningParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RolePlaceholder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RowSplitter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_RowSplitter_340c887da1d1415b9678c763af74ea97 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Rule | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRLogoMapping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRLogoMappings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRTypeOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SDRTypeOptionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SXAJSSLayout | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SXARole | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SXAStandardValuesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceAlertMessage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceCheckBox | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceCheckBoxType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButton | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceConditionalRadioButtons | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceDateInput | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceDropdown | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceDropdownOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceHiddenField | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceInput | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceInputType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceIntegratedForm | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceIntegratedFormTypesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceRepeatableSubSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceRichTextArea | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceSortCodeInput | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SalesforceSubmissionType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Scope | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ScopesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Scriban | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Scripts | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchBox | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchBoxFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchBox_1c04fd611d874590acfe9cc186865ab3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchResults | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchResultsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SearchResults_a06f7130041d46bb8c2995a2dc00c26a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SecondaryHeroBannerParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeading | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionHeadingTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionSelector | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionSelectorFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SectionSelectorTab | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Security_33077d51ebad4d1cb4a83b79f51dba13 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Series | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SeriesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Settings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SettingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Settings_6c82caca67dc464195698faad083230e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharePriceSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedArticlesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedContentFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedHelpArticlesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedPressReleasesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedSettingsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedSitesSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SharedSitesSettings_c14bf746030f4e598594395f6d299e61 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Showcase | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ShowcaseFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ShowcaseItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ShowcaseParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Site | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteContentFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteDefinition | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteEntryDisclaimer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteGrouping | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteManagement | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSecurityItemPointer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSelector | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSelector_a44632f56dcd4d10b4892f4e35e193c3 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteSetupRoot | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SiteTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Site_e46f3af239fa4866a1577017c4b2a40c | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SitecoreFormWrapperParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SitecoreRole | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SitemapSettings_c71d856635c849b7a84d9d176e9cbd05 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SkipLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SkipLinkParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SkipLinksFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Snippet | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SnippetItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SnippetsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialLoginWrapper | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaButtons | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaShare | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialMediaTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialNetwork | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialNetworkFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SocialNetworkLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SolutionTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SortResults | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SortResultsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Sorting | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SortingGroups | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SpotifyPodcast | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SpotifyPodcastFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_StickyCTA | ArticleSearchSeriesQuery_search_ItemSearchResults_results_StickyCTAFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_StickyCTAParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_StrategiesInFocusFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_StrategyInFocus | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Style | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Styles | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Styles_9c0dac2808aa4b44bc2153363206f6a5 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_SubscriptionBannerParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tab | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TabItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContents | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContentsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContentsSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TableOfContentsSubsection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tabs | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TabsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tabs_f26a9560ccf148c59542800e837caf7a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tag | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TagCloud | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TagFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TagList | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamBiographySettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamListingCards | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamListingCardsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMember | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMemberCard | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembers | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamProfileCards | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TeamProfileCardsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TechzoneArticlePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tenant | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TenantFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TenantSecurityItemPointer | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TenantSetupRoot | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TertieryHeroBanner | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TertieryHeroBannerParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Text | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlock | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockHeadingParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockHeadingType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockHeadingTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockLinkType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlockLinkTypeFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlocks | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlocksFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextBlocksParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TextFolder_b762d56787f5493cbb480c455d834457 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Text_b8f5894cb4934016bf784090b0a2fd16 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Theme | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemeTag | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemeTagsFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemingMode | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ThemingModes | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Tile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileSizeOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TileSizeOptionFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TilesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TilesParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Title | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Title_a82e893105754175917de904ef7e6dbe | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Toggle | ArticleSearchSeriesQuery_search_ItemSearchResults_results_ToggleFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Toggle_8e4c968e9fa543a89ac4c0baf273ccde | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Transformation | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustArticleHeroParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustFinder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustFinderFilterOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustRegion | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustType | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TrustTypesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Twitter | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterApp | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterApps | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_TwitterSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results_UnknownItem | ArticleSearchSeriesQuery_search_ItemSearchResults_results_UnminifiedFile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_UpgradeScript | ArticleSearchSeriesQuery_search_ItemSearchResults_results_UpgradeScriptLibrary | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantComponentField | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantDateField | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantPlaceholder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantReference | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantSection | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantText | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VariantToken | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Variants | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTile | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTileLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTilesFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VectorTilesParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Version_95ebc23204774dc38ad3465d5fe8da2f | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Video | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoCountOption | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoCountOptions | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoFolder | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoFolder_bba49474673e468186ba8b1a20e067a9 | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoPage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoParameters | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoParametersTemplate | ArticleSearchSeriesQuery_search_ItemSearchResults_results_VideoPressReleasePage | ArticleSearchSeriesQuery_search_ItemSearchResults_results_Video_4bc649610a894242be2dc5026090cf49 | ArticleSearchSeriesQuery_search_ItemSearchResults_results__AssetsOptimization | ArticleSearchSeriesQuery_search_ItemSearchResults_results__BackgroundImage | ArticleSearchSeriesQuery_search_ItemSearchResults_results__CompatibleThemes | ArticleSearchSeriesQuery_search_ItemSearchResults_results__CompositeTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results__CustomMetadata | ArticleSearchSeriesQuery_search_ItemSearchResults_results__CustomRenderingViewPath | ArticleSearchSeriesQuery_search_ItemSearchResults_results__DatasourceBehaviour | ArticleSearchSeriesQuery_search_ItemSearchResults_results__Favicon | ArticleSearchSeriesQuery_search_ItemSearchResults_results__FormsFolderLocation | ArticleSearchSeriesQuery_search_ItemSearchResults_results__FundSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results__HasValidUrlName | ArticleSearchSeriesQuery_search_ItemSearchResults_results__LocalDataLink | ArticleSearchSeriesQuery_search_ItemSearchResults_results__Login | ArticleSearchSeriesQuery_search_ItemSearchResults_results__OpenGraphMetadata | ArticleSearchSeriesQuery_search_ItemSearchResults_results__PageDesignTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results__PageSearchScope | ArticleSearchSeriesQuery_search_ItemSearchResults_results__SearchCriteria | ArticleSearchSeriesQuery_search_ItemSearchResults_results__SearchableWithoutRelatedItems | ArticleSearchSeriesQuery_search_ItemSearchResults_results__SeoMetadata | ArticleSearchSeriesQuery_search_ItemSearchResults_results__SiteTheme | ArticleSearchSeriesQuery_search_ItemSearchResults_results__SitemapSettings | ArticleSearchSeriesQuery_search_ItemSearchResults_results__StickyNote | ArticleSearchSeriesQuery_search_ItemSearchResults_results__Styleable | ArticleSearchSeriesQuery_search_ItemSearchResults_results__TwitterMetadata | ArticleSearchSeriesQuery_search_ItemSearchResults_results__Webinar | ArticleSearchSeriesQuery_search_ItemSearchResults_results__WildcardSource;

export type ArticleSearchSeriesQuery_search_ItemSearchResults = (
  { __typename?: 'ItemSearchResults' }
  & Pick<Types.ItemSearchResults, 'total'>
  & { pageInfo: ArticleSearchSeriesQuery_search_ItemSearchResults_pageInfo_PageInfo, results: Array<Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results>> }
);

export type ArticleSearchSeriesQuery_Query = (
  { __typename?: 'Query' }
  & { search: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults> }
);


export type ArticleSearchSeriesQueryVariables = Types.Exact<{
  pageSize: Types.Scalars['Int']['input'];
  language: Types.Scalars['String']['input'];
  siteId: Types.Scalars['String']['input'];
  seriesId: Types.Scalars['String']['input'];
}>;


export type ArticleSearchSeriesQuery = ArticleSearchSeriesQuery_Query;

export type Base_Accordion_Fragment = (
  { __typename?: 'Accordion' }
  & Pick<Types.Accordion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionFolder_Fragment = (
  { __typename?: 'AccordionFolder' }
  & Pick<Types.AccordionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment = (
  { __typename?: 'AccordionFolder_03f88fb497884025b46f2cb249f4fcd6' }
  & Pick<Types.AccordionFolder_03f88fb497884025b46f2cb249f4fcd6, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionItem_Fragment = (
  { __typename?: 'AccordionItem' }
  & Pick<Types.AccordionItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment = (
  { __typename?: 'AccordionItem_8cf671721b2d489e809f4c23db5ab2da' }
  & Pick<Types.AccordionItem_8cf671721b2d489e809f4c23db5ab2da, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionParametersTemplate_Fragment = (
  { __typename?: 'AccordionParametersTemplate' }
  & Pick<Types.AccordionParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionPresentation_Fragment = (
  { __typename?: 'AccordionPresentation' }
  & Pick<Types.AccordionPresentation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AccordionPresentationFolder_Fragment = (
  { __typename?: 'AccordionPresentationFolder' }
  & Pick<Types.AccordionPresentationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment = (
  { __typename?: 'Accordion_02d060598cc14423a9ac9ff2365176b7' }
  & Pick<Types.Accordion_02d060598cc14423a9ac9ff2365176b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment = (
  { __typename?: 'Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1' }
  & Pick<Types.Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AddItem_Fragment = (
  { __typename?: 'AddItem' }
  & Pick<Types.AddItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment = (
  { __typename?: 'AddItem_1e1b739ec3784909941d171aca7362e5' }
  & Pick<Types.AddItem_1e1b739ec3784909941d171aca7362e5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment = (
  { __typename?: 'AddItem_3aea335cd06d45b1841acbc8d2d1ce40' }
  & Pick<Types.AddItem_3aea335cd06d45b1841acbc8d2d1ce40, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AddItem_De8c75222f3241288f20342f479894eb_Fragment = (
  { __typename?: 'AddItem_de8c75222f3241288f20342f479894eb' }
  & Pick<Types.AddItem_De8c75222f3241288f20342f479894eb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment = (
  { __typename?: 'AddItem_ea8a3f269ccd443a95f571b868a94bd0' }
  & Pick<Types.AddItem_Ea8a3f269ccd443a95f571b868a94bd0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AddThisParameters_Fragment = (
  { __typename?: 'AddThisParameters' }
  & Pick<Types.AddThisParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AggregatedFacetFilter_Fragment = (
  { __typename?: 'AggregatedFacetFilter' }
  & Pick<Types.AggregatedFacetFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AlertMessage_Fragment = (
  { __typename?: 'AlertMessage' }
  & Pick<Types.AlertMessage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AlertMessageFolder_Fragment = (
  { __typename?: 'AlertMessageFolder' }
  & Pick<Types.AlertMessageFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AlertMessageParametersTemplate_Fragment = (
  { __typename?: 'AlertMessageParametersTemplate' }
  & Pick<Types.AlertMessageParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AlertMessageType_Fragment = (
  { __typename?: 'AlertMessageType' }
  & Pick<Types.AlertMessageType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AllertMessageTypeFolder_Fragment = (
  { __typename?: 'AllertMessageTypeFolder' }
  & Pick<Types.AllertMessageTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Archive_Fragment = (
  { __typename?: 'Archive' }
  & Pick<Types.Archive, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleAuthor_Fragment = (
  { __typename?: 'ArticleAuthor' }
  & Pick<Types.ArticleAuthor, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleAuthorsFolder_Fragment = (
  { __typename?: 'ArticleAuthorsFolder' }
  & Pick<Types.ArticleAuthorsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleCategoriesFolder_Fragment = (
  { __typename?: 'ArticleCategoriesFolder' }
  & Pick<Types.ArticleCategoriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleCategory_Fragment = (
  { __typename?: 'ArticleCategory' }
  & Pick<Types.ArticleCategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleChapter_Fragment = (
  { __typename?: 'ArticleChapter' }
  & Pick<Types.ArticleChapter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleChapters_Fragment = (
  { __typename?: 'ArticleChapters' }
  & Pick<Types.ArticleChapters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleContentType_Fragment = (
  { __typename?: 'ArticleContentType' }
  & Pick<Types.ArticleContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleContentTypesFolder_Fragment = (
  { __typename?: 'ArticleContentTypesFolder' }
  & Pick<Types.ArticleContentTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleFilter_Fragment = (
  { __typename?: 'ArticleFilter' }
  & Pick<Types.ArticleFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleFilterOption_Fragment = (
  { __typename?: 'ArticleFilterOption' }
  & Pick<Types.ArticleFilterOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleFootnote_Fragment = (
  { __typename?: 'ArticleFootnote' }
  & Pick<Types.ArticleFootnote, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleFootnoteLink_Fragment = (
  { __typename?: 'ArticleFootnoteLink' }
  & Pick<Types.ArticleFootnoteLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleFootnoteText_Fragment = (
  { __typename?: 'ArticleFootnoteText' }
  & Pick<Types.ArticleFootnoteText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleInfogramTile_Fragment = (
  { __typename?: 'ArticleInfogramTile' }
  & Pick<Types.ArticleInfogramTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleInfogramTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleInfogramTileParametersTemplate' }
  & Pick<Types.ArticleInfogramTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticlePage_Fragment = (
  { __typename?: 'ArticlePage' }
  & Pick<Types.ArticlePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleRegion_Fragment = (
  { __typename?: 'ArticleRegion' }
  & Pick<Types.ArticleRegion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleRegionsFolder_Fragment = (
  { __typename?: 'ArticleRegionsFolder' }
  & Pick<Types.ArticleRegionsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSearchPage_Fragment = (
  { __typename?: 'ArticleSearchPage' }
  & Pick<Types.ArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment = (
  { __typename?: 'ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c' }
  & Pick<Types.ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment = (
  { __typename?: 'ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2' }
  & Pick<Types.ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment = (
  { __typename?: 'ArticleSearchPage_be414ff574ac4203abb2694811443e25' }
  & Pick<Types.ArticleSearchPage_Be414ff574ac4203abb2694811443e25, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment = (
  { __typename?: 'ArticleSearchPage_c7ad44ac3cab45158b619465a552a82c' }
  & Pick<Types.ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment = (
  { __typename?: 'ArticleSearchPage_cf31bd740a4b4363b03d1f7a88e39907' }
  & Pick<Types.ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSeriesCollection_Fragment = (
  { __typename?: 'ArticleSeriesCollection' }
  & Pick<Types.ArticleSeriesCollection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSeriesFolder_Fragment = (
  { __typename?: 'ArticleSeriesFolder' }
  & Pick<Types.ArticleSeriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSettings_Fragment = (
  { __typename?: 'ArticleSettings' }
  & Pick<Types.ArticleSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSubscriptionBanner_Fragment = (
  { __typename?: 'ArticleSubscriptionBanner' }
  & Pick<Types.ArticleSubscriptionBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleSubscriptionBannerFolder_Fragment = (
  { __typename?: 'ArticleSubscriptionBannerFolder' }
  & Pick<Types.ArticleSubscriptionBannerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleTag_Fragment = (
  { __typename?: 'ArticleTag' }
  & Pick<Types.ArticleTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleTagsFolder_Fragment = (
  { __typename?: 'ArticleTagsFolder' }
  & Pick<Types.ArticleTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleTeamAuthor_Fragment = (
  { __typename?: 'ArticleTeamAuthor' }
  & Pick<Types.ArticleTeamAuthor, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleTileParametersTemplate_Fragment = (
  { __typename?: 'ArticleTileParametersTemplate' }
  & Pick<Types.ArticleTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleTilesParametersTemplate_Fragment = (
  { __typename?: 'ArticleTilesParametersTemplate' }
  & Pick<Types.ArticleTilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment = (
  { __typename?: 'ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f' }
  & Pick<Types.ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment = (
  { __typename?: 'ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8' }
  & Pick<Types.ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment = (
  { __typename?: 'ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca' }
  & Pick<Types.ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment = (
  { __typename?: 'ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c' }
  & Pick<Types.ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment = (
  { __typename?: 'ArticleWildcardPage_405b20252077400383d3b47f09f88b47' }
  & Pick<Types.ArticleWildcardPage_405b20252077400383d3b47f09f88b47, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment = (
  { __typename?: 'ArticleWildcardPage_b037a577f5cb4ad3b79f07720a96985b' }
  & Pick<Types.ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ArticlesGroupFolder_Fragment = (
  { __typename?: 'ArticlesGroupFolder' }
  & Pick<Types.ArticlesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AttachThemeExtension_Fragment = (
  { __typename?: 'AttachThemeExtension' }
  & Pick<Types.AttachThemeExtension, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AutomaticDocumentListings_Fragment = (
  { __typename?: 'AutomaticDocumentListings' }
  & Pick<Types.AutomaticDocumentListings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AutomaticDocumentListingsFolder_Fragment = (
  { __typename?: 'AutomaticDocumentListingsFolder' }
  & Pick<Types.AutomaticDocumentListingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AvailableJsonRenderings_Fragment = (
  { __typename?: 'AvailableJSONRenderings' }
  & Pick<Types.AvailableJsonRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AvailableMetaRenderings_Fragment = (
  { __typename?: 'AvailableMetaRenderings' }
  & Pick<Types.AvailableMetaRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AvailableRenderings_Fragment = (
  { __typename?: 'AvailableRenderings' }
  & Pick<Types.AvailableRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment = (
  { __typename?: 'AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb' }
  & Pick<Types.AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AwardsBanner_Fragment = (
  { __typename?: 'AwardsBanner' }
  & Pick<Types.AwardsBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AwardsBannerFolder_Fragment = (
  { __typename?: 'AwardsBannerFolder' }
  & Pick<Types.AwardsBannerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AwardsBannerImage_Fragment = (
  { __typename?: 'AwardsBannerImage' }
  & Pick<Types.AwardsBannerImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_AwardsBannerParametersTemplate_Fragment = (
  { __typename?: 'AwardsBannerParametersTemplate' }
  & Pick<Types.AwardsBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ByocWrapperRenderingParameters_Fragment = (
  { __typename?: 'BYOCWrapperRenderingParameters' }
  & Pick<Types.ByocWrapperRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BackgroundColorOption_Fragment = (
  { __typename?: 'BackgroundColorOption' }
  & Pick<Types.BackgroundColorOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BackgroundColorOptionFolder_Fragment = (
  { __typename?: 'BackgroundColorOptionFolder' }
  & Pick<Types.BackgroundColorOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BannerFolder_Fragment = (
  { __typename?: 'BannerFolder' }
  & Pick<Types.BannerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BannerType_Fragment = (
  { __typename?: 'BannerType' }
  & Pick<Types.BannerType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BannerTypeFolder_Fragment = (
  { __typename?: 'BannerTypeFolder' }
  & Pick<Types.BannerTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BaseHeading_Fragment = (
  { __typename?: 'BaseHeading' }
  & Pick<Types.BaseHeading, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BaseHeadingFolder_Fragment = (
  { __typename?: 'BaseHeadingFolder' }
  & Pick<Types.BaseHeadingFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BoolFacet_Fragment = (
  { __typename?: 'BoolFacet' }
  & Pick<Types.BoolFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BranchesFolder_Fragment = (
  { __typename?: 'BranchesFolder' }
  & Pick<Types.BranchesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Breadcrumb_Fragment = (
  { __typename?: 'Breadcrumb' }
  & Pick<Types.Breadcrumb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_BrowserTitleDefinition_Fragment = (
  { __typename?: 'BrowserTitleDefinition' }
  & Pick<Types.BrowserTitleDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CorsEntry_Fragment = (
  { __typename?: 'CORSEntry' }
  & Pick<Types.CorsEntry, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CorsGrouping_Fragment = (
  { __typename?: 'CORSGrouping' }
  & Pick<Types.CorsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CtaPresentationType_Fragment = (
  { __typename?: 'CTAPresentationType' }
  & Pick<Types.CtaPresentationType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CtaPresentationTypeFolder_Fragment = (
  { __typename?: 'CTAPresentationTypeFolder' }
  & Pick<Types.CtaPresentationTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__AbrdnPage_Fragment = (
  { __typename?: 'C__AbrdnPage' }
  & Pick<Types.C__AbrdnPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ActionBase_Fragment = (
  { __typename?: 'C__ActionBase' }
  & Pick<Types.C__ActionBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__AdvancedParameter_Fragment = (
  { __typename?: 'C__AdvancedParameter' }
  & Pick<Types.C__AdvancedParameter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__App_Fragment = (
  { __typename?: 'C__App' }
  & Pick<Types.C__App, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment = (
  { __typename?: 'C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c' }
  & Pick<Types.C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ArticleWildcardPage_Fragment = (
  { __typename?: 'C__ArticleWildcardPage' }
  & Pick<Types.C__ArticleWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__AvailableRenderingsFolder_Fragment = (
  { __typename?: 'C__AvailableRenderingsFolder' }
  & Pick<Types.C__AvailableRenderingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ByocRenderingParameters_Fragment = (
  { __typename?: 'C__BYOCRenderingParameters' }
  & Pick<Types.C__ByocRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BackgroundParametersTemplate_Fragment = (
  { __typename?: 'C__BackgroundParametersTemplate' }
  & Pick<Types.C__BackgroundParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BaseCta_Fragment = (
  { __typename?: 'C__BaseCTA' }
  & Pick<Types.C__BaseCta, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_Fragment = (
  { __typename?: 'C__BasePage' }
  & Pick<Types.C__BasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment = (
  { __typename?: 'C__BasePage_037da552a5524fe4aeee331f57ac1378' }
  & Pick<Types.C__BasePage_037da552a5524fe4aeee331f57ac1378, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment = (
  { __typename?: 'C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f' }
  & Pick<Types.C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment = (
  { __typename?: 'C__BasePage_315fd21bebf04c9d9f00bae191442f1d' }
  & Pick<Types.C__BasePage_315fd21bebf04c9d9f00bae191442f1d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment = (
  { __typename?: 'C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd' }
  & Pick<Types.C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment = (
  { __typename?: 'C__BasePage_728c97b5c56146d9807e21018a972bb5' }
  & Pick<Types.C__BasePage_728c97b5c56146d9807e21018a972bb5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment = (
  { __typename?: 'C__BasePage_6105875085f346729dfc8d133b481f26' }
  & Pick<Types.C__BasePage_6105875085f346729dfc8d133b481f26, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment = (
  { __typename?: 'C__BasePage_b08130ebd3314a3b9c0f2b5e9b66387b' }
  & Pick<Types.C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BaseRenderingParameters_Fragment = (
  { __typename?: 'C__BaseRenderingParameters' }
  & Pick<Types.C__BaseRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BaseTheme_Fragment = (
  { __typename?: 'C__BaseTheme' }
  & Pick<Types.C__BaseTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__BaseVariantField_Fragment = (
  { __typename?: 'C__BaseVariantField' }
  & Pick<Types.C__BaseVariantField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__Class_Fragment = (
  { __typename?: 'C__Class' }
  & Pick<Types.C__Class, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__CompositeGroup_Fragment = (
  { __typename?: 'C__CompositeGroup' }
  & Pick<Types.C__CompositeGroup, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__CompositeSection_Fragment = (
  { __typename?: 'C__CompositeSection' }
  & Pick<Types.C__CompositeSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__EloquaForm_Fragment = (
  { __typename?: 'C__EloquaForm' }
  & Pick<Types.C__EloquaForm, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment = (
  { __typename?: 'C__ErrorPage_d40dd5cadbf1461191b8f9e1071e557d' }
  & Pick<Types.C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ExtendedOptions_Fragment = (
  { __typename?: 'C__ExtendedOptions' }
  & Pick<Types.C__ExtendedOptions, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment = (
  { __typename?: 'C__ExtendedOptions_2964fb4257a6440fb192218443904c90' }
  & Pick<Types.C__ExtendedOptions_2964fb4257a6440fb192218443904c90, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment = (
  { __typename?: 'C__ExtendedOptions_f1850030f97848b4bdb5884b7e863160' }
  & Pick<Types.C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FEaaSRenderingParameters_Fragment = (
  { __typename?: 'C__FEaaSRenderingParameters' }
  & Pick<Types.C__FEaaSRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FacetSelectorConfigBase_Fragment = (
  { __typename?: 'C__FacetSelectorConfigBase' }
  & Pick<Types.C__FacetSelectorConfigBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment = (
  { __typename?: 'C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845' }
  & Pick<Types.C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment = (
  { __typename?: 'C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b' }
  & Pick<Types.C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment = (
  { __typename?: 'C__FundDetailsWildcardPage_fb127f7aeeba46458c5fbe9f7c589303' }
  & Pick<Types.C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment = (
  { __typename?: 'C__FundSearchPage_d83da2a5ce9042b6bd557aa8820c62c5' }
  & Pick<Types.C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment = (
  { __typename?: 'C__FundShareclassDetailsWildcardPage_e3590ad764a84980a419c4f1f926f9fc' }
  & Pick<Types.C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__GlobalDatasourceBehavior_Fragment = (
  { __typename?: 'C__GlobalDatasourceBehavior' }
  & Pick<Types.C__GlobalDatasourceBehavior, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__GridDefinition_Fragment = (
  { __typename?: 'C__GridDefinition' }
  & Pick<Types.C__GridDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__GridItemBase_Fragment = (
  { __typename?: 'C__GridItemBase' }
  & Pick<Types.C__GridItemBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__GridParameters_Fragment = (
  { __typename?: 'C__GridParameters' }
  & Pick<Types.C__GridParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__HeadlessSite_Fragment = (
  { __typename?: 'C__HeadlessSite' }
  & Pick<Types.C__HeadlessSite, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__HeadlessTenant_Fragment = (
  { __typename?: 'C__HeadlessTenant' }
  & Pick<Types.C__HeadlessTenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment = (
  { __typename?: 'C__HelpArticleSearchPage_d1c4d91365c8401389dcde7b5fb2f28b' }
  & Pick<Types.C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment = (
  { __typename?: 'C__HelpArticleWildcardPage_c0a939305f6e47a38739f2a8f300e65d' }
  & Pick<Types.C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment = (
  { __typename?: 'C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d' }
  & Pick<Types.C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IAllowEmpty_Fragment = (
  { __typename?: 'C__IAllowEmpty' }
  & Pick<Types.C__IAllowEmpty, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IBaseVariantDefinition_Fragment = (
  { __typename?: 'C__IBaseVariantDefinition' }
  & Pick<Types.C__IBaseVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IBoosting_Fragment = (
  { __typename?: 'C__IBoosting' }
  & Pick<Types.C__IBoosting, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ICacheable_Fragment = (
  { __typename?: 'C__ICacheable' }
  & Pick<Types.C__ICacheable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ICompatibleRenderings_Fragment = (
  { __typename?: 'C__ICompatibleRenderings' }
  & Pick<Types.C__ICompatibleRenderings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IComponentVariant_Fragment = (
  { __typename?: 'C__IComponentVariant' }
  & Pick<Types.C__IComponentVariant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IControlType_Fragment = (
  { __typename?: 'C__IControlType' }
  & Pick<Types.C__IControlType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IDynamicPlaceholder_Fragment = (
  { __typename?: 'C__IDynamicPlaceholder' }
  & Pick<Types.C__IDynamicPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IfEaaSComponentsDataSourceTemplates_Fragment = (
  { __typename?: 'C__IFEaaSComponentsDataSourceTemplates' }
  & Pick<Types.C__IfEaaSComponentsDataSourceTemplates, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IfEaaSComponentsEditorScriptUrl_Fragment = (
  { __typename?: 'C__IFEaaSComponentsEditorScriptURL' }
  & Pick<Types.C__IfEaaSComponentsEditorScriptUrl, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IIcon_Fragment = (
  { __typename?: 'C__IIcon' }
  & Pick<Types.C__IIcon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ILocation_Fragment = (
  { __typename?: 'C__ILocation' }
  & Pick<Types.C__ILocation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IPaginable_Fragment = (
  { __typename?: 'C__IPaginable' }
  & Pick<Types.C__IPaginable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IPagination_Fragment = (
  { __typename?: 'C__IPagination' }
  & Pick<Types.C__IPagination, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IPoi_Fragment = (
  { __typename?: 'C__IPoi' }
  & Pick<Types.C__IPoi, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IRenderingId_Fragment = (
  { __typename?: 'C__IRenderingId' }
  & Pick<Types.C__IRenderingId, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ISplitter_Fragment = (
  { __typename?: 'C__ISplitter' }
  & Pick<Types.C__ISplitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IStyling_Fragment = (
  { __typename?: 'C__IStyling' }
  & Pick<Types.C__IStyling, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__IVariantDefinition_Fragment = (
  { __typename?: 'C__IVariantDefinition' }
  & Pick<Types.C__IVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__InvestmentTrustPage_Fragment = (
  { __typename?: 'C__InvestmentTrustPage' }
  & Pick<Types.C__InvestmentTrustPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__JsonField_Fragment = (
  { __typename?: 'C__JSONField' }
  & Pick<Types.C__JsonField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__JsonReference_Fragment = (
  { __typename?: 'C__JSONReference' }
  & Pick<Types.C__JsonReference, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__JssData_Fragment = (
  { __typename?: 'C__JSSData' }
  & Pick<Types.C__JssData, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__JssSettings_Fragment = (
  { __typename?: 'C__JSSSettings' }
  & Pick<Types.C__JssSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__JssSiteFolder_Fragment = (
  { __typename?: 'C__JSSSiteFolder' }
  & Pick<Types.C__JssSiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__JssRootFolder_Fragment = (
  { __typename?: 'C__JssRootFolder' }
  & Pick<Types.C__JssRootFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment = (
  { __typename?: 'C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086' }
  & Pick<Types.C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment = (
  { __typename?: 'C__Navigation_e6d98f24d01c419e871a4617125a49ed' }
  & Pick<Types.C__Navigation_E6d98f24d01c419e871a4617125a49ed, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__Page_Fragment = (
  { __typename?: 'C__Page' }
  & Pick<Types.C__Page, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PageData_Fragment = (
  { __typename?: 'C__PageData' }
  & Pick<Types.C__PageData, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PageDesignFolder_Fragment = (
  { __typename?: 'C__PageDesignFolder' }
  & Pick<Types.C__PageDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment = (
  { __typename?: 'C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd' }
  & Pick<Types.C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment = (
  { __typename?: 'C__PageDesigns_daaf41fd96db4892be99f62f16d036c4' }
  & Pick<Types.C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PartialDesign_Fragment = (
  { __typename?: 'C__PartialDesign' }
  & Pick<Types.C__PartialDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PartialDesignFolder_Fragment = (
  { __typename?: 'C__PartialDesignFolder' }
  & Pick<Types.C__PartialDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment = (
  { __typename?: 'C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d' }
  & Pick<Types.C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment = (
  { __typename?: 'C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d' }
  & Pick<Types.C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PlaceholderWrapper_Fragment = (
  { __typename?: 'C__PlaceholderWrapper' }
  & Pick<Types.C__PlaceholderWrapper, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment = (
  { __typename?: 'C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac' }
  & Pick<Types.C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment = (
  { __typename?: 'C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b' }
  & Pick<Types.C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__RedirectMapGrouping_Fragment = (
  { __typename?: 'C__RedirectMapGrouping' }
  & Pick<Types.C__RedirectMapGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment = (
  { __typename?: 'C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973' }
  & Pick<Types.C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__Route_Fragment = (
  { __typename?: 'C__Route' }
  & Pick<Types.C__Route, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__SimpleVideo_Fragment = (
  { __typename?: 'C__SimpleVideo' }
  & Pick<Types.C__SimpleVideo, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__SiteSettingsFolder_Fragment = (
  { __typename?: 'C__SiteSettingsFolder' }
  & Pick<Types.C__SiteSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__SitemapSettings_Fragment = (
  { __typename?: 'C__SitemapSettings' }
  & Pick<Types.C__SitemapSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__StandardTemplate_Fragment = (
  { __typename?: 'C__StandardTemplate' }
  & Pick<Types.C__StandardTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment = (
  { __typename?: 'C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c' }
  & Pick<Types.C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment = (
  { __typename?: 'C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65' }
  & Pick<Types.C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__TrustFolder_Fragment = (
  { __typename?: 'C__TrustFolder' }
  & Pick<Types.C__TrustFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__VariantDefinition_Fragment = (
  { __typename?: 'C__VariantDefinition' }
  & Pick<Types.C__VariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__VariantField_Fragment = (
  { __typename?: 'C__VariantField' }
  & Pick<Types.C__VariantField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C__VariantsGrouping_Fragment = (
  { __typename?: 'C__VariantsGrouping' }
  & Pick<Types.C__VariantsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___AdvancedItem_Fragment = (
  { __typename?: 'C___AdvancedItem' }
  & Pick<Types.C___AdvancedItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Arguments_Fragment = (
  { __typename?: 'C___Arguments' }
  & Pick<Types.C___Arguments, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment = (
  { __typename?: 'C___Arguments_33fab87cd52f44319a1f589ba7c1e287' }
  & Pick<Types.C___Arguments_33fab87cd52f44319a1f589ba7c1e287, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Article_Fragment = (
  { __typename?: 'C___Article' }
  & Pick<Types.C___Article, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ArticlePageWorkflow_Fragment = (
  { __typename?: 'C___ArticlePageWorkflow' }
  & Pick<Types.C___ArticlePageWorkflow, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ArticleSearchPage_Fragment = (
  { __typename?: 'C___ArticleSearchPage' }
  & Pick<Types.C___ArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ArticleWildcard_Fragment = (
  { __typename?: 'C___ArticleWildcard' }
  & Pick<Types.C___ArticleWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___AssetServiceThemeMode_Fragment = (
  { __typename?: 'C___AssetServiceThemeMode' }
  & Pick<Types.C___AssetServiceThemeMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseArticle_Fragment = (
  { __typename?: 'C___BaseArticle' }
  & Pick<Types.C___BaseArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseDataFolder_Fragment = (
  { __typename?: 'C___BaseDataFolder' }
  & Pick<Types.C___BaseDataFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseHelpArticle_Fragment = (
  { __typename?: 'C___BaseHelpArticle' }
  & Pick<Types.C___BaseHelpArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseInvestmentTrust_Fragment = (
  { __typename?: 'C___BaseInvestmentTrust' }
  & Pick<Types.C___BaseInvestmentTrust, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseJssTenant_Fragment = (
  { __typename?: 'C___BaseJSSTenant' }
  & Pick<Types.C___BaseJssTenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePage_Fragment = (
  { __typename?: 'C___BasePage' }
  & Pick<Types.C___BasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePageDesign_Fragment = (
  { __typename?: 'C___BasePageDesign' }
  & Pick<Types.C___BasePageDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePageDesignFolder_Fragment = (
  { __typename?: 'C___BasePageDesignFolder' }
  & Pick<Types.C___BasePageDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePartialDesign_Fragment = (
  { __typename?: 'C___BasePartialDesign' }
  & Pick<Types.C___BasePartialDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePartialDesignFolder_Fragment = (
  { __typename?: 'C___BasePartialDesignFolder' }
  & Pick<Types.C___BasePartialDesignFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePlaceholder_Fragment = (
  { __typename?: 'C___BasePlaceholder' }
  & Pick<Types.C___BasePlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePlaceholderSettingsFolder_Fragment = (
  { __typename?: 'C___BasePlaceholderSettingsFolder' }
  & Pick<Types.C___BasePlaceholderSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePresentation_Fragment = (
  { __typename?: 'C___BasePresentation' }
  & Pick<Types.C___BasePresentation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BasePressRelease_Fragment = (
  { __typename?: 'C___BasePressRelease' }
  & Pick<Types.C___BasePressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseRenderingParameters_Fragment = (
  { __typename?: 'C___BaseRenderingParameters' }
  & Pick<Types.C___BaseRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSxaStandardValuesFolder_Fragment = (
  { __typename?: 'C___BaseSXAStandardValuesFolder' }
  & Pick<Types.C___BaseSxaStandardValuesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSettings_Fragment = (
  { __typename?: 'C___BaseSettings' }
  & Pick<Types.C___BaseSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSharedSitesSettings_Fragment = (
  { __typename?: 'C___BaseSharedSitesSettings' }
  & Pick<Types.C___BaseSharedSitesSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSiteDefinition_Fragment = (
  { __typename?: 'C___BaseSiteDefinition' }
  & Pick<Types.C___BaseSiteDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSiteFolder_Fragment = (
  { __typename?: 'C___BaseSiteFolder' }
  & Pick<Types.C___BaseSiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSiteGrouping_Fragment = (
  { __typename?: 'C___BaseSiteGrouping' }
  & Pick<Types.C___BaseSiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseSiteRoot_Fragment = (
  { __typename?: 'C___BaseSiteRoot' }
  & Pick<Types.C___BaseSiteRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseTenant_Fragment = (
  { __typename?: 'C___BaseTenant' }
  & Pick<Types.C___BaseTenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BaseTenantFolder_Fragment = (
  { __typename?: 'C___BaseTenantFolder' }
  & Pick<Types.C___BaseTenantFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___BucketRules_Fragment = (
  { __typename?: 'C___BucketRules' }
  & Pick<Types.C___BucketRules, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Cors_Fragment = (
  { __typename?: 'C___CORS' }
  & Pick<Types.C___Cors, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Content_Fragment = (
  { __typename?: 'C___Content' }
  & Pick<Types.C___Content, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ContentType_Fragment = (
  { __typename?: 'C___ContentType' }
  & Pick<Types.C___ContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___DataAttributes_Fragment = (
  { __typename?: 'C___DataAttributes' }
  & Pick<Types.C___DataAttributes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___DatasourceWorkflow_Fragment = (
  { __typename?: 'C___DatasourceWorkflow' }
  & Pick<Types.C___DatasourceWorkflow, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Dependencies_Fragment = (
  { __typename?: 'C___Dependencies' }
  & Pick<Types.C___Dependencies, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Description_Fragment = (
  { __typename?: 'C___Description' }
  & Pick<Types.C___Description, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___DesignTemplateMapping_Fragment = (
  { __typename?: 'C___DesignTemplateMapping' }
  & Pick<Types.C___DesignTemplateMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Designable_Fragment = (
  { __typename?: 'C___Designable' }
  & Pick<Types.C___Designable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___EditType_Fragment = (
  { __typename?: 'C___EditType' }
  & Pick<Types.C___EditType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment = (
  { __typename?: 'C___EditType_8a9f84baaa124c5d9096935714809da4' }
  & Pick<Types.C___EditType_8a9f84baaa124c5d9096935714809da4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___EditingTheme_Fragment = (
  { __typename?: 'C___EditingTheme' }
  & Pick<Types.C___EditingTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Enabled_Fragment = (
  { __typename?: 'C___Enabled' }
  & Pick<Types.C___Enabled, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ErrorHandling_Fragment = (
  { __typename?: 'C___ErrorHandling' }
  & Pick<Types.C___ErrorHandling, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ExternalArticle_Fragment = (
  { __typename?: 'C___ExternalArticle' }
  & Pick<Types.C___ExternalArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Fields_Fragment = (
  { __typename?: 'C___Fields' }
  & Pick<Types.C___Fields, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FilteredArticlesParent_Fragment = (
  { __typename?: 'C___FilteredArticlesParent' }
  & Pick<Types.C___FilteredArticlesParent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FilteredArticlesWildcard_Fragment = (
  { __typename?: 'C___FilteredArticlesWildcard' }
  & Pick<Types.C___FilteredArticlesWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Footnotes_Fragment = (
  { __typename?: 'C___Footnotes' }
  & Pick<Types.C___Footnotes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundDetailsWildcard_Fragment = (
  { __typename?: 'C___FundDetailsWildcard' }
  & Pick<Types.C___FundDetailsWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundFormAvailability_Fragment = (
  { __typename?: 'C___FundFormAvailability' }
  & Pick<Types.C___FundFormAvailability, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundMetadataPage_Fragment = (
  { __typename?: 'C___FundMetadataPage' }
  & Pick<Types.C___FundMetadataPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundSearchPage_Fragment = (
  { __typename?: 'C___FundSearchPage' }
  & Pick<Types.C___FundSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundsFolder_Fragment = (
  { __typename?: 'C___FundsFolder' }
  & Pick<Types.C___FundsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundsFormsFolder_Fragment = (
  { __typename?: 'C___FundsFormsFolder' }
  & Pick<Types.C___FundsFormsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundsLiteratureFolder_Fragment = (
  { __typename?: 'C___FundsLiteratureFolder' }
  & Pick<Types.C___FundsLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___FundsShareclassesDetailsWildcard_Fragment = (
  { __typename?: 'C___FundsShareclassesDetailsWildcard' }
  & Pick<Types.C___FundsShareclassesDetailsWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___GridMapping_Fragment = (
  { __typename?: 'C___GridMapping' }
  & Pick<Types.C___GridMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___HelpArticle_Fragment = (
  { __typename?: 'C___HelpArticle' }
  & Pick<Types.C___HelpArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___HelpArticleSearchPage_Fragment = (
  { __typename?: 'C___HelpArticleSearchPage' }
  & Pick<Types.C___HelpArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___HelpArticleWildcard_Fragment = (
  { __typename?: 'C___HelpArticleWildcard' }
  & Pick<Types.C___HelpArticleWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___HorizonDatasourceGrouping_Fragment = (
  { __typename?: 'C___HorizonDatasourceGrouping' }
  & Pick<Types.C___HorizonDatasourceGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Icon_Fragment = (
  { __typename?: 'C___Icon' }
  & Pick<Types.C___Icon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___IncludeByDefault_Fragment = (
  { __typename?: 'C___IncludeByDefault' }
  & Pick<Types.C___IncludeByDefault, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___IncludeIfInstalled_Fragment = (
  { __typename?: 'C___IncludeIfInstalled' }
  & Pick<Types.C___IncludeIfInstalled, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___InternalArticle_Fragment = (
  { __typename?: 'C___InternalArticle' }
  & Pick<Types.C___InternalArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___InternetExplorerCompatibilityMode_Fragment = (
  { __typename?: 'C___InternetExplorerCompatibilityMode' }
  & Pick<Types.C___InternetExplorerCompatibilityMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___IsSystemModule_Fragment = (
  { __typename?: 'C___IsSystemModule' }
  & Pick<Types.C___IsSystemModule, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___JsonVariantPaging_Fragment = (
  { __typename?: 'C___JSONVariantPaging' }
  & Pick<Types.C___JsonVariantPaging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___JsonVariantsBase_Fragment = (
  { __typename?: 'C___JSONVariantsBase' }
  & Pick<Types.C___JsonVariantsBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___LimitedDisplay_Fragment = (
  { __typename?: 'C___LimitedDisplay' }
  & Pick<Types.C___LimitedDisplay, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___LinkAttributes_Fragment = (
  { __typename?: 'C___LinkAttributes' }
  & Pick<Types.C___LinkAttributes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___LinkSettings_Fragment = (
  { __typename?: 'C___LinkSettings' }
  & Pick<Types.C___LinkSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___LiteratureHubSearchPage_Fragment = (
  { __typename?: 'C___LiteratureHubSearchPage' }
  & Pick<Types.C___LiteratureHubSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ManualKeyInformation_Fragment = (
  { __typename?: 'C___ManualKeyInformation' }
  & Pick<Types.C___ManualKeyInformation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___MemberOf_Fragment = (
  { __typename?: 'C___MemberOf' }
  & Pick<Types.C___MemberOf, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___MetadataPage_Fragment = (
  { __typename?: 'C___MetadataPage' }
  & Pick<Types.C___MetadataPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Modules_Fragment = (
  { __typename?: 'C___Modules' }
  & Pick<Types.C___Modules, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Name_Fragment = (
  { __typename?: 'C___Name' }
  & Pick<Types.C___Name, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment = (
  { __typename?: 'C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d' }
  & Pick<Types.C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Name_299cdb154745448a807868d401248eaa_Fragment = (
  { __typename?: 'C___Name_299cdb154745448a807868d401248eaa' }
  & Pick<Types.C___Name_299cdb154745448a807868d401248eaa, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Name_B88cf88159a54a19991e71038751cb60_Fragment = (
  { __typename?: 'C___Name_b88cf88159a54a19991e71038751cb60' }
  & Pick<Types.C___Name_B88cf88159a54a19991e71038751cb60, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Navigable_Fragment = (
  { __typename?: 'C___Navigable' }
  & Pick<Types.C___Navigable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___NavigablePage_Fragment = (
  { __typename?: 'C___NavigablePage' }
  & Pick<Types.C___NavigablePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PageContent_Fragment = (
  { __typename?: 'C___PageContent' }
  & Pick<Types.C___PageContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PageWorkflow_Fragment = (
  { __typename?: 'C___PageWorkflow' }
  & Pick<Types.C___PageWorkflow, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PerSiteStandardValues_Fragment = (
  { __typename?: 'C___PerSiteStandardValues' }
  & Pick<Types.C___PerSiteStandardValues, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Podcast_Fragment = (
  { __typename?: 'C___Podcast' }
  & Pick<Types.C___Podcast, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PodcastPressRelease_Fragment = (
  { __typename?: 'C___PodcastPressRelease' }
  & Pick<Types.C___PodcastPressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PremiumContentPage_Fragment = (
  { __typename?: 'C___PremiumContentPage' }
  & Pick<Types.C___PremiumContentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PressRelease_Fragment = (
  { __typename?: 'C___PressRelease' }
  & Pick<Types.C___PressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PressReleaseContentType_Fragment = (
  { __typename?: 'C___PressReleaseContentType' }
  & Pick<Types.C___PressReleaseContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PressReleaseSearchPage_Fragment = (
  { __typename?: 'C___PressReleaseSearchPage' }
  & Pick<Types.C___PressReleaseSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PressReleaseWildcard_Fragment = (
  { __typename?: 'C___PressReleaseWildcard' }
  & Pick<Types.C___PressReleaseWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___ProtectedTheme_Fragment = (
  { __typename?: 'C___ProtectedTheme' }
  & Pick<Types.C___ProtectedTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___PublishingGroupingTemplate_Fragment = (
  { __typename?: 'C___PublishingGroupingTemplate' }
  & Pick<Types.C___PublishingGroupingTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RenderingRelatedParameters_Fragment = (
  { __typename?: 'C___RenderingRelatedParameters' }
  & Pick<Types.C___RenderingRelatedParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RenderingVariantsBase_Fragment = (
  { __typename?: 'C___RenderingVariantsBase' }
  & Pick<Types.C___RenderingVariantsBase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RenderingsList_Fragment = (
  { __typename?: 'C___RenderingsList' }
  & Pick<Types.C___RenderingsList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RobotsContent_Fragment = (
  { __typename?: 'C___RobotsContent' }
  & Pick<Types.C___RobotsContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RoleDomain_Fragment = (
  { __typename?: 'C___RoleDomain' }
  & Pick<Types.C___RoleDomain, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RoleName_Fragment = (
  { __typename?: 'C___RoleName' }
  & Pick<Types.C___RoleName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___RoleType_Fragment = (
  { __typename?: 'C___RoleType' }
  & Pick<Types.C___RoleType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SalesforceCommonValidations_Fragment = (
  { __typename?: 'C___SalesforceCommonValidations' }
  & Pick<Types.C___SalesforceCommonValidations, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SalesforceFieldId_Fragment = (
  { __typename?: 'C___SalesforceFieldId' }
  & Pick<Types.C___SalesforceFieldId, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SalesforceFieldTitle_Fragment = (
  { __typename?: 'C___SalesforceFieldTitle' }
  & Pick<Types.C___SalesforceFieldTitle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SalesforceFieldValue_Fragment = (
  { __typename?: 'C___SalesforceFieldValue' }
  & Pick<Types.C___SalesforceFieldValue, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Script_Fragment = (
  { __typename?: 'C___Script' }
  & Pick<Types.C___Script, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SearchSignature_Fragment = (
  { __typename?: 'C___SearchSignature' }
  & Pick<Types.C___SearchSignature, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Searchable_Fragment = (
  { __typename?: 'C___Searchable' }
  & Pick<Types.C___Searchable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SecurityItemPointer_Fragment = (
  { __typename?: 'C___SecurityItemPointer' }
  & Pick<Types.C___SecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedArticles_Fragment = (
  { __typename?: 'C___SharedArticles' }
  & Pick<Types.C___SharedArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedContent_Fragment = (
  { __typename?: 'C___SharedContent' }
  & Pick<Types.C___SharedContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedHelpArticles_Fragment = (
  { __typename?: 'C___SharedHelpArticles' }
  & Pick<Types.C___SharedHelpArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedPage_Fragment = (
  { __typename?: 'C___SharedPage' }
  & Pick<Types.C___SharedPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedPressReleases_Fragment = (
  { __typename?: 'C___SharedPressReleases' }
  & Pick<Types.C___SharedPressReleases, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedRoot_Fragment = (
  { __typename?: 'C___SharedRoot' }
  & Pick<Types.C___SharedRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SharedSettings_Fragment = (
  { __typename?: 'C___SharedSettings' }
  & Pick<Types.C___SharedSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SiteContent_Fragment = (
  { __typename?: 'C___SiteContent' }
  & Pick<Types.C___SiteContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SiteFolder_Fragment = (
  { __typename?: 'C___SiteFolder' }
  & Pick<Types.C___SiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SiteMediaLibrary_Fragment = (
  { __typename?: 'C___SiteMediaLibrary' }
  & Pick<Types.C___SiteMediaLibrary, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SiteSettings_Fragment = (
  { __typename?: 'C___SiteSettings' }
  & Pick<Types.C___SiteSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SiteTemplate_Fragment = (
  { __typename?: 'C___SiteTemplate' }
  & Pick<Types.C___SiteTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SitecoreClientSiteManaging_Fragment = (
  { __typename?: 'C___SitecoreClientSiteManaging' }
  & Pick<Types.C___SitecoreClientSiteManaging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Sitemap_Fragment = (
  { __typename?: 'C___Sitemap' }
  & Pick<Types.C___Sitemap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SitemapMediaItems_Fragment = (
  { __typename?: 'C___SitemapMediaItems' }
  & Pick<Types.C___SitemapMediaItems, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SlidersRangeSettings_Fragment = (
  { __typename?: 'C___SlidersRangeSettings' }
  & Pick<Types.C___SlidersRangeSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SolutionTemplateContent_Fragment = (
  { __typename?: 'C___SolutionTemplateContent' }
  & Pick<Types.C___SolutionTemplateContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SolutionTemplateDescription_Fragment = (
  { __typename?: 'C___SolutionTemplateDescription' }
  & Pick<Types.C___SolutionTemplateDescription, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SolutionTemplateName_Fragment = (
  { __typename?: 'C___SolutionTemplateName' }
  & Pick<Types.C___SolutionTemplateName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SortOrder_Fragment = (
  { __typename?: 'C___SortOrder' }
  & Pick<Types.C___SortOrder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___StackBreakpoint_Fragment = (
  { __typename?: 'C___StackBreakpoint' }
  & Pick<Types.C___StackBreakpoint, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Statistics_Fragment = (
  { __typename?: 'C___Statistics' }
  & Pick<Types.C___Statistics, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___SupportedLanguages_Fragment = (
  { __typename?: 'C___SupportedLanguages' }
  & Pick<Types.C___SupportedLanguages, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Taggable_Fragment = (
  { __typename?: 'C___Taggable' }
  & Pick<Types.C___Taggable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___TeamMembersParentPage_Fragment = (
  { __typename?: 'C___TeamMembersParentPage' }
  & Pick<Types.C___TeamMembersParentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___TeamMembersWildcard_Fragment = (
  { __typename?: 'C___TeamMembersWildcard' }
  & Pick<Types.C___TeamMembersWildcard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___TechzoneArticle_Fragment = (
  { __typename?: 'C___TechzoneArticle' }
  & Pick<Types.C___TechzoneArticle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Template_Fragment = (
  { __typename?: 'C___Template' }
  & Pick<Types.C___Template, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Title_Fragment = (
  { __typename?: 'C___Title' }
  & Pick<Types.C___Title, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Type_Fragment = (
  { __typename?: 'C___Type' }
  & Pick<Types.C___Type, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Validation_Fragment = (
  { __typename?: 'C___Validation' }
  & Pick<Types.C___Validation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___VariantPaging_Fragment = (
  { __typename?: 'C___VariantPaging' }
  & Pick<Types.C___VariantPaging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___VectorTile_Fragment = (
  { __typename?: 'C___VectorTile' }
  & Pick<Types.C___VectorTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___VectorTileLink_Fragment = (
  { __typename?: 'C___VectorTileLink' }
  & Pick<Types.C___VectorTileLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Video_Fragment = (
  { __typename?: 'C___Video' }
  & Pick<Types.C___Video, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___VideoPressRelease_Fragment = (
  { __typename?: 'C___VideoPressRelease' }
  & Pick<Types.C___VideoPressRelease, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___Width_Fragment = (
  { __typename?: 'C___Width' }
  & Pick<Types.C___Width, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_C___WildcardPage_Fragment = (
  { __typename?: 'C___WildcardPage' }
  & Pick<Types.C___WildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CacheSetting_Fragment = (
  { __typename?: 'CacheSetting' }
  & Pick<Types.CacheSetting, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment = (
  { __typename?: 'Caching_26fce9bf0256458d8281a713a5bf5520' }
  & Pick<Types.Caching_26fce9bf0256458d8281a713a5bf5520, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CalendarEvent_Fragment = (
  { __typename?: 'CalendarEvent' }
  & Pick<Types.CalendarEvent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CallOutSection_Fragment = (
  { __typename?: 'CallOutSection' }
  & Pick<Types.CallOutSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CallOutSectionDropdownOption_Fragment = (
  { __typename?: 'CallOutSectionDropdownOption' }
  & Pick<Types.CallOutSectionDropdownOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CallOutSectionFolder_Fragment = (
  { __typename?: 'CallOutSectionFolder' }
  & Pick<Types.CallOutSectionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CallOutSectionParametersTemplate_Fragment = (
  { __typename?: 'CallOutSectionParametersTemplate' }
  & Pick<Types.CallOutSectionParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CallToAction_Fragment = (
  { __typename?: 'CallToAction' }
  & Pick<Types.CallToAction, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CallToActionFolder_Fragment = (
  { __typename?: 'CallToActionFolder' }
  & Pick<Types.CallToActionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CapabilitiesFolder_Fragment = (
  { __typename?: 'CapabilitiesFolder' }
  & Pick<Types.CapabilitiesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Capability_Fragment = (
  { __typename?: 'Capability' }
  & Pick<Types.Capability, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CapabilityMap_Fragment = (
  { __typename?: 'CapabilityMap' }
  & Pick<Types.CapabilityMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CapabilityMappings_Fragment = (
  { __typename?: 'CapabilityMappings' }
  & Pick<Types.CapabilityMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Carousel_Fragment = (
  { __typename?: 'Carousel' }
  & Pick<Types.Carousel, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CarouselFolder_Fragment = (
  { __typename?: 'CarouselFolder' }
  & Pick<Types.CarouselFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CarouselSlide_Fragment = (
  { __typename?: 'CarouselSlide' }
  & Pick<Types.CarouselSlide, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment = (
  { __typename?: 'Carousel_2b65f0d87ec54834b4aa1753c0f7036b' }
  & Pick<Types.Carousel_2b65f0d87ec54834b4aa1753c0f7036b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Checkbox_Fragment = (
  { __typename?: 'Checkbox' }
  & Pick<Types.Checkbox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ChecklistFilter_Fragment = (
  { __typename?: 'ChecklistFilter' }
  & Pick<Types.ChecklistFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ChecklistFilterFolder_Fragment = (
  { __typename?: 'ChecklistFilterFolder' }
  & Pick<Types.ChecklistFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment = (
  { __typename?: 'ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee' }
  & Pick<Types.ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ColumnSplitter_Fragment = (
  { __typename?: 'ColumnSplitter' }
  & Pick<Types.ColumnSplitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment = (
  { __typename?: 'ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0' }
  & Pick<Types.ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CompatibilityMode_Fragment = (
  { __typename?: 'CompatibilityMode' }
  & Pick<Types.CompatibilityMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ComponentConfiguration_Fragment = (
  { __typename?: 'ComponentConfiguration' }
  & Pick<Types.ComponentConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ComponentThemeConfiguration_Fragment = (
  { __typename?: 'ComponentThemeConfiguration' }
  & Pick<Types.ComponentThemeConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ComponentThemesConfiguration_Fragment = (
  { __typename?: 'ComponentThemesConfiguration' }
  & Pick<Types.ComponentThemesConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ComponentsConfigurations_Fragment = (
  { __typename?: 'ComponentsConfigurations' }
  & Pick<Types.ComponentsConfigurations, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ConfigurationFolder_Fragment = (
  { __typename?: 'ConfigurationFolder' }
  & Pick<Types.ConfigurationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Container_Fragment = (
  { __typename?: 'Container' }
  & Pick<Types.Container, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContainerOption_Fragment = (
  { __typename?: 'ContainerOption' }
  & Pick<Types.ContainerOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContainerOptionsFolder_Fragment = (
  { __typename?: 'ContainerOptionsFolder' }
  & Pick<Types.ContainerOptionsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContainerParametersTemplate_Fragment = (
  { __typename?: 'ContainerParametersTemplate' }
  & Pick<Types.ContainerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment = (
  { __typename?: 'Container_45130bdbbae34edcaea87b68b9d94c7f' }
  & Pick<Types.Container_45130bdbbae34edcaea87b68b9d94c7f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContentBlock_Fragment = (
  { __typename?: 'ContentBlock' }
  & Pick<Types.ContentBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContentBlockFolder_Fragment = (
  { __typename?: 'ContentBlockFolder' }
  & Pick<Types.ContentBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContentToken_Fragment = (
  { __typename?: 'ContentToken' }
  & Pick<Types.ContentToken, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContentTokenFolder_Fragment = (
  { __typename?: 'ContentTokenFolder' }
  & Pick<Types.ContentTokenFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ContentType_Fragment = (
  { __typename?: 'ContentType' }
  & Pick<Types.ContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CorporateTheme_Fragment = (
  { __typename?: 'CorporateTheme' }
  & Pick<Types.CorporateTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CorporateThemesFolder_Fragment = (
  { __typename?: 'CorporateThemesFolder' }
  & Pick<Types.CorporateThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Country_Fragment = (
  { __typename?: 'Country' }
  & Pick<Types.Country, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CountryIsoCode_Fragment = (
  { __typename?: 'CountryISOCode' }
  & Pick<Types.CountryIsoCode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CountryIsoCodesFolder_Fragment = (
  { __typename?: 'CountryISOCodesFolder' }
  & Pick<Types.CountryIsoCodesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CustomerReviewFolder_Fragment = (
  { __typename?: 'CustomerReviewFolder' }
  & Pick<Types.CustomerReviewFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CustomerReviewTile_Fragment = (
  { __typename?: 'CustomerReviewTile' }
  & Pick<Types.CustomerReviewTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_CustomerReviewTileParametersTemplate_Fragment = (
  { __typename?: 'CustomerReviewTileParametersTemplate' }
  & Pick<Types.CustomerReviewTileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DataBridgeDocumentCategoryMap_Fragment = (
  { __typename?: 'DataBridgeDocumentCategoryMap' }
  & Pick<Types.DataBridgeDocumentCategoryMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DataBridgeFund_Fragment = (
  { __typename?: 'DataBridgeFund' }
  & Pick<Types.DataBridgeFund, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DataBridgeFundRangeName_Fragment = (
  { __typename?: 'DataBridgeFundRangeName' }
  & Pick<Types.DataBridgeFundRangeName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DataBridgeSettingsFolder_Fragment = (
  { __typename?: 'DataBridgeSettingsFolder' }
  & Pick<Types.DataBridgeSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DataBridgeShareClass_Fragment = (
  { __typename?: 'DataBridgeShareClass' }
  & Pick<Types.DataBridgeShareClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DataFolder_Fragment = (
  { __typename?: 'DataFolder' }
  & Pick<Types.DataFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DatasourceConfiguration_Fragment = (
  { __typename?: 'DatasourceConfiguration' }
  & Pick<Types.DatasourceConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DatasourceConfigurations_Fragment = (
  { __typename?: 'DatasourceConfigurations' }
  & Pick<Types.DatasourceConfigurations, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DatasourceWorkflowAction_Fragment = (
  { __typename?: 'DatasourceWorkflowAction' }
  & Pick<Types.DatasourceWorkflowAction, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DateFacet_Fragment = (
  { __typename?: 'DateFacet' }
  & Pick<Types.DateFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DateFilter_Fragment = (
  { __typename?: 'DateFilter' }
  & Pick<Types.DateFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DateFilterFolder_Fragment = (
  { __typename?: 'DateFilterFolder' }
  & Pick<Types.DateFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment = (
  { __typename?: 'DateFilter_ad89c1f1e99148ef865938ab13aa28f1' }
  & Pick<Types.DateFilter_Ad89c1f1e99148ef865938ab13aa28f1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DefaultColumnLayout_Fragment = (
  { __typename?: 'DefaultColumnLayout' }
  & Pick<Types.DefaultColumnLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DefaultShareclassMapping_Fragment = (
  { __typename?: 'DefaultShareclassMapping' }
  & Pick<Types.DefaultShareclassMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DefaultShareclassMappings_Fragment = (
  { __typename?: 'DefaultShareclassMappings' }
  & Pick<Types.DefaultShareclassMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DescriptiveHighlight_Fragment = (
  { __typename?: 'DescriptiveHighlight' }
  & Pick<Types.DescriptiveHighlight, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DescriptiveHighlightFolder_Fragment = (
  { __typename?: 'DescriptiveHighlightFolder' }
  & Pick<Types.DescriptiveHighlightFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DescriptiveHighlightItem_Fragment = (
  { __typename?: 'DescriptiveHighlightItem' }
  & Pick<Types.DescriptiveHighlightItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DescriptiveHighlightParametersTemplate_Fragment = (
  { __typename?: 'DescriptiveHighlightParametersTemplate' }
  & Pick<Types.DescriptiveHighlightParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Device_Fragment = (
  { __typename?: 'Device' }
  & Pick<Types.Device, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment = (
  { __typename?: 'Device_7c27ec70f42e40428a0fabaa2f8eda18' }
  & Pick<Types.Device_7c27ec70f42e40428a0fabaa2f8eda18, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Devices_Fragment = (
  { __typename?: 'Devices' }
  & Pick<Types.Devices, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DictionaryFolder_Fragment = (
  { __typename?: 'DictionaryFolder' }
  & Pick<Types.DictionaryFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DisqusParameters_Fragment = (
  { __typename?: 'DisqusParameters' }
  & Pick<Types.DisqusParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DistanceFacet_Fragment = (
  { __typename?: 'DistanceFacet' }
  & Pick<Types.DistanceFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Divider_Fragment = (
  { __typename?: 'Divider' }
  & Pick<Types.Divider, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DocumentItem_Fragment = (
  { __typename?: 'DocumentItem' }
  & Pick<Types.DocumentItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DocumentListings_Fragment = (
  { __typename?: 'DocumentListings' }
  & Pick<Types.DocumentListings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DocumentListingsFolder_Fragment = (
  { __typename?: 'DocumentListingsFolder' }
  & Pick<Types.DocumentListingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DocumentTypeFolder_Fragment = (
  { __typename?: 'DocumentTypeFolder' }
  & Pick<Types.DocumentTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DominantLanguageMapping_Fragment = (
  { __typename?: 'DominantLanguageMapping' }
  & Pick<Types.DominantLanguageMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Dropdown_Fragment = (
  { __typename?: 'Dropdown' }
  & Pick<Types.Dropdown, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DropdownFilter_Fragment = (
  { __typename?: 'DropdownFilter' }
  & Pick<Types.DropdownFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DropdownFilterFolder_Fragment = (
  { __typename?: 'DropdownFilterFolder' }
  & Pick<Types.DropdownFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment = (
  { __typename?: 'DropdownFilter_790c0f2c16214604a6c672b9f8ae830d' }
  & Pick<Types.DropdownFilter_790c0f2c16214604a6c672b9f8ae830d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditEditingTheme_Fragment = (
  { __typename?: 'EditEditingTheme' }
  & Pick<Types.EditEditingTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditFrame_Fragment = (
  { __typename?: 'EditFrame' }
  & Pick<Types.EditFrame, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditModePanel_Fragment = (
  { __typename?: 'EditModePanel' }
  & Pick<Types.EditModePanel, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditSiteItem_Fragment = (
  { __typename?: 'EditSiteItem' }
  & Pick<Types.EditSiteItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment = (
  { __typename?: 'EditSiteItem_f040db0387fe4e10ae4053c63175e31b' }
  & Pick<Types.EditSiteItem_F040db0387fe4e10ae4053c63175e31b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditSiteTheme_Fragment = (
  { __typename?: 'EditSiteTheme' }
  & Pick<Types.EditSiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditTenantTemplate_Fragment = (
  { __typename?: 'EditTenantTemplate' }
  & Pick<Types.EditTenantTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment = (
  { __typename?: 'EditTenantTemplate_a7d9fcbcc8944274935f9b9659c000d3' }
  & Pick<Types.EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EditType_Fragment = (
  { __typename?: 'EditType' }
  & Pick<Types.EditType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EloquaFormFolder_Fragment = (
  { __typename?: 'EloquaFormFolder' }
  & Pick<Types.EloquaFormFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EloquaFundForm_Fragment = (
  { __typename?: 'EloquaFundForm' }
  & Pick<Types.EloquaFundForm, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Enum_Fragment = (
  { __typename?: 'Enum' }
  & Pick<Types.Enum, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Enums_Fragment = (
  { __typename?: 'Enums' }
  & Pick<Types.Enums, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ErrorPage_Fragment = (
  { __typename?: 'ErrorPage' }
  & Pick<Types.ErrorPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment = (
  { __typename?: 'ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171' }
  & Pick<Types.ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment = (
  { __typename?: 'ErrorPage_4dbccce416d1491f94198496e3f77c6d' }
  & Pick<Types.ErrorPage_4dbccce416d1491f94198496e3f77c6d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment = (
  { __typename?: 'ErrorPage_45d797cc048740ffb693214883ff35c2' }
  & Pick<Types.ErrorPage_45d797cc048740ffb693214883ff35c2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment = (
  { __typename?: 'ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9' }
  & Pick<Types.ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment = (
  { __typename?: 'ErrorPage_a7dfa49761224679bf9949fffacd5fa1' }
  & Pick<Types.ErrorPage_A7dfa49761224679bf9949fffacd5fa1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EventCalendarParameters_Fragment = (
  { __typename?: 'EventCalendarParameters' }
  & Pick<Types.EventCalendarParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EventList_Fragment = (
  { __typename?: 'EventList' }
  & Pick<Types.EventList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EventListParameters_Fragment = (
  { __typename?: 'EventListParameters' }
  & Pick<Types.EventListParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EventTypes_Fragment = (
  { __typename?: 'EventTypes' }
  & Pick<Types.EventTypes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_EventsFolder_Fragment = (
  { __typename?: 'EventsFolder' }
  & Pick<Types.EventsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExecuteScript_Fragment = (
  { __typename?: 'ExecuteScript' }
  & Pick<Types.ExecuteScript, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment = (
  { __typename?: 'ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f' }
  & Pick<Types.ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment = (
  { __typename?: 'ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a' }
  & Pick<Types.ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment = (
  { __typename?: 'ExecuteScript_b06460c28b7b47a59e2cf966f689b6ca' }
  & Pick<Types.ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment = (
  { __typename?: 'ExecuteScript_bc9bb68436df4285888bd8b4d87b10de' }
  & Pick<Types.ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment = (
  { __typename?: 'ExecuteScript_e14c08721a97459eafef0acaaaf1ffbb' }
  & Pick<Types.ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExtendSiteTheme_Fragment = (
  { __typename?: 'ExtendSiteTheme' }
  & Pick<Types.ExtendSiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ExternalLiterature_Fragment = (
  { __typename?: 'ExternalLiterature' }
  & Pick<Types.ExternalLiterature, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FEaaSWrapperRenderingParameters_Fragment = (
  { __typename?: 'FEaaSWrapperRenderingParameters' }
  & Pick<Types.FEaaSWrapperRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacebookCommentsParametersTemplate_Fragment = (
  { __typename?: 'FacebookCommentsParametersTemplate' }
  & Pick<Types.FacebookCommentsParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetSlider_Fragment = (
  { __typename?: 'FacetSlider' }
  & Pick<Types.FacetSlider, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetSliderFolder_Fragment = (
  { __typename?: 'FacetSliderFolder' }
  & Pick<Types.FacetSliderFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment = (
  { __typename?: 'FacetSlider_995ce2c7319f478b84fe22053ac85bb7' }
  & Pick<Types.FacetSlider_995ce2c7319f478b84fe22053ac85bb7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetSummary_Fragment = (
  { __typename?: 'FacetSummary' }
  & Pick<Types.FacetSummary, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetSummaryFolder_Fragment = (
  { __typename?: 'FacetSummaryFolder' }
  & Pick<Types.FacetSummaryFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment = (
  { __typename?: 'FacetSummary_cd5c935c1f604d899a6b88ce28305cf2' }
  & Pick<Types.FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FacetsGrouping_Fragment = (
  { __typename?: 'FacetsGrouping' }
  & Pick<Types.FacetsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FakeNavigationItem_Fragment = (
  { __typename?: 'FakeNavigationItem' }
  & Pick<Types.FakeNavigationItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeatureBanner_Fragment = (
  { __typename?: 'FeatureBanner' }
  & Pick<Types.FeatureBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeatureBannerParametersTemplate_Fragment = (
  { __typename?: 'FeatureBannerParametersTemplate' }
  & Pick<Types.FeatureBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeaturedArticles_Fragment = (
  { __typename?: 'FeaturedArticles' }
  & Pick<Types.FeaturedArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeaturedArticlesFolder_Fragment = (
  { __typename?: 'FeaturedArticlesFolder' }
  & Pick<Types.FeaturedArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeaturedTheme_Fragment = (
  { __typename?: 'FeaturedTheme' }
  & Pick<Types.FeaturedTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeaturedThemesFolder_Fragment = (
  { __typename?: 'FeaturedThemesFolder' }
  & Pick<Types.FeaturedThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Feed_Fragment = (
  { __typename?: 'Feed' }
  & Pick<Types.Feed, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeedFolder_Fragment = (
  { __typename?: 'FeedFolder' }
  & Pick<Types.FeedFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FeedParameters_Fragment = (
  { __typename?: 'FeedParameters' }
  & Pick<Types.FeedParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FieldEditor_Fragment = (
  { __typename?: 'FieldEditor' }
  & Pick<Types.FieldEditor, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FieldRenderer_Fragment = (
  { __typename?: 'FieldRenderer' }
  & Pick<Types.FieldRenderer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FileList_Fragment = (
  { __typename?: 'FileList' }
  & Pick<Types.FileList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FileListFolder_Fragment = (
  { __typename?: 'FileListFolder' }
  & Pick<Types.FileListFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FileListParametersTemplate_Fragment = (
  { __typename?: 'FileListParametersTemplate' }
  & Pick<Types.FileListParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_File_04129321770849c1801baee196e1c0a8_Fragment = (
  { __typename?: 'File_04129321770849c1801baee196e1c0a8' }
  & Pick<Types.File_04129321770849c1801baee196e1c0a8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilterCriteria_Fragment = (
  { __typename?: 'FilterCriteria' }
  & Pick<Types.FilterCriteria, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilterCriteriaFolder_Fragment = (
  { __typename?: 'FilterCriteriaFolder' }
  & Pick<Types.FilterCriteriaFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilterTaxonomyOption_Fragment = (
  { __typename?: 'FilterTaxonomyOption' }
  & Pick<Types.FilterTaxonomyOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilterTaxonomyOptions_Fragment = (
  { __typename?: 'FilterTaxonomyOptions' }
  & Pick<Types.FilterTaxonomyOptions, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesParentPage_Fragment = (
  { __typename?: 'FilteredArticlesParentPage' }
  & Pick<Types.FilteredArticlesParentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d' }
  & Pick<Types.FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941' }
  & Pick<Types.FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_a34845039cf1441f8c967a5bbbdd7616' }
  & Pick<Types.FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_e4f65f074322485787460a4058d378f9' }
  & Pick<Types.FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment = (
  { __typename?: 'FilteredArticlesParentPage_f099104e87204d52a6ab75aa44d159ce' }
  & Pick<Types.FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesWildcardPage_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage' }
  & Pick<Types.FilteredArticlesWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e' }
  & Pick<Types.FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835' }
  & Pick<Types.FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2' }
  & Pick<Types.FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_ceac9aa72d344797adf00f73f9a55f96' }
  & Pick<Types.FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment = (
  { __typename?: 'FilteredArticlesWildcardPage_da761c9a4e8f4a91b99040d8f5baa260' }
  & Pick<Types.FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Flip_Fragment = (
  { __typename?: 'Flip' }
  & Pick<Types.Flip, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FlipFolder_Fragment = (
  { __typename?: 'FlipFolder' }
  & Pick<Types.FlipFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Flip_5ef078504c044b839dafefd752cfaba8_Fragment = (
  { __typename?: 'Flip_5ef078504c044b839dafefd752cfaba8' }
  & Pick<Types.Flip_5ef078504c044b839dafefd752cfaba8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Flipside_Fragment = (
  { __typename?: 'Flipside' }
  & Pick<Types.Flipside, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FloatFacet_Fragment = (
  { __typename?: 'FloatFacet' }
  & Pick<Types.FloatFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Footer_Fragment = (
  { __typename?: 'Footer' }
  & Pick<Types.Footer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FooterFolder_Fragment = (
  { __typename?: 'FooterFolder' }
  & Pick<Types.FooterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FooterLink_Fragment = (
  { __typename?: 'FooterLink' }
  & Pick<Types.FooterLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FormRenderingParameters_Fragment = (
  { __typename?: 'FormRenderingParameters' }
  & Pick<Types.FormRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundAssetClass_Fragment = (
  { __typename?: 'FundAssetClass' }
  & Pick<Types.FundAssetClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundAssetClassesFolder_Fragment = (
  { __typename?: 'FundAssetClassesFolder' }
  & Pick<Types.FundAssetClassesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundDetailsWildcardPage_Fragment = (
  { __typename?: 'FundDetailsWildcardPage' }
  & Pick<Types.FundDetailsWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734' }
  & Pick<Types.FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f' }
  & Pick<Types.FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment = (
  { __typename?: 'FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b' }
  & Pick<Types.FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundFormsFolder_Fragment = (
  { __typename?: 'FundFormsFolder' }
  & Pick<Types.FundFormsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundInFocus_Fragment = (
  { __typename?: 'FundInFocus' }
  & Pick<Types.FundInFocus, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundInFocusShareClass_Fragment = (
  { __typename?: 'FundInFocusShareClass' }
  & Pick<Types.FundInFocusShareClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSearchPage_Fragment = (
  { __typename?: 'FundSearchPage' }
  & Pick<Types.FundSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment = (
  { __typename?: 'FundSearchPage_5505b84dba1f47c7b8054749d802d926' }
  & Pick<Types.FundSearchPage_5505b84dba1f47c7b8054749d802d926, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment = (
  { __typename?: 'FundSearchPage_5806f83c03bc443380678ff955f4310f' }
  & Pick<Types.FundSearchPage_5806f83c03bc443380678ff955f4310f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment = (
  { __typename?: 'FundSearchPage_7432205c04214a419ca064c4cb37501c' }
  & Pick<Types.FundSearchPage_7432205c04214a419ca064c4cb37501c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment = (
  { __typename?: 'FundSearchPage_edc9df02132e4c0a8435dd60057cbb0a' }
  & Pick<Types.FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSettings_Fragment = (
  { __typename?: 'FundSettings' }
  & Pick<Types.FundSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundShareclassDetailsWildcardPage_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage' }
  & Pick<Types.FundShareclassDetailsWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c' }
  & Pick<Types.FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3' }
  & Pick<Types.FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_cf3f2635270b49779bb3822ab90f1dcc' }
  & Pick<Types.FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment = (
  { __typename?: 'FundShareclassDetailsWildcardPage_d7e686d9c3bc4ef9974e201972b59eee' }
  & Pick<Types.FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSubAssetClass_Fragment = (
  { __typename?: 'FundSubAssetClass' }
  & Pick<Types.FundSubAssetClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundSubAssetClassesFolder_Fragment = (
  { __typename?: 'FundSubAssetClassesFolder' }
  & Pick<Types.FundSubAssetClassesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundsExternalLiteratureFolder_Fragment = (
  { __typename?: 'FundsExternalLiteratureFolder' }
  & Pick<Types.FundsExternalLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundsFolder_Fragment = (
  { __typename?: 'FundsFolder' }
  & Pick<Types.FundsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundsInFocusFolder_Fragment = (
  { __typename?: 'FundsInFocusFolder' }
  & Pick<Types.FundsInFocusFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundsInFocusParametersTemplate_Fragment = (
  { __typename?: 'FundsInFocusParametersTemplate' }
  & Pick<Types.FundsInFocusParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundsLiteratureFolder_Fragment = (
  { __typename?: 'FundsLiteratureFolder' }
  & Pick<Types.FundsLiteratureFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_FundsLiteratureMappingsFolder_Fragment = (
  { __typename?: 'FundsLiteratureMappingsFolder' }
  & Pick<Types.FundsLiteratureMappingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Gallery_Fragment = (
  { __typename?: 'Gallery' }
  & Pick<Types.Gallery, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GalleryFolder_Fragment = (
  { __typename?: 'GalleryFolder' }
  & Pick<Types.GalleryFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GalleryImage_Fragment = (
  { __typename?: 'GalleryImage' }
  & Pick<Types.GalleryImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GalleryParametersTemplate_Fragment = (
  { __typename?: 'GalleryParametersTemplate' }
  & Pick<Types.GalleryParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GalleryVideo_Fragment = (
  { __typename?: 'GalleryVideo' }
  & Pick<Types.GalleryVideo, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GatedAccordionContainer_Fragment = (
  { __typename?: 'GatedAccordionContainer' }
  & Pick<Types.GatedAccordionContainer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GlobalLanguageSelector_Fragment = (
  { __typename?: 'GlobalLanguageSelector' }
  & Pick<Types.GlobalLanguageSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GlobalNavigationBar_Fragment = (
  { __typename?: 'GlobalNavigationBar' }
  & Pick<Types.GlobalNavigationBar, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GoogleAnalytics_Fragment = (
  { __typename?: 'GoogleAnalytics' }
  & Pick<Types.GoogleAnalytics, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GoogleTagManager_Fragment = (
  { __typename?: 'GoogleTagManager' }
  & Pick<Types.GoogleTagManager, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GoogleTagManagerFolder_Fragment = (
  { __typename?: 'GoogleTagManagerFolder' }
  & Pick<Types.GoogleTagManagerFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GridSetup_Fragment = (
  { __typename?: 'GridSetup' }
  & Pick<Types.GridSetup, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_GridTheme_Fragment = (
  { __typename?: 'GridTheme' }
  & Pick<Types.GridTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlCode_Fragment = (
  { __typename?: 'HTMLCode' }
  & Pick<Types.HtmlCode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlCodeFolder_Fragment = (
  { __typename?: 'HTMLCodeFolder' }
  & Pick<Types.HtmlCodeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlInclude_Fragment = (
  { __typename?: 'HTMLInclude' }
  & Pick<Types.HtmlInclude, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlIncludesFolder_Fragment = (
  { __typename?: 'HTMLIncludesFolder' }
  & Pick<Types.HtmlIncludesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlSnippet_Fragment = (
  { __typename?: 'HTMLSnippet' }
  & Pick<Types.HtmlSnippet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlSnippetFolder_Fragment = (
  { __typename?: 'HTMLSnippetFolder' }
  & Pick<Types.HtmlSnippetFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HtmlTag_Fragment = (
  { __typename?: 'HTMLTag' }
  & Pick<Types.HtmlTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Header_Fragment = (
  { __typename?: 'Header' }
  & Pick<Types.Header, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeaderFolder_Fragment = (
  { __typename?: 'HeaderFolder' }
  & Pick<Types.HeaderFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Heading_Fragment = (
  { __typename?: 'Heading' }
  & Pick<Types.Heading, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSiteSetupRoot_Fragment = (
  { __typename?: 'HeadlessSiteSetupRoot' }
  & Pick<Types.HeadlessSiteSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment = (
  { __typename?: 'HeadlessSite_00d050988bad49e5b65db1e08b03ca1b' }
  & Pick<Types.HeadlessSite_00d050988bad49e5b65db1e08b03ca1b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment = (
  { __typename?: 'HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1' }
  & Pick<Types.HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment = (
  { __typename?: 'HeadlessSite_8ca001453c4b4715959d8a05292ecbc5' }
  & Pick<Types.HeadlessSite_8ca001453c4b4715959d8a05292ecbc5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment = (
  { __typename?: 'HeadlessSite_68ffa40c5aab45548f774742b163f318' }
  & Pick<Types.HeadlessSite_68ffa40c5aab45548f774742b163f318, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment = (
  { __typename?: 'HeadlessSite_89d464c8c03e4b0287e9a878d95d7149' }
  & Pick<Types.HeadlessSite_89d464c8c03e4b0287e9a878d95d7149, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment = (
  { __typename?: 'HeadlessSite_229484893ca144958b9937167dfb5064' }
  & Pick<Types.HeadlessSite_229484893ca144958b9937167dfb5064, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment = (
  { __typename?: 'HeadlessSite_b28055626acc45a2913a9617398c9730' }
  & Pick<Types.HeadlessSite_B28055626acc45a2913a9617398c9730, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment = (
  { __typename?: 'HeadlessSite_f1cab1661abb450d84d55d938e7699cb' }
  & Pick<Types.HeadlessSite_F1cab1661abb450d84d55d938e7699cb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment = (
  { __typename?: 'HeadlessSite_f3884baa0e1548f59a6d7154a4559604' }
  & Pick<Types.HeadlessSite_F3884baa0e1548f59a6d7154a4559604, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessSolutionTemplateFolder_Fragment = (
  { __typename?: 'HeadlessSolutionTemplateFolder' }
  & Pick<Types.HeadlessSolutionTemplateFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenantSetupRoot_Fragment = (
  { __typename?: 'HeadlessTenantSetupRoot' }
  & Pick<Types.HeadlessTenantSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment = (
  { __typename?: 'HeadlessTenant_07248c4700af499eb2a9cb7789f72372' }
  & Pick<Types.HeadlessTenant_07248c4700af499eb2a9cb7789f72372, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment = (
  { __typename?: 'HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8' }
  & Pick<Types.HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment = (
  { __typename?: 'HeadlessTenant_5d72df6049c74324969205b55767ad7b' }
  & Pick<Types.HeadlessTenant_5d72df6049c74324969205b55767ad7b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment = (
  { __typename?: 'HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3' }
  & Pick<Types.HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment = (
  { __typename?: 'HeadlessTenant_77a403a2094e48afafa60943d349d23d' }
  & Pick<Types.HeadlessTenant_77a403a2094e48afafa60943d349d23d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment = (
  { __typename?: 'HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2' }
  & Pick<Types.HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment = (
  { __typename?: 'HeadlessTenant_94824ac390d748499e5af0275d10811f' }
  & Pick<Types.HeadlessTenant_94824ac390d748499e5af0275d10811f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment = (
  { __typename?: 'HeadlessTenant_4797571864fd40929cf2412c39757ec3' }
  & Pick<Types.HeadlessTenant_4797571864fd40929cf2412c39757ec3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment = (
  { __typename?: 'HeadlessTenant_c102fb48f40f49fb9c21f8e3e1b0c107' }
  & Pick<Types.HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessTrustSite_Fragment = (
  { __typename?: 'HeadlessTrustSite' }
  & Pick<Types.HeadlessTrustSite, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessVariants_Fragment = (
  { __typename?: 'HeadlessVariants' }
  & Pick<Types.HeadlessVariants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeadlessVariantsGrouping_Fragment = (
  { __typename?: 'HeadlessVariantsGrouping' }
  & Pick<Types.HeadlessVariantsGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticlePage_Fragment = (
  { __typename?: 'HelpArticlePage' }
  & Pick<Types.HelpArticlePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticlePlatform_Fragment = (
  { __typename?: 'HelpArticlePlatform' }
  & Pick<Types.HelpArticlePlatform, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticlePlatformMap_Fragment = (
  { __typename?: 'HelpArticlePlatformMap' }
  & Pick<Types.HelpArticlePlatformMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticlePlatformMappings_Fragment = (
  { __typename?: 'HelpArticlePlatformMappings' }
  & Pick<Types.HelpArticlePlatformMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticlePlatformsFolder_Fragment = (
  { __typename?: 'HelpArticlePlatformsFolder' }
  & Pick<Types.HelpArticlePlatformsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticleSearchPage_Fragment = (
  { __typename?: 'HelpArticleSearchPage' }
  & Pick<Types.HelpArticleSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment = (
  { __typename?: 'HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77' }
  & Pick<Types.HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticleTag_Fragment = (
  { __typename?: 'HelpArticleTag' }
  & Pick<Types.HelpArticleTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticleTagsFolder_Fragment = (
  { __typename?: 'HelpArticleTagsFolder' }
  & Pick<Types.HelpArticleTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticleWildcardPage_Fragment = (
  { __typename?: 'HelpArticleWildcardPage' }
  & Pick<Types.HelpArticleWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment = (
  { __typename?: 'HelpArticleWildcardPage_e4e2d58c853341deaa6b2a2a136421c4' }
  & Pick<Types.HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpArticlesGroupFolder_Fragment = (
  { __typename?: 'HelpArticlesGroupFolder' }
  & Pick<Types.HelpArticlesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpTagMap_Fragment = (
  { __typename?: 'HelpTagMap' }
  & Pick<Types.HelpTagMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HelpTagMappings_Fragment = (
  { __typename?: 'HelpTagMappings' }
  & Pick<Types.HelpTagMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HeroBanner_Fragment = (
  { __typename?: 'HeroBanner' }
  & Pick<Types.HeroBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Highlight_Fragment = (
  { __typename?: 'Highlight' }
  & Pick<Types.Highlight, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HighlightBlock_Fragment = (
  { __typename?: 'HighlightBlock' }
  & Pick<Types.HighlightBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HighlightBlockFolder_Fragment = (
  { __typename?: 'HighlightBlockFolder' }
  & Pick<Types.HighlightBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HighlightBlockParametersTemplate_Fragment = (
  { __typename?: 'HighlightBlockParametersTemplate' }
  & Pick<Types.HighlightBlockParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HighlightFolder_Fragment = (
  { __typename?: 'HighlightFolder' }
  & Pick<Types.HighlightFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HighlightItem_Fragment = (
  { __typename?: 'HighlightItem' }
  & Pick<Types.HighlightItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HighlightParametersTemplate_Fragment = (
  { __typename?: 'HighlightParametersTemplate' }
  & Pick<Types.HighlightParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Home_Fragment = (
  { __typename?: 'Home' }
  & Pick<Types.Home, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HomePage_Fragment = (
  { __typename?: 'HomePage' }
  & Pick<Types.HomePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HomePage_0d3963a8171d4080b5f808618578b631_Fragment = (
  { __typename?: 'HomePage_0d3963a8171d4080b5f808618578b631' }
  & Pick<Types.HomePage_0d3963a8171d4080b5f808618578b631, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment = (
  { __typename?: 'HomePage_6d95c7d946c74a70be07304cc73a2010' }
  & Pick<Types.HomePage_6d95c7d946c74a70be07304cc73a2010, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment = (
  { __typename?: 'HomePage_b407f259b4e34c7db9a06e8907a56b17' }
  & Pick<Types.HomePage_B407f259b4e34c7db9a06e8907a56b17, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HomePage_Cde13c51062d426b95569e8202edc963_Fragment = (
  { __typename?: 'HomePage_cde13c51062d426b95569e8202edc963' }
  & Pick<Types.HomePage_Cde13c51062d426b95569e8202edc963, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment = (
  { __typename?: 'HomePage_de9353283a3e41c495ba386aed0540c6' }
  & Pick<Types.HomePage_De9353283a3e41c495ba386aed0540c6, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IFrame_Fragment = (
  { __typename?: 'IFrame' }
  & Pick<Types.IFrame, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IFrameFolder_Fragment = (
  { __typename?: 'IFrameFolder' }
  & Pick<Types.IFrameFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment = (
  { __typename?: 'IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2' }
  & Pick<Types.IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IFrameParametersTemplate_Fragment = (
  { __typename?: 'IFrameParametersTemplate' }
  & Pick<Types.IFrameParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment = (
  { __typename?: 'IFrame_0da12d476de24dfeb4d0f513489bfea1' }
  & Pick<Types.IFrame_0da12d476de24dfeb4d0f513489bfea1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment = (
  { __typename?: 'IFrame_88a6f65f2b78491bb3770b06e48883e1' }
  & Pick<Types.IFrame_88a6f65f2b78491bb3770b06e48883e1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Icon_Fragment = (
  { __typename?: 'Icon' }
  & Pick<Types.Icon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IconFolder_Fragment = (
  { __typename?: 'IconFolder' }
  & Pick<Types.IconFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Image_Fragment = (
  { __typename?: 'Image' }
  & Pick<Types.Image, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ImageFolder_Fragment = (
  { __typename?: 'ImageFolder' }
  & Pick<Types.ImageFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment = (
  { __typename?: 'ImageFolder_edc00e86cef24d0cbfa264460becc323' }
  & Pick<Types.ImageFolder_Edc00e86cef24d0cbfa264460becc323, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment = (
  { __typename?: 'ImageFolder_f7a4527687f14ea5bf25e3c7cb7aa993' }
  & Pick<Types.ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ImageParametersTemplate_Fragment = (
  { __typename?: 'ImageParametersTemplate' }
  & Pick<Types.ImageParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Image_83bc563c6320490092f8204bff81586a_Fragment = (
  { __typename?: 'Image_83bc563c6320490092f8204bff81586a' }
  & Pick<Types.Image_83bc563c6320490092f8204bff81586a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Image_15185b0e641844499f934ff03b7ee032_Fragment = (
  { __typename?: 'Image_15185b0e641844499f934ff03b7ee032' }
  & Pick<Types.Image_15185b0e641844499f934ff03b7ee032, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Image_D885df8cb2d64007b34b2bbafb527304_Fragment = (
  { __typename?: 'Image_d885df8cb2d64007b34b2bbafb527304' }
  & Pick<Types.Image_D885df8cb2d64007b34b2bbafb527304, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Infographics_Fragment = (
  { __typename?: 'Infographics' }
  & Pick<Types.Infographics, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InfographicsFolder_Fragment = (
  { __typename?: 'InfographicsFolder' }
  & Pick<Types.InfographicsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InputValidationStep_Fragment = (
  { __typename?: 'InputValidationStep' }
  & Pick<Types.InputValidationStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment = (
  { __typename?: 'InputValidationStep_088928cf558e40ec87f3342aa9e66757' }
  & Pick<Types.InputValidationStep_088928cf558e40ec87f3342aa9e66757, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment = (
  { __typename?: 'InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593' }
  & Pick<Types.InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment = (
  { __typename?: 'InputValidationStep_d028fef2babf4ad1bbe74d62a977992f' }
  & Pick<Types.InputValidationStep_D028fef2babf4ad1bbe74d62a977992f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IntegerFacet_Fragment = (
  { __typename?: 'IntegerFacet' }
  & Pick<Types.IntegerFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IntroCopy_Fragment = (
  { __typename?: 'IntroCopy' }
  & Pick<Types.IntroCopy, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_IntroCopyFolder_Fragment = (
  { __typename?: 'IntroCopyFolder' }
  & Pick<Types.IntroCopyFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustAssetClass_Fragment = (
  { __typename?: 'InvestmentTrustAssetClass' }
  & Pick<Types.InvestmentTrustAssetClass, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustAssetClassFolder_Fragment = (
  { __typename?: 'InvestmentTrustAssetClassFolder' }
  & Pick<Types.InvestmentTrustAssetClassFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment = (
  { __typename?: 'InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73' }
  & Pick<Types.InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment = (
  { __typename?: 'InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb' }
  & Pick<Types.InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustRegion_Fragment = (
  { __typename?: 'InvestmentTrustRegion' }
  & Pick<Types.InvestmentTrustRegion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustRegionFolder_Fragment = (
  { __typename?: 'InvestmentTrustRegionFolder' }
  & Pick<Types.InvestmentTrustRegionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustStyle_Fragment = (
  { __typename?: 'InvestmentTrustStyle' }
  & Pick<Types.InvestmentTrustStyle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestmentTrustStyleFolder_Fragment = (
  { __typename?: 'InvestmentTrustStyleFolder' }
  & Pick<Types.InvestmentTrustStyleFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestorType_Fragment = (
  { __typename?: 'InvestorType' }
  & Pick<Types.InvestorType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_InvestorTypesFolder_Fragment = (
  { __typename?: 'InvestorTypesFolder' }
  & Pick<Types.InvestorTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ItemQueriesFolder_Fragment = (
  { __typename?: 'ItemQueriesFolder' }
  & Pick<Types.ItemQueriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ItemRights_Fragment = (
  { __typename?: 'ItemRights' }
  & Pick<Types.ItemRights, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsBeaconSettings_Fragment = (
  { __typename?: 'JSBeaconSettings' }
  & Pick<Types.JsBeaconSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonCheckbox_Fragment = (
  { __typename?: 'JSONCheckbox' }
  & Pick<Types.JsonCheckbox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonContent_Fragment = (
  { __typename?: 'JSONContent' }
  & Pick<Types.JsonContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonDate_Fragment = (
  { __typename?: 'JSONDate' }
  & Pick<Types.JsonDate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonFile_Fragment = (
  { __typename?: 'JSONFile' }
  & Pick<Types.JsonFile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonImage_Fragment = (
  { __typename?: 'JSONImage' }
  & Pick<Types.JsonImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonLayout_Fragment = (
  { __typename?: 'JSONLayout' }
  & Pick<Types.JsonLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonList_Fragment = (
  { __typename?: 'JSONList' }
  & Pick<Types.JsonList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonMultilistReference_Fragment = (
  { __typename?: 'JSONMultilistReference' }
  & Pick<Types.JsonMultilistReference, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonPlaceholder_Fragment = (
  { __typename?: 'JSONPlaceholder' }
  & Pick<Types.JsonPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonQuery_Fragment = (
  { __typename?: 'JSONQuery' }
  & Pick<Types.JsonQuery, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonResults_Fragment = (
  { __typename?: 'JSONResults' }
  & Pick<Types.JsonResults, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonRichText_Fragment = (
  { __typename?: 'JSONRichText' }
  & Pick<Types.JsonRichText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonScriban_Fragment = (
  { __typename?: 'JSONScriban' }
  & Pick<Types.JsonScriban, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonSection_Fragment = (
  { __typename?: 'JSONSection' }
  & Pick<Types.JsonSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonTemplate_Fragment = (
  { __typename?: 'JSONTemplate' }
  & Pick<Types.JsonTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonText_Fragment = (
  { __typename?: 'JSONText' }
  & Pick<Types.JsonText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonToken_Fragment = (
  { __typename?: 'JSONToken' }
  & Pick<Types.JsonToken, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonVariantDefinition_Fragment = (
  { __typename?: 'JSONVariantDefinition' }
  & Pick<Types.JsonVariantDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonVariants_Fragment = (
  { __typename?: 'JSONVariants' }
  & Pick<Types.JsonVariants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssLayout_Fragment = (
  { __typename?: 'JSSLayout' }
  & Pick<Types.JssLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment = (
  { __typename?: 'JSSSettings_1a6fb678eca242c09ae77a9e7f72a6d0' }
  & Pick<Types.JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment = (
  { __typename?: 'JSSSettings_6b328292f8314ab79885d89a054ca10a' }
  & Pick<Types.JssSettings_6b328292f8314ab79885d89a054ca10a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment = (
  { __typename?: 'JSSSettings_457c9d0b61b84adfaf7f82561ed275ff' }
  & Pick<Types.JssSettings_457c9d0b61b84adfaf7f82561ed275ff, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment = (
  { __typename?: 'JSSSettings_5045bf85d2ea430b9f41c2e348436e5d' }
  & Pick<Types.JssSettings_5045bf85d2ea430b9f41c2e348436e5d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment = (
  { __typename?: 'JSSSettings_a767f80d5ad44bfbb8b750a8da144cb5' }
  & Pick<Types.JssSettings_A767f80d5ad44bfbb8b750a8da144cb5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment = (
  { __typename?: 'JSSSettings_b001fd725bb1476496825a8cb9e995cd' }
  & Pick<Types.JssSettings_B001fd725bb1476496825a8cb9e995cd, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment = (
  { __typename?: 'JSSSettings_c643bc8630d14d61a173c7870f5dbbad' }
  & Pick<Types.JssSettings_C643bc8630d14d61a173c7870f5dbbad, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment = (
  { __typename?: 'JSSSettings_ce3dfd340df34b2d8715e54f85dfcce2' }
  & Pick<Types.JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment = (
  { __typename?: 'JSSSettings_ef855d0ba8b04a8e87851d1298266d90' }
  & Pick<Types.JssSettings_Ef855d0ba8b04a8e87851d1298266d90, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssSiteGrouping_Fragment = (
  { __typename?: 'JSSSiteGrouping' }
  & Pick<Types.JssSiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JssTenantFolder_Fragment = (
  { __typename?: 'JSSTenantFolder' }
  & Pick<Types.JssTenantFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JavaScriptRendering_Fragment = (
  { __typename?: 'JavaScriptRendering' }
  & Pick<Types.JavaScriptRendering, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JsonRendering_Fragment = (
  { __typename?: 'JsonRendering' }
  & Pick<Types.JsonRendering, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JurisdictionStatus_Fragment = (
  { __typename?: 'JurisdictionStatus' }
  & Pick<Types.JurisdictionStatus, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_JurisdictionsFolder_Fragment = (
  { __typename?: 'JurisdictionsFolder' }
  & Pick<Types.JurisdictionsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_KeyHighlightItem_Fragment = (
  { __typename?: 'KeyHighlightItem' }
  & Pick<Types.KeyHighlightItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_KeyHighlights_Fragment = (
  { __typename?: 'KeyHighlights' }
  & Pick<Types.KeyHighlights, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_KeyHighlightsFolder_Fragment = (
  { __typename?: 'KeyHighlightsFolder' }
  & Pick<Types.KeyHighlightsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_KeyHighlightsParametersTemplate_Fragment = (
  { __typename?: 'KeyHighlightsParametersTemplate' }
  & Pick<Types.KeyHighlightsParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Language_Fragment = (
  { __typename?: 'Language' }
  & Pick<Types.Language, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LanguageSelector_Fragment = (
  { __typename?: 'LanguageSelector' }
  & Pick<Types.LanguageSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LanguagesFolder_Fragment = (
  { __typename?: 'LanguagesFolder' }
  & Pick<Types.LanguagesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LatestPressReleasesParametersTemplate_Fragment = (
  { __typename?: 'LatestPressReleasesParametersTemplate' }
  & Pick<Types.LatestPressReleasesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LayoutServiceVariants_Fragment = (
  { __typename?: 'LayoutServiceVariants' }
  & Pick<Types.LayoutServiceVariants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LimitedDisplayFolder_Fragment = (
  { __typename?: 'LimitedDisplayFolder' }
  & Pick<Types.LimitedDisplayFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LimitedDisplayOption_Fragment = (
  { __typename?: 'LimitedDisplayOption' }
  & Pick<Types.LimitedDisplayOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Link_Fragment = (
  { __typename?: 'Link' }
  & Pick<Types.Link, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinkList_Fragment = (
  { __typename?: 'LinkList' }
  & Pick<Types.LinkList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinkListFolder_Fragment = (
  { __typename?: 'LinkListFolder' }
  & Pick<Types.LinkListFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment = (
  { __typename?: 'LinkListFolder_c237d144647a4afeaa7b1570f3e3f139' }
  & Pick<Types.LinkListFolder_C237d144647a4afeaa7b1570f3e3f139, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment = (
  { __typename?: 'LinkList_33c9207e3b0446068ef54ca99a97c776' }
  & Pick<Types.LinkList_33c9207e3b0446068ef54ca99a97c776, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment = (
  { __typename?: 'LinkList_97a593ad273141dc80bfceb5ef6a33b7' }
  & Pick<Types.LinkList_97a593ad273141dc80bfceb5ef6a33b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment = (
  { __typename?: 'LinkList_f7561ffcc0d8477fb53d2703a4060be1' }
  & Pick<Types.LinkList_F7561ffcc0d8477fb53d2703a4060be1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment = (
  { __typename?: 'Link_68bd1cb5a7624a969ac6cb16ab5882a3' }
  & Pick<Types.Link_68bd1cb5a7624a969ac6cb16ab5882a3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment = (
  { __typename?: 'Link_930f134d56784b35bfd1b77f9d0115f1' }
  & Pick<Types.Link_930f134d56784b35bfd1b77f9d0115f1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment = (
  { __typename?: 'Link_e24e0789a05848bfabb6c69c0e60b6b7' }
  & Pick<Types.Link_E24e0789a05848bfabb6c69c0e60b6b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LinksFolder_Fragment = (
  { __typename?: 'LinksFolder' }
  & Pick<Types.LinksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_List_Fragment = (
  { __typename?: 'List' }
  & Pick<Types.List, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListFacet_Fragment = (
  { __typename?: 'ListFacet' }
  & Pick<Types.ListFacet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListFolder_Fragment = (
  { __typename?: 'ListFolder' }
  & Pick<Types.ListFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListItem_Fragment = (
  { __typename?: 'ListItem' }
  & Pick<Types.ListItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListParametersTemplate_Fragment = (
  { __typename?: 'ListParametersTemplate' }
  & Pick<Types.ListParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListStyle_Fragment = (
  { __typename?: 'ListStyle' }
  & Pick<Types.ListStyle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListStyleItem_Fragment = (
  { __typename?: 'ListStyleItem' }
  & Pick<Types.ListStyleItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListingHeroBanner_Fragment = (
  { __typename?: 'ListingHeroBanner' }
  & Pick<Types.ListingHeroBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ListingHeroParametersTemplate_Fragment = (
  { __typename?: 'ListingHeroParametersTemplate' }
  & Pick<Types.ListingHeroParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LiteratureAuthorization_Fragment = (
  { __typename?: 'LiteratureAuthorization' }
  & Pick<Types.LiteratureAuthorization, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LiteratureAuthorizationsFolder_Fragment = (
  { __typename?: 'LiteratureAuthorizationsFolder' }
  & Pick<Types.LiteratureAuthorizationsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LiteratureHubSearchPage_Fragment = (
  { __typename?: 'LiteratureHubSearchPage' }
  & Pick<Types.LiteratureHubSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d' }
  & Pick<Types.LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e' }
  & Pick<Types.LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment = (
  { __typename?: 'LiteratureHubSearchPage_d2b2958263564ba8bba5922add46a0ea' }
  & Pick<Types.LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LoadMore_Fragment = (
  { __typename?: 'LoadMore' }
  & Pick<Types.LoadMore, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LoadMoreFolder_Fragment = (
  { __typename?: 'LoadMoreFolder' }
  & Pick<Types.LoadMoreFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment = (
  { __typename?: 'LoadMore_7a3a53e06a0144ff8ba52be46e201fe6' }
  & Pick<Types.LoadMore_7a3a53e06a0144ff8ba52be46e201fe6, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LocationFilter_Fragment = (
  { __typename?: 'LocationFilter' }
  & Pick<Types.LocationFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LocationFilterFolder_Fragment = (
  { __typename?: 'LocationFilterFolder' }
  & Pick<Types.LocationFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment = (
  { __typename?: 'LocationFilter_aaad4aad290744dc90b69e4e83a661ec' }
  & Pick<Types.LocationFilter_Aaad4aad290744dc90b69e4e83a661ec, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Log_Fragment = (
  { __typename?: 'Log' }
  & Pick<Types.Log, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Login_Fragment = (
  { __typename?: 'Login' }
  & Pick<Types.Login, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment = (
  { __typename?: 'Login_abed54dc4f7840ddac562289c9c849d8' }
  & Pick<Types.Login_Abed54dc4f7840ddac562289c9c849d8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LogoTextBlockItem_Fragment = (
  { __typename?: 'LogoTextBlockItem' }
  & Pick<Types.LogoTextBlockItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LogoTextBlocks_Fragment = (
  { __typename?: 'LogoTextBlocks' }
  & Pick<Types.LogoTextBlocks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_LogoTextBlocksFolder_Fragment = (
  { __typename?: 'LogoTextBlocksFolder' }
  & Pick<Types.LogoTextBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Logout_Fragment = (
  { __typename?: 'Logout' }
  & Pick<Types.Logout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment = (
  { __typename?: 'Logout_c2294d8235a6452a94b15eb5e543b602' }
  & Pick<Types.Logout_C2294d8235a6452a94b15eb5e543b602, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ManagedRangeFilter_Fragment = (
  { __typename?: 'ManagedRangeFilter' }
  & Pick<Types.ManagedRangeFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ManagedRangeFilterFolder_Fragment = (
  { __typename?: 'ManagedRangeFilterFolder' }
  & Pick<Types.ManagedRangeFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment = (
  { __typename?: 'ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91' }
  & Pick<Types.ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ManagedRangeItem_Fragment = (
  { __typename?: 'ManagedRangeItem' }
  & Pick<Types.ManagedRangeItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Map_Fragment = (
  { __typename?: 'Map' }
  & Pick<Types.Map, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MapParameters_Fragment = (
  { __typename?: 'MapParameters' }
  & Pick<Types.MapParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MapsFolder_Fragment = (
  { __typename?: 'MapsFolder' }
  & Pick<Types.MapsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MapsProvider_Fragment = (
  { __typename?: 'MapsProvider' }
  & Pick<Types.MapsProvider, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MediaBlock_Fragment = (
  { __typename?: 'MediaBlock' }
  & Pick<Types.MediaBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MediaBlockFolder_Fragment = (
  { __typename?: 'MediaBlockFolder' }
  & Pick<Types.MediaBlockFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MediaBlockParametersTemplate_Fragment = (
  { __typename?: 'MediaBlockParametersTemplate' }
  & Pick<Types.MediaBlockParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment = (
  { __typename?: 'MediaFolder_81150e5837f5443fa3c075e14a9321e7' }
  & Pick<Types.MediaFolder_81150e5837f5443fa3c075e14a9321e7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MediaLinkParameters_Fragment = (
  { __typename?: 'MediaLinkParameters' }
  & Pick<Types.MediaLinkParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MediaVirtualFolder_Fragment = (
  { __typename?: 'MediaVirtualFolder' }
  & Pick<Types.MediaVirtualFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MegaNavigation_Fragment = (
  { __typename?: 'MegaNavigation' }
  & Pick<Types.MegaNavigation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MegaNavigationFolder_Fragment = (
  { __typename?: 'MegaNavigationFolder' }
  & Pick<Types.MegaNavigationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MetaBranding_Fragment = (
  { __typename?: 'MetaBranding' }
  & Pick<Types.MetaBranding, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MetaRenderingParameters_Fragment = (
  { __typename?: 'MetaRenderingParameters' }
  & Pick<Types.MetaRenderingParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MetadataPartialDesign_Fragment = (
  { __typename?: 'MetadataPartialDesign' }
  & Pick<Types.MetadataPartialDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Model_Fragment = (
  { __typename?: 'Model' }
  & Pick<Types.Model, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ModelIterator_Fragment = (
  { __typename?: 'ModelIterator' }
  & Pick<Types.ModelIterator, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_MyLocationPoi_Fragment = (
  { __typename?: 'MyLocationPOI' }
  & Pick<Types.MyLocationPoi, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Navigation_Fragment = (
  { __typename?: 'Navigation' }
  & Pick<Types.Navigation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_NavigationCategory_Fragment = (
  { __typename?: 'NavigationCategory' }
  & Pick<Types.NavigationCategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_NavigationFilter_Fragment = (
  { __typename?: 'NavigationFilter' }
  & Pick<Types.NavigationFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_NavigationFilterFolder_Fragment = (
  { __typename?: 'NavigationFilterFolder' }
  & Pick<Types.NavigationFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_NavigationLink_Fragment = (
  { __typename?: 'NavigationLink' }
  & Pick<Types.NavigationLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_NavigationSubcategory_Fragment = (
  { __typename?: 'NavigationSubcategory' }
  & Pick<Types.NavigationSubcategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment = (
  { __typename?: 'Navigation_9ce34bf95c934dff841d8f649c2bd6c8' }
  & Pick<Types.Navigation_9ce34bf95c934dff841d8f649c2bd6c8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OneTrustSettings_Fragment = (
  { __typename?: 'OneTrustSettings' }
  & Pick<Types.OneTrustSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OptimiserConfiguration_Fragment = (
  { __typename?: 'OptimiserConfiguration' }
  & Pick<Types.OptimiserConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OptimiserConfigurationSection_Fragment = (
  { __typename?: 'OptimiserConfigurationSection' }
  & Pick<Types.OptimiserConfigurationSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OptimizedFile_Fragment = (
  { __typename?: 'OptimizedFile' }
  & Pick<Types.OptimizedFile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OracleCdpSettings_Fragment = (
  { __typename?: 'OracleCDPSettings' }
  & Pick<Types.OracleCdpSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OverlayContent_Fragment = (
  { __typename?: 'OverlayContent' }
  & Pick<Types.OverlayContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OverlayFolderTemplate_Fragment = (
  { __typename?: 'OverlayFolderTemplate' }
  & Pick<Types.OverlayFolderTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Ownership_Fragment = (
  { __typename?: 'Ownership' }
  & Pick<Types.Ownership, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_OwnershipFolder_Fragment = (
  { __typename?: 'OwnershipFolder' }
  & Pick<Types.OwnershipFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Poi_Fragment = (
  { __typename?: 'POI' }
  & Pick<Types.Poi, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PoiFolder_Fragment = (
  { __typename?: 'POIFolder' }
  & Pick<Types.PoiFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PoiType_Fragment = (
  { __typename?: 'POIType' }
  & Pick<Types.PoiType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PoIs_Fragment = (
  { __typename?: 'POIs' }
  & Pick<Types.PoIs, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageBranchesFolder_Fragment = (
  { __typename?: 'PageBranchesFolder' }
  & Pick<Types.PageBranchesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageContent_Fragment = (
  { __typename?: 'PageContent' }
  & Pick<Types.PageContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageContentFolder_Fragment = (
  { __typename?: 'PageContentFolder' }
  & Pick<Types.PageContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment = (
  { __typename?: 'PageContent_ef87e73bc7ff49a2ac599b0be83755c3' }
  & Pick<Types.PageContent_Ef87e73bc7ff49a2ac599b0be83755c3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesign_Fragment = (
  { __typename?: 'PageDesign' }
  & Pick<Types.PageDesign, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment = (
  { __typename?: 'PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0' }
  & Pick<Types.PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment = (
  { __typename?: 'PageDesignFolder_27d4f8be63b045769a4ef3163c935b47' }
  & Pick<Types.PageDesignFolder_27d4f8be63b045769a4ef3163c935b47, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment = (
  { __typename?: 'PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8' }
  & Pick<Types.PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment = (
  { __typename?: 'PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b' }
  & Pick<Types.PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment = (
  { __typename?: 'PageDesignFolder_720d01f11e5046fa9c4a697f9321f662' }
  & Pick<Types.PageDesignFolder_720d01f11e5046fa9c4a697f9321f662, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment = (
  { __typename?: 'PageDesignFolder_771a0de7e83f44338c5d78727ead93bc' }
  & Pick<Types.PageDesignFolder_771a0de7e83f44338c5d78727ead93bc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment = (
  { __typename?: 'PageDesignFolder_14161ec204984aa7a2a46decadf669f5' }
  & Pick<Types.PageDesignFolder_14161ec204984aa7a2a46decadf669f5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment = (
  { __typename?: 'PageDesignFolder_c691c2c4e0dd4fedb84a3c29de7002cb' }
  & Pick<Types.PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment = (
  { __typename?: 'PageDesignFolder_d84605f786ea482da6ff683f6572821c' }
  & Pick<Types.PageDesignFolder_D84605f786ea482da6ff683f6572821c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment = (
  { __typename?: 'PageDesign_1105b8f81e00426bbf1fc840742d827b' }
  & Pick<Types.PageDesign_1105b8f81e00426bbf1fc840742d827b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_Fragment = (
  { __typename?: 'PageDesigns' }
  & Pick<Types.PageDesigns, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment = (
  { __typename?: 'PageDesigns_3af52e70e982424b9c85e355542500c9' }
  & Pick<Types.PageDesigns_3af52e70e982424b9c85e355542500c9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment = (
  { __typename?: 'PageDesigns_9b34083e890b467d8e76b8c3dbbb712d' }
  & Pick<Types.PageDesigns_9b34083e890b467d8e76b8c3dbbb712d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment = (
  { __typename?: 'PageDesigns_48d2d50a150c4f6283603a4fed5646e0' }
  & Pick<Types.PageDesigns_48d2d50a150c4f6283603a4fed5646e0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment = (
  { __typename?: 'PageDesigns_99a71bba507746729c3fb29b04abee23' }
  & Pick<Types.PageDesigns_99a71bba507746729c3fb29b04abee23, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment = (
  { __typename?: 'PageDesigns_a0f265b42d6241968b65d3ede7cb59c3' }
  & Pick<Types.PageDesigns_A0f265b42d6241968b65d3ede7cb59c3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment = (
  { __typename?: 'PageDesigns_abe5ce6a82ff4433b4973bc50f192e11' }
  & Pick<Types.PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment = (
  { __typename?: 'PageDesigns_b8d9b352c1694b31bd506848b47ca884' }
  & Pick<Types.PageDesigns_B8d9b352c1694b31bd506848b47ca884, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment = (
  { __typename?: 'PageDesigns_d3b2e1466f744df0900bec314f699ef3' }
  & Pick<Types.PageDesigns_D3b2e1466f744df0900bec314f699ef3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment = (
  { __typename?: 'PageDesigns_fd4b9b54f7474f01abdeba569d4b5bbe' }
  & Pick<Types.PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageLevelTabs_Fragment = (
  { __typename?: 'PageLevelTabs' }
  & Pick<Types.PageLevelTabs, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageLevelTabsFolder_Fragment = (
  { __typename?: 'PageLevelTabsFolder' }
  & Pick<Types.PageLevelTabsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageList_Fragment = (
  { __typename?: 'PageList' }
  & Pick<Types.PageList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSelector_Fragment = (
  { __typename?: 'PageSelector' }
  & Pick<Types.PageSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSelectorConfiguration_Fragment = (
  { __typename?: 'PageSelectorConfiguration' }
  & Pick<Types.PageSelectorConfiguration, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSelectorFolder_Fragment = (
  { __typename?: 'PageSelectorFolder' }
  & Pick<Types.PageSelectorFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment = (
  { __typename?: 'PageSelector_59a7bb775f8c435ab810291abde80e63' }
  & Pick<Types.PageSelector_59a7bb775f8c435ab810291abde80e63, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSize_Fragment = (
  { __typename?: 'PageSize' }
  & Pick<Types.PageSize, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSizeFolder_Fragment = (
  { __typename?: 'PageSizeFolder' }
  & Pick<Types.PageSizeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment = (
  { __typename?: 'PageSize_b682562e0af64b3e9e3b45273bbe152d' }
  & Pick<Types.PageSize_B682562e0af64b3e9e3b45273bbe152d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageTheme_Fragment = (
  { __typename?: 'PageTheme' }
  & Pick<Types.PageTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PageThemesFolder_Fragment = (
  { __typename?: 'PageThemesFolder' }
  & Pick<Types.PageThemesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_4f49a81db3664f198b89cab92f377d7a_Fragment = (
  { __typename?: 'Page_4f49a81db3664f198b89cab92f377d7a' }
  & Pick<Types.Page_4f49a81db3664f198b89cab92f377d7a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_5e66d86353544fe6a27d3b894984d50f_Fragment = (
  { __typename?: 'Page_5e66d86353544fe6a27d3b894984d50f' }
  & Pick<Types.Page_5e66d86353544fe6a27d3b894984d50f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment = (
  { __typename?: 'Page_84f342ad2d0646b9aa9a818201145ca2' }
  & Pick<Types.Page_84f342ad2d0646b9aa9a818201145ca2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_718df200be51463d93edf4d77ab7a49e_Fragment = (
  { __typename?: 'Page_718df200be51463d93edf4d77ab7a49e' }
  & Pick<Types.Page_718df200be51463d93edf4d77ab7a49e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment = (
  { __typename?: 'Page_b61d5babe46f4ef39f27b57c4ccefdf7' }
  & Pick<Types.Page_B61d5babe46f4ef39f27b57c4ccefdf7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment = (
  { __typename?: 'Page_cfd6e04697e24f3cb9eb41b79afc35dc' }
  & Pick<Types.Page_Cfd6e04697e24f3cb9eb41b79afc35dc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment = (
  { __typename?: 'Page_dae7821153e14dbabb0ddf0b53a90aaf' }
  & Pick<Types.Page_Dae7821153e14dbabb0ddf0b53a90aaf, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Page_Fa608b3e6aeb426388a059d89caabada_Fragment = (
  { __typename?: 'Page_fa608b3e6aeb426388a059d89caabada' }
  & Pick<Types.Page_Fa608b3e6aeb426388a059d89caabada, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Pagging_Fragment = (
  { __typename?: 'Pagging' }
  & Pick<Types.Pagging, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Pagination_Fragment = (
  { __typename?: 'Pagination' }
  & Pick<Types.Pagination, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PaginationFolder_Fragment = (
  { __typename?: 'PaginationFolder' }
  & Pick<Types.PaginationFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Paragraph_Fragment = (
  { __typename?: 'Paragraph' }
  & Pick<Types.Paragraph, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment = (
  { __typename?: 'PartialDesignFolder_8cf20a4412b746ee801218122c955b2d' }
  & Pick<Types.PartialDesignFolder_8cf20a4412b746ee801218122c955b2d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment = (
  { __typename?: 'PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b' }
  & Pick<Types.PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment = (
  { __typename?: 'PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8' }
  & Pick<Types.PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment = (
  { __typename?: 'PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b' }
  & Pick<Types.PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment = (
  { __typename?: 'PartialDesignFolder_828b5ff144cd4150bcdfe54084165112' }
  & Pick<Types.PartialDesignFolder_828b5ff144cd4150bcdfe54084165112, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment = (
  { __typename?: 'PartialDesignFolder_89098e3089aa4062a77346d608caac90' }
  & Pick<Types.PartialDesignFolder_89098e3089aa4062a77346d608caac90, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment = (
  { __typename?: 'PartialDesignFolder_1695576fb93647d7842ed17730278c32' }
  & Pick<Types.PartialDesignFolder_1695576fb93647d7842ed17730278c32, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment = (
  { __typename?: 'PartialDesignFolder_f16ae56fb78845639407c88edaffcbcc' }
  & Pick<Types.PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment = (
  { __typename?: 'PartialDesignFolder_fb58558a3ec946d18524cd30805ab21a' }
  & Pick<Types.PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment = (
  { __typename?: 'PartialDesign_fd2059fd60434dfe8c04e2437ce87634' }
  & Pick<Types.PartialDesign_Fd2059fd60434dfe8c04e2437ce87634, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_Fragment = (
  { __typename?: 'PartialDesigns' }
  & Pick<Types.PartialDesigns, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment = (
  { __typename?: 'PartialDesigns_043d3ad0ac4445dba03afc3550d088ec' }
  & Pick<Types.PartialDesigns_043d3ad0ac4445dba03afc3550d088ec, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment = (
  { __typename?: 'PartialDesigns_0310a4bf20d1441c886a0418c53e30f4' }
  & Pick<Types.PartialDesigns_0310a4bf20d1441c886a0418c53e30f4, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment = (
  { __typename?: 'PartialDesigns_36c869ded22040929ce829f6ed643c66' }
  & Pick<Types.PartialDesigns_36c869ded22040929ce829f6ed643c66, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment = (
  { __typename?: 'PartialDesigns_1943dc73710a430895515a342c84b037' }
  & Pick<Types.PartialDesigns_1943dc73710a430895515a342c84b037, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment = (
  { __typename?: 'PartialDesigns_b1e2a6790a1442d8bafa66317b8be117' }
  & Pick<Types.PartialDesigns_B1e2a6790a1442d8bafa66317b8be117, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment = (
  { __typename?: 'PartialDesigns_cc6d8635f3e2440ab8ebb93dc1030e9e' }
  & Pick<Types.PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment = (
  { __typename?: 'PartialDesigns_d52704ed3b704a53abb4292105f687ad' }
  & Pick<Types.PartialDesigns_D52704ed3b704a53abb4292105f687ad, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment = (
  { __typename?: 'PartialDesigns_d216303f58d8425688da8cd30d00afab' }
  & Pick<Types.PartialDesigns_D216303f58d8425688da8cd30d00afab, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment = (
  { __typename?: 'PartialDesigns_facda26791204fa9a0363344348f2c42' }
  & Pick<Types.PartialDesigns_Facda26791204fa9a0363344348f2c42, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PerformanceChartSettings_Fragment = (
  { __typename?: 'PerformanceChartSettings' }
  & Pick<Types.PerformanceChartSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PerformanceChartTimePeriod_Fragment = (
  { __typename?: 'PerformanceChartTimePeriod' }
  & Pick<Types.PerformanceChartTimePeriod, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PerformanceChartTimePeriodFolder_Fragment = (
  { __typename?: 'PerformanceChartTimePeriodFolder' }
  & Pick<Types.PerformanceChartTimePeriodFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80' }
  & Pick<Types.PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d' }
  & Pick<Types.PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment = (
  { __typename?: 'PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba' }
  & Pick<Types.PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment = (
  { __typename?: 'Placeholder_1ca0304be5b64810821154426f1752c2' }
  & Pick<Types.Placeholder_1ca0304be5b64810821154426f1752c2, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment = (
  { __typename?: 'Placeholder_d2a6884c04d54089a64ed27ca9d68d4c' }
  & Pick<Types.Placeholder_D2a6884c04d54089a64ed27ca9d68d4c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PlainHtmlParametersTemplate_Fragment = (
  { __typename?: 'PlainHtmlParametersTemplate' }
  & Pick<Types.PlainHtmlParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Playlist_Fragment = (
  { __typename?: 'Playlist' }
  & Pick<Types.Playlist, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PlaylistFolder_Fragment = (
  { __typename?: 'PlaylistFolder' }
  & Pick<Types.PlaylistFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PlaylistParametersTemplate_Fragment = (
  { __typename?: 'PlaylistParametersTemplate' }
  & Pick<Types.PlaylistParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Podcast_Fragment = (
  { __typename?: 'Podcast' }
  & Pick<Types.Podcast, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PodcastFolder_Fragment = (
  { __typename?: 'PodcastFolder' }
  & Pick<Types.PodcastFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PodcastPage_Fragment = (
  { __typename?: 'PodcastPage' }
  & Pick<Types.PodcastPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PodcastPressReleasePage_Fragment = (
  { __typename?: 'PodcastPressReleasePage' }
  & Pick<Types.PodcastPressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PoiTypes_Fragment = (
  { __typename?: 'PoiTypes' }
  & Pick<Types.PoiTypes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostDeleteStep_Fragment = (
  { __typename?: 'PostDeleteStep' }
  & Pick<Types.PostDeleteStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment = (
  { __typename?: 'PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574' }
  & Pick<Types.PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment = (
  { __typename?: 'PostDeleteStep_78d6ec9b66e34763987003cf314ee37a' }
  & Pick<Types.PostDeleteStep_78d6ec9b66e34763987003cf314ee37a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment = (
  { __typename?: 'PostDeleteStep_b20857895385413883f096f3767cb156' }
  & Pick<Types.PostDeleteStep_B20857895385413883f096f3767cb156, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostSetupStep_Fragment = (
  { __typename?: 'PostSetupStep' }
  & Pick<Types.PostSetupStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment = (
  { __typename?: 'PostSetupStep_6fac654e22154a419a1d59197bebc0fe' }
  & Pick<Types.PostSetupStep_6fac654e22154a419a1d59197bebc0fe, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment = (
  { __typename?: 'PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f' }
  & Pick<Types.PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment = (
  { __typename?: 'PostSetupStep_341738aa44fe490e90ff7010a3c2463b' }
  & Pick<Types.PostSetupStep_341738aa44fe490e90ff7010a3c2463b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteStep_Fragment = (
  { __typename?: 'PreDeleteStep' }
  & Pick<Types.PreDeleteStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment = (
  { __typename?: 'PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49' }
  & Pick<Types.PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment = (
  { __typename?: 'PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b' }
  & Pick<Types.PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment = (
  { __typename?: 'PreDeleteStep_f0daf401190f45468bda8568d08e161d' }
  & Pick<Types.PreDeleteStep_F0daf401190f45468bda8568d08e161d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteValidationStep_Fragment = (
  { __typename?: 'PreDeleteValidationStep' }
  & Pick<Types.PreDeleteValidationStep, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f' }
  & Pick<Types.PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment = (
  { __typename?: 'PreDeleteValidationStep_edf1fa4206c44703ab1af23495bc6d8f' }
  & Pick<Types.PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment = (
  { __typename?: 'PreDeleteValidationStep_f8c52120d0ea4d009de3b49fe12a3f1e' }
  & Pick<Types.PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Presentation_Fragment = (
  { __typename?: 'Presentation' }
  & Pick<Types.Presentation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment = (
  { __typename?: 'Presentation_0a70fa7389234a6eabf34134f25f3221' }
  & Pick<Types.Presentation_0a70fa7389234a6eabf34134f25f3221, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseContentType_Fragment = (
  { __typename?: 'PressReleaseContentType' }
  & Pick<Types.PressReleaseContentType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseContentTypesFolder_Fragment = (
  { __typename?: 'PressReleaseContentTypesFolder' }
  & Pick<Types.PressReleaseContentTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseFilter_Fragment = (
  { __typename?: 'PressReleaseFilter' }
  & Pick<Types.PressReleaseFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleasePage_Fragment = (
  { __typename?: 'PressReleasePage' }
  & Pick<Types.PressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleasePlatform_Fragment = (
  { __typename?: 'PressReleasePlatform' }
  & Pick<Types.PressReleasePlatform, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleasePlatformsFolder_Fragment = (
  { __typename?: 'PressReleasePlatformsFolder' }
  & Pick<Types.PressReleasePlatformsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseSearchPage_Fragment = (
  { __typename?: 'PressReleaseSearchPage' }
  & Pick<Types.PressReleaseSearchPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment = (
  { __typename?: 'PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f' }
  & Pick<Types.PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment = (
  { __typename?: 'PressReleaseSearchPage_a6c344ca7c6946009de2ca92e27d7b72' }
  & Pick<Types.PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment = (
  { __typename?: 'PressReleaseSearchPage_b9cd16f585ea4405a1ceda10cb20f64d' }
  & Pick<Types.PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment = (
  { __typename?: 'PressReleaseSearchPage_c97027442df647cf9c36eedfc6787f58' }
  & Pick<Types.PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseWildcardPage_Fragment = (
  { __typename?: 'PressReleaseWildcardPage' }
  & Pick<Types.PressReleaseWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e' }
  & Pick<Types.PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79' }
  & Pick<Types.PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_b337d30403c642d2b9757e23d08223a1' }
  & Pick<Types.PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment = (
  { __typename?: 'PressReleaseWildcardPage_e55e9d5bf9614e30b0a2a90327428258' }
  & Pick<Types.PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PressReleasesGroupFolder_Fragment = (
  { __typename?: 'PressReleasesGroupFolder' }
  & Pick<Types.PressReleasesGroupFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PrivacyWarning_Fragment = (
  { __typename?: 'PrivacyWarning' }
  & Pick<Types.PrivacyWarning, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ProjectFolder_Fragment = (
  { __typename?: 'ProjectFolder' }
  & Pick<Types.ProjectFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Promo_Fragment = (
  { __typename?: 'Promo' }
  & Pick<Types.Promo, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PromoFolder_Fragment = (
  { __typename?: 'PromoFolder' }
  & Pick<Types.PromoFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment = (
  { __typename?: 'PromoFolder_f07cbe8973ae4de692172570260cac6e' }
  & Pick<Types.PromoFolder_F07cbe8973ae4de692172570260cac6e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment = (
  { __typename?: 'Promo_7f21f14d096b4f27bbccf115c6e6f6f1' }
  & Pick<Types.Promo_7f21f14d096b4f27bbccf115c6e6f6f1, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment = (
  { __typename?: 'Promo_881869ca7f5845ea8b34ad1bfd3551a8' }
  & Pick<Types.Promo_881869ca7f5845ea8b34ad1bfd3551a8, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment = (
  { __typename?: 'Promo_dfed4457d760457abec1c0dccdc44381' }
  & Pick<Types.Promo_Dfed4457d760457abec1c0dccdc44381, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PromotedContent_Fragment = (
  { __typename?: 'PromotedContent' }
  & Pick<Types.PromotedContent, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PromotedContentFolder_Fragment = (
  { __typename?: 'PromotedContentFolder' }
  & Pick<Types.PromotedContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PropertyListingCard_Fragment = (
  { __typename?: 'PropertyListingCard' }
  & Pick<Types.PropertyListingCard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PropertyListingCards_Fragment = (
  { __typename?: 'PropertyListingCards' }
  & Pick<Types.PropertyListingCards, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PropertyListingCategory_Fragment = (
  { __typename?: 'PropertyListingCategory' }
  & Pick<Types.PropertyListingCategory, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_PropertyListingFolder_Fragment = (
  { __typename?: 'PropertyListingFolder' }
  & Pick<Types.PropertyListingFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Query_98b413525a4b4067b92418a4b50f0a53_Fragment = (
  { __typename?: 'Query_98b413525a4b4067b92418a4b50f0a53' }
  & Pick<Types.Query_98b413525a4b4067b92418a4b50f0a53, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuickLinks_Fragment = (
  { __typename?: 'QuickLinks' }
  & Pick<Types.QuickLinks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuickLinksFolder_Fragment = (
  { __typename?: 'QuickLinksFolder' }
  & Pick<Types.QuickLinksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuickLinksParametersTemplate_Fragment = (
  { __typename?: 'QuickLinksParametersTemplate' }
  & Pick<Types.QuickLinksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuotationBlockItem_Fragment = (
  { __typename?: 'QuotationBlockItem' }
  & Pick<Types.QuotationBlockItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuotationBlocks_Fragment = (
  { __typename?: 'QuotationBlocks' }
  & Pick<Types.QuotationBlocks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuotationBlocksFolder_Fragment = (
  { __typename?: 'QuotationBlocksFolder' }
  & Pick<Types.QuotationBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuotationBlocksParametersTemplate_Fragment = (
  { __typename?: 'QuotationBlocksParametersTemplate' }
  & Pick<Types.QuotationBlocksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Quote_Fragment = (
  { __typename?: 'Quote' }
  & Pick<Types.Quote, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuoteFolder_Fragment = (
  { __typename?: 'QuoteFolder' }
  & Pick<Types.QuoteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_QuoteParametersTemplate_Fragment = (
  { __typename?: 'QuoteParametersTemplate' }
  & Pick<Types.QuoteParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RadiusFilter_Fragment = (
  { __typename?: 'RadiusFilter' }
  & Pick<Types.RadiusFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RadiusFilterFolder_Fragment = (
  { __typename?: 'RadiusFilterFolder' }
  & Pick<Types.RadiusFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment = (
  { __typename?: 'RadiusFilter_de3fa58eef9d45449f77dcd1dbb05b64' }
  & Pick<Types.RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RadiusScheme_Fragment = (
  { __typename?: 'RadiusScheme' }
  & Pick<Types.RadiusScheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RadiusSchemeValue_Fragment = (
  { __typename?: 'RadiusSchemeValue' }
  & Pick<Types.RadiusSchemeValue, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RangeSliderFilter_Fragment = (
  { __typename?: 'RangeSliderFilter' }
  & Pick<Types.RangeSliderFilter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RangeSliderFilterFolder_Fragment = (
  { __typename?: 'RangeSliderFilterFolder' }
  & Pick<Types.RangeSliderFilterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment = (
  { __typename?: 'RangeSliderFilter_0a1787c296b54d40828522564a5d8e03' }
  & Pick<Types.RangeSliderFilter_0a1787c296b54d40828522564a5d8e03, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RecentArticles_Fragment = (
  { __typename?: 'RecentArticles' }
  & Pick<Types.RecentArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Redirect_Fragment = (
  { __typename?: 'Redirect' }
  & Pick<Types.Redirect, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RedirectMap_Fragment = (
  { __typename?: 'RedirectMap' }
  & Pick<Types.RedirectMap, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RedirectMaps_Fragment = (
  { __typename?: 'RedirectMaps' }
  & Pick<Types.RedirectMaps, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Region_Fragment = (
  { __typename?: 'Region' }
  & Pick<Types.Region, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RegionLanguages_Fragment = (
  { __typename?: 'RegionLanguages' }
  & Pick<Types.RegionLanguages, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RegionLanguagesFolder_Fragment = (
  { __typename?: 'RegionLanguagesFolder' }
  & Pick<Types.RegionLanguagesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RelatedArticles_Fragment = (
  { __typename?: 'RelatedArticles' }
  & Pick<Types.RelatedArticles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RelatedArticlesParametersTemplate_Fragment = (
  { __typename?: 'RelatedArticlesParametersTemplate' }
  & Pick<Types.RelatedArticlesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RenderEngineType_Fragment = (
  { __typename?: 'RenderEngineType' }
  & Pick<Types.RenderEngineType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment = (
  { __typename?: 'RenderingFolder_840d4a46550349ecbf9dbd090946c63d' }
  & Pick<Types.RenderingFolder_840d4a46550349ecbf9dbd090946c63d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RenderingHost_Fragment = (
  { __typename?: 'RenderingHost' }
  & Pick<Types.RenderingHost, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResizableIFramePage_Fragment = (
  { __typename?: 'ResizableIFramePage' }
  & Pick<Types.ResizableIFramePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment = (
  { __typename?: 'ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067' }
  & Pick<Types.ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment = (
  { __typename?: 'ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68' }
  & Pick<Types.ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment = (
  { __typename?: 'ResizableIFramePage_b58eacfb27f5417bb536141f94b92521' }
  & Pick<Types.ResizableIFramePage_B58eacfb27f5417bb536141f94b92521, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment = (
  { __typename?: 'ResizableIFramePage_d8d76a2407084147bf3900cd5e12e401' }
  & Pick<Types.ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment = (
  { __typename?: 'ResizableIFramePage_f460ab055585441892023750e7cef6b7' }
  & Pick<Types.ResizableIFramePage_F460ab055585441892023750e7cef6b7, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResponsiveImage_Fragment = (
  { __typename?: 'ResponsiveImage' }
  & Pick<Types.ResponsiveImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResultsCount_Fragment = (
  { __typename?: 'ResultsCount' }
  & Pick<Types.ResultsCount, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResultsCountFolder_Fragment = (
  { __typename?: 'ResultsCountFolder' }
  & Pick<Types.ResultsCountFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment = (
  { __typename?: 'ResultsCount_f3c0661ef9a9444ca26d44bf2a68a186' }
  & Pick<Types.ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ResultsVariantSelector_Fragment = (
  { __typename?: 'ResultsVariantSelector' }
  & Pick<Types.ResultsVariantSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RichText_Fragment = (
  { __typename?: 'RichText' }
  & Pick<Types.RichText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RichTextFolder_Fragment = (
  { __typename?: 'RichTextFolder' }
  & Pick<Types.RichTextFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment = (
  { __typename?: 'RichText_0f3b73366112418c8bbab0526f3887ce' }
  & Pick<Types.RichText_0f3b73366112418c8bbab0526f3887ce, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment = (
  { __typename?: 'RichText_efcfd8f6596745f48f85b5421928205d' }
  & Pick<Types.RichText_Efcfd8f6596745f48f85b5421928205d, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskImageMapping_Fragment = (
  { __typename?: 'RiskImageMapping' }
  & Pick<Types.RiskImageMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskImageMappings_Fragment = (
  { __typename?: 'RiskImageMappings' }
  & Pick<Types.RiskImageMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskLevelOption_Fragment = (
  { __typename?: 'RiskLevelOption' }
  & Pick<Types.RiskLevelOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskLevelOptionFolder_Fragment = (
  { __typename?: 'RiskLevelOptionFolder' }
  & Pick<Types.RiskLevelOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskWarning_Fragment = (
  { __typename?: 'RiskWarning' }
  & Pick<Types.RiskWarning, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskWarningFolder_Fragment = (
  { __typename?: 'RiskWarningFolder' }
  & Pick<Types.RiskWarningFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RiskWarningParametersTemplate_Fragment = (
  { __typename?: 'RiskWarningParametersTemplate' }
  & Pick<Types.RiskWarningParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RolePlaceholder_Fragment = (
  { __typename?: 'RolePlaceholder' }
  & Pick<Types.RolePlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RowSplitter_Fragment = (
  { __typename?: 'RowSplitter' }
  & Pick<Types.RowSplitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment = (
  { __typename?: 'RowSplitter_340c887da1d1415b9678c763af74ea97' }
  & Pick<Types.RowSplitter_340c887da1d1415b9678c763af74ea97, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Rule_Fragment = (
  { __typename?: 'Rule' }
  & Pick<Types.Rule, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SdrLogoMapping_Fragment = (
  { __typename?: 'SDRLogoMapping' }
  & Pick<Types.SdrLogoMapping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SdrLogoMappings_Fragment = (
  { __typename?: 'SDRLogoMappings' }
  & Pick<Types.SdrLogoMappings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SdrTypeOption_Fragment = (
  { __typename?: 'SDRTypeOption' }
  & Pick<Types.SdrTypeOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SdrTypeOptionFolder_Fragment = (
  { __typename?: 'SDRTypeOptionFolder' }
  & Pick<Types.SdrTypeOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SxajssLayout_Fragment = (
  { __typename?: 'SXAJSSLayout' }
  & Pick<Types.SxajssLayout, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SxaRole_Fragment = (
  { __typename?: 'SXARole' }
  & Pick<Types.SxaRole, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SxaStandardValuesFolder_Fragment = (
  { __typename?: 'SXAStandardValuesFolder' }
  & Pick<Types.SxaStandardValuesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceAlertMessage_Fragment = (
  { __typename?: 'SalesforceAlertMessage' }
  & Pick<Types.SalesforceAlertMessage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceCheckBox_Fragment = (
  { __typename?: 'SalesforceCheckBox' }
  & Pick<Types.SalesforceCheckBox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceCheckBoxType_Fragment = (
  { __typename?: 'SalesforceCheckBoxType' }
  & Pick<Types.SalesforceCheckBoxType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceConditionalRadioButton_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButton' }
  & Pick<Types.SalesforceConditionalRadioButton, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceConditionalRadioButtons_Fragment = (
  { __typename?: 'SalesforceConditionalRadioButtons' }
  & Pick<Types.SalesforceConditionalRadioButtons, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceDateInput_Fragment = (
  { __typename?: 'SalesforceDateInput' }
  & Pick<Types.SalesforceDateInput, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceDropdown_Fragment = (
  { __typename?: 'SalesforceDropdown' }
  & Pick<Types.SalesforceDropdown, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceDropdownOption_Fragment = (
  { __typename?: 'SalesforceDropdownOption' }
  & Pick<Types.SalesforceDropdownOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceHiddenField_Fragment = (
  { __typename?: 'SalesforceHiddenField' }
  & Pick<Types.SalesforceHiddenField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceInput_Fragment = (
  { __typename?: 'SalesforceInput' }
  & Pick<Types.SalesforceInput, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceInputType_Fragment = (
  { __typename?: 'SalesforceInputType' }
  & Pick<Types.SalesforceInputType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceIntegratedForm_Fragment = (
  { __typename?: 'SalesforceIntegratedForm' }
  & Pick<Types.SalesforceIntegratedForm, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceIntegratedFormTypesFolder_Fragment = (
  { __typename?: 'SalesforceIntegratedFormTypesFolder' }
  & Pick<Types.SalesforceIntegratedFormTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceRepeatableSubSection_Fragment = (
  { __typename?: 'SalesforceRepeatableSubSection' }
  & Pick<Types.SalesforceRepeatableSubSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceRichTextArea_Fragment = (
  { __typename?: 'SalesforceRichTextArea' }
  & Pick<Types.SalesforceRichTextArea, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceSection_Fragment = (
  { __typename?: 'SalesforceSection' }
  & Pick<Types.SalesforceSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceSortCodeInput_Fragment = (
  { __typename?: 'SalesforceSortCodeInput' }
  & Pick<Types.SalesforceSortCodeInput, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SalesforceSubmissionType_Fragment = (
  { __typename?: 'SalesforceSubmissionType' }
  & Pick<Types.SalesforceSubmissionType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Scope_Fragment = (
  { __typename?: 'Scope' }
  & Pick<Types.Scope, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ScopesFolder_Fragment = (
  { __typename?: 'ScopesFolder' }
  & Pick<Types.ScopesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Scriban_Fragment = (
  { __typename?: 'Scriban' }
  & Pick<Types.Scriban, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Scripts_Fragment = (
  { __typename?: 'Scripts' }
  & Pick<Types.Scripts, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchBox_Fragment = (
  { __typename?: 'SearchBox' }
  & Pick<Types.SearchBox, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchBoxFolder_Fragment = (
  { __typename?: 'SearchBoxFolder' }
  & Pick<Types.SearchBoxFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment = (
  { __typename?: 'SearchBox_1c04fd611d874590acfe9cc186865ab3' }
  & Pick<Types.SearchBox_1c04fd611d874590acfe9cc186865ab3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchFolder_Fragment = (
  { __typename?: 'SearchFolder' }
  & Pick<Types.SearchFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchResults_Fragment = (
  { __typename?: 'SearchResults' }
  & Pick<Types.SearchResults, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchResultsFolder_Fragment = (
  { __typename?: 'SearchResultsFolder' }
  & Pick<Types.SearchResultsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment = (
  { __typename?: 'SearchResults_a06f7130041d46bb8c2995a2dc00c26a' }
  & Pick<Types.SearchResults_A06f7130041d46bb8c2995a2dc00c26a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SecondaryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'SecondaryHeroBannerParametersTemplate' }
  & Pick<Types.SecondaryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionHeading_Fragment = (
  { __typename?: 'SectionHeading' }
  & Pick<Types.SectionHeading, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionHeadingFolder_Fragment = (
  { __typename?: 'SectionHeadingFolder' }
  & Pick<Types.SectionHeadingFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionHeadingParametersTemplate_Fragment = (
  { __typename?: 'SectionHeadingParametersTemplate' }
  & Pick<Types.SectionHeadingParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionHeadingType_Fragment = (
  { __typename?: 'SectionHeadingType' }
  & Pick<Types.SectionHeadingType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionHeadingTypeFolder_Fragment = (
  { __typename?: 'SectionHeadingTypeFolder' }
  & Pick<Types.SectionHeadingTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionSelector_Fragment = (
  { __typename?: 'SectionSelector' }
  & Pick<Types.SectionSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionSelectorFolder_Fragment = (
  { __typename?: 'SectionSelectorFolder' }
  & Pick<Types.SectionSelectorFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SectionSelectorTab_Fragment = (
  { __typename?: 'SectionSelectorTab' }
  & Pick<Types.SectionSelectorTab, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment = (
  { __typename?: 'Security_33077d51ebad4d1cb4a83b79f51dba13' }
  & Pick<Types.Security_33077d51ebad4d1cb4a83b79f51dba13, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Series_Fragment = (
  { __typename?: 'Series' }
  & Pick<Types.Series, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SeriesFolder_Fragment = (
  { __typename?: 'SeriesFolder' }
  & Pick<Types.SeriesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Settings_Fragment = (
  { __typename?: 'Settings' }
  & Pick<Types.Settings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SettingsFolder_Fragment = (
  { __typename?: 'SettingsFolder' }
  & Pick<Types.SettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Settings_6c82caca67dc464195698faad083230e_Fragment = (
  { __typename?: 'Settings_6c82caca67dc464195698faad083230e' }
  & Pick<Types.Settings_6c82caca67dc464195698faad083230e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharePriceSettings_Fragment = (
  { __typename?: 'SharePriceSettings' }
  & Pick<Types.SharePriceSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedArticlesFolder_Fragment = (
  { __typename?: 'SharedArticlesFolder' }
  & Pick<Types.SharedArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedContentFolder_Fragment = (
  { __typename?: 'SharedContentFolder' }
  & Pick<Types.SharedContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedFolder_Fragment = (
  { __typename?: 'SharedFolder' }
  & Pick<Types.SharedFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedHelpArticlesFolder_Fragment = (
  { __typename?: 'SharedHelpArticlesFolder' }
  & Pick<Types.SharedHelpArticlesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedPressReleasesFolder_Fragment = (
  { __typename?: 'SharedPressReleasesFolder' }
  & Pick<Types.SharedPressReleasesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedSettingsFolder_Fragment = (
  { __typename?: 'SharedSettingsFolder' }
  & Pick<Types.SharedSettingsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedSitesSettings_Fragment = (
  { __typename?: 'SharedSitesSettings' }
  & Pick<Types.SharedSitesSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment = (
  { __typename?: 'SharedSitesSettings_c14bf746030f4e598594395f6d299e61' }
  & Pick<Types.SharedSitesSettings_C14bf746030f4e598594395f6d299e61, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Showcase_Fragment = (
  { __typename?: 'Showcase' }
  & Pick<Types.Showcase, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ShowcaseFolder_Fragment = (
  { __typename?: 'ShowcaseFolder' }
  & Pick<Types.ShowcaseFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ShowcaseItem_Fragment = (
  { __typename?: 'ShowcaseItem' }
  & Pick<Types.ShowcaseItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ShowcaseParametersTemplate_Fragment = (
  { __typename?: 'ShowcaseParametersTemplate' }
  & Pick<Types.ShowcaseParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Site_Fragment = (
  { __typename?: 'Site' }
  & Pick<Types.Site, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteContentFolder_Fragment = (
  { __typename?: 'SiteContentFolder' }
  & Pick<Types.SiteContentFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteDefinition_Fragment = (
  { __typename?: 'SiteDefinition' }
  & Pick<Types.SiteDefinition, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteEntryDisclaimer_Fragment = (
  { __typename?: 'SiteEntryDisclaimer' }
  & Pick<Types.SiteEntryDisclaimer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteFolder_Fragment = (
  { __typename?: 'SiteFolder' }
  & Pick<Types.SiteFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteGrouping_Fragment = (
  { __typename?: 'SiteGrouping' }
  & Pick<Types.SiteGrouping, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteManagement_Fragment = (
  { __typename?: 'SiteManagement' }
  & Pick<Types.SiteManagement, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteSecurityItemPointer_Fragment = (
  { __typename?: 'SiteSecurityItemPointer' }
  & Pick<Types.SiteSecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteSelector_Fragment = (
  { __typename?: 'SiteSelector' }
  & Pick<Types.SiteSelector, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment = (
  { __typename?: 'SiteSelector_a44632f56dcd4d10b4892f4e35e193c3' }
  & Pick<Types.SiteSelector_A44632f56dcd4d10b4892f4e35e193c3, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteSetupRoot_Fragment = (
  { __typename?: 'SiteSetupRoot' }
  & Pick<Types.SiteSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SiteTheme_Fragment = (
  { __typename?: 'SiteTheme' }
  & Pick<Types.SiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment = (
  { __typename?: 'Site_e46f3af239fa4866a1577017c4b2a40c' }
  & Pick<Types.Site_E46f3af239fa4866a1577017c4b2a40c, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SitecoreFormWrapperParametersTemplate_Fragment = (
  { __typename?: 'SitecoreFormWrapperParametersTemplate' }
  & Pick<Types.SitecoreFormWrapperParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SitecoreRole_Fragment = (
  { __typename?: 'SitecoreRole' }
  & Pick<Types.SitecoreRole, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment = (
  { __typename?: 'SitemapSettings_c71d856635c849b7a84d9d176e9cbd05' }
  & Pick<Types.SitemapSettings_C71d856635c849b7a84d9d176e9cbd05, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SkipLink_Fragment = (
  { __typename?: 'SkipLink' }
  & Pick<Types.SkipLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SkipLinkParameters_Fragment = (
  { __typename?: 'SkipLinkParameters' }
  & Pick<Types.SkipLinkParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SkipLinksFolder_Fragment = (
  { __typename?: 'SkipLinksFolder' }
  & Pick<Types.SkipLinksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Snippet_Fragment = (
  { __typename?: 'Snippet' }
  & Pick<Types.Snippet, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SnippetItem_Fragment = (
  { __typename?: 'SnippetItem' }
  & Pick<Types.SnippetItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SnippetsFolder_Fragment = (
  { __typename?: 'SnippetsFolder' }
  & Pick<Types.SnippetsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialLoginWrapper_Fragment = (
  { __typename?: 'SocialLoginWrapper' }
  & Pick<Types.SocialLoginWrapper, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialMediaButtons_Fragment = (
  { __typename?: 'SocialMediaButtons' }
  & Pick<Types.SocialMediaButtons, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialMediaFolder_Fragment = (
  { __typename?: 'SocialMediaFolder' }
  & Pick<Types.SocialMediaFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialMediaShare_Fragment = (
  { __typename?: 'SocialMediaShare' }
  & Pick<Types.SocialMediaShare, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialMediaTemplate_Fragment = (
  { __typename?: 'SocialMediaTemplate' }
  & Pick<Types.SocialMediaTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialNetwork_Fragment = (
  { __typename?: 'SocialNetwork' }
  & Pick<Types.SocialNetwork, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialNetworkFolder_Fragment = (
  { __typename?: 'SocialNetworkFolder' }
  & Pick<Types.SocialNetworkFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SocialNetworkLink_Fragment = (
  { __typename?: 'SocialNetworkLink' }
  & Pick<Types.SocialNetworkLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SolutionTemplate_Fragment = (
  { __typename?: 'SolutionTemplate' }
  & Pick<Types.SolutionTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SortResults_Fragment = (
  { __typename?: 'SortResults' }
  & Pick<Types.SortResults, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SortResultsFolder_Fragment = (
  { __typename?: 'SortResultsFolder' }
  & Pick<Types.SortResultsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Sorting_Fragment = (
  { __typename?: 'Sorting' }
  & Pick<Types.Sorting, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SortingGroups_Fragment = (
  { __typename?: 'SortingGroups' }
  & Pick<Types.SortingGroups, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SpotifyPodcast_Fragment = (
  { __typename?: 'SpotifyPodcast' }
  & Pick<Types.SpotifyPodcast, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SpotifyPodcastFolder_Fragment = (
  { __typename?: 'SpotifyPodcastFolder' }
  & Pick<Types.SpotifyPodcastFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_StickyCta_Fragment = (
  { __typename?: 'StickyCTA' }
  & Pick<Types.StickyCta, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_StickyCtaFolder_Fragment = (
  { __typename?: 'StickyCTAFolder' }
  & Pick<Types.StickyCtaFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_StickyCtaParametersTemplate_Fragment = (
  { __typename?: 'StickyCTAParametersTemplate' }
  & Pick<Types.StickyCtaParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_StrategiesInFocusFolder_Fragment = (
  { __typename?: 'StrategiesInFocusFolder' }
  & Pick<Types.StrategiesInFocusFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_StrategyInFocus_Fragment = (
  { __typename?: 'StrategyInFocus' }
  & Pick<Types.StrategyInFocus, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Style_Fragment = (
  { __typename?: 'Style' }
  & Pick<Types.Style, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Styles_Fragment = (
  { __typename?: 'Styles' }
  & Pick<Types.Styles, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment = (
  { __typename?: 'Styles_9c0dac2808aa4b44bc2153363206f6a5' }
  & Pick<Types.Styles_9c0dac2808aa4b44bc2153363206f6a5, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_SubscriptionBannerParametersTemplate_Fragment = (
  { __typename?: 'SubscriptionBannerParametersTemplate' }
  & Pick<Types.SubscriptionBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Tab_Fragment = (
  { __typename?: 'Tab' }
  & Pick<Types.Tab, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TabItem_Fragment = (
  { __typename?: 'TabItem' }
  & Pick<Types.TabItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TableOfContents_Fragment = (
  { __typename?: 'TableOfContents' }
  & Pick<Types.TableOfContents, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TableOfContentsFolder_Fragment = (
  { __typename?: 'TableOfContentsFolder' }
  & Pick<Types.TableOfContentsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TableOfContentsSection_Fragment = (
  { __typename?: 'TableOfContentsSection' }
  & Pick<Types.TableOfContentsSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TableOfContentsSubsection_Fragment = (
  { __typename?: 'TableOfContentsSubsection' }
  & Pick<Types.TableOfContentsSubsection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Tabs_Fragment = (
  { __typename?: 'Tabs' }
  & Pick<Types.Tabs, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TabsFolder_Fragment = (
  { __typename?: 'TabsFolder' }
  & Pick<Types.TabsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment = (
  { __typename?: 'Tabs_f26a9560ccf148c59542800e837caf7a' }
  & Pick<Types.Tabs_F26a9560ccf148c59542800e837caf7a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Tag_Fragment = (
  { __typename?: 'Tag' }
  & Pick<Types.Tag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TagCloud_Fragment = (
  { __typename?: 'TagCloud' }
  & Pick<Types.TagCloud, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TagFolder_Fragment = (
  { __typename?: 'TagFolder' }
  & Pick<Types.TagFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TagList_Fragment = (
  { __typename?: 'TagList' }
  & Pick<Types.TagList, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamBiographySettings_Fragment = (
  { __typename?: 'TeamBiographySettings' }
  & Pick<Types.TeamBiographySettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamListingCards_Fragment = (
  { __typename?: 'TeamListingCards' }
  & Pick<Types.TeamListingCards, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamListingCardsFolder_Fragment = (
  { __typename?: 'TeamListingCardsFolder' }
  & Pick<Types.TeamListingCardsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMember_Fragment = (
  { __typename?: 'TeamMember' }
  & Pick<Types.TeamMember, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMemberCard_Fragment = (
  { __typename?: 'TeamMemberCard' }
  & Pick<Types.TeamMemberCard, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembers_Fragment = (
  { __typename?: 'TeamMembers' }
  & Pick<Types.TeamMembers, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersParentPage_Fragment = (
  { __typename?: 'TeamMembersParentPage' }
  & Pick<Types.TeamMembersParentPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment = (
  { __typename?: 'TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e' }
  & Pick<Types.TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment = (
  { __typename?: 'TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e' }
  & Pick<Types.TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment = (
  { __typename?: 'TeamMembersParentPage_47f304d629a84648a0e2b942513133ff' }
  & Pick<Types.TeamMembersParentPage_47f304d629a84648a0e2b942513133ff, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment = (
  { __typename?: 'TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089' }
  & Pick<Types.TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment = (
  { __typename?: 'TeamMembersParentPage_b4311697c06c4d58b88dca047c0a72b0' }
  & Pick<Types.TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersWildcardPage_Fragment = (
  { __typename?: 'TeamMembersWildcardPage' }
  & Pick<Types.TeamMembersWildcardPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e' }
  & Pick<Types.TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450' }
  & Pick<Types.TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a' }
  & Pick<Types.TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29' }
  & Pick<Types.TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment = (
  { __typename?: 'TeamMembersWildcardPage_ea27a3d835fd49a3a4c797d2a6d52745' }
  & Pick<Types.TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamProfileCards_Fragment = (
  { __typename?: 'TeamProfileCards' }
  & Pick<Types.TeamProfileCards, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TeamProfileCardsFolder_Fragment = (
  { __typename?: 'TeamProfileCardsFolder' }
  & Pick<Types.TeamProfileCardsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TechzoneArticlePage_Fragment = (
  { __typename?: 'TechzoneArticlePage' }
  & Pick<Types.TechzoneArticlePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Tenant_Fragment = (
  { __typename?: 'Tenant' }
  & Pick<Types.Tenant, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TenantFolder_Fragment = (
  { __typename?: 'TenantFolder' }
  & Pick<Types.TenantFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TenantSecurityItemPointer_Fragment = (
  { __typename?: 'TenantSecurityItemPointer' }
  & Pick<Types.TenantSecurityItemPointer, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TenantSetupRoot_Fragment = (
  { __typename?: 'TenantSetupRoot' }
  & Pick<Types.TenantSetupRoot, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TertieryHeroBanner_Fragment = (
  { __typename?: 'TertieryHeroBanner' }
  & Pick<Types.TertieryHeroBanner, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TertieryHeroBannerParametersTemplate_Fragment = (
  { __typename?: 'TertieryHeroBannerParametersTemplate' }
  & Pick<Types.TertieryHeroBannerParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Text_Fragment = (
  { __typename?: 'Text' }
  & Pick<Types.Text, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlock_Fragment = (
  { __typename?: 'TextBlock' }
  & Pick<Types.TextBlock, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlockHeadingParametersTemplate_Fragment = (
  { __typename?: 'TextBlockHeadingParametersTemplate' }
  & Pick<Types.TextBlockHeadingParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlockHeadingType_Fragment = (
  { __typename?: 'TextBlockHeadingType' }
  & Pick<Types.TextBlockHeadingType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlockHeadingTypeFolder_Fragment = (
  { __typename?: 'TextBlockHeadingTypeFolder' }
  & Pick<Types.TextBlockHeadingTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlockLinkType_Fragment = (
  { __typename?: 'TextBlockLinkType' }
  & Pick<Types.TextBlockLinkType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlockLinkTypeFolder_Fragment = (
  { __typename?: 'TextBlockLinkTypeFolder' }
  & Pick<Types.TextBlockLinkTypeFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlocks_Fragment = (
  { __typename?: 'TextBlocks' }
  & Pick<Types.TextBlocks, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlocksFolder_Fragment = (
  { __typename?: 'TextBlocksFolder' }
  & Pick<Types.TextBlocksFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextBlocksParametersTemplate_Fragment = (
  { __typename?: 'TextBlocksParametersTemplate' }
  & Pick<Types.TextBlocksParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextFolder_Fragment = (
  { __typename?: 'TextFolder' }
  & Pick<Types.TextFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TextFolder_B762d56787f5493cbb480c455d834457_Fragment = (
  { __typename?: 'TextFolder_b762d56787f5493cbb480c455d834457' }
  & Pick<Types.TextFolder_B762d56787f5493cbb480c455d834457, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment = (
  { __typename?: 'Text_b8f5894cb4934016bf784090b0a2fd16' }
  & Pick<Types.Text_B8f5894cb4934016bf784090b0a2fd16, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Theme_Fragment = (
  { __typename?: 'Theme' }
  & Pick<Types.Theme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ThemeTag_Fragment = (
  { __typename?: 'ThemeTag' }
  & Pick<Types.ThemeTag, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ThemeTagsFolder_Fragment = (
  { __typename?: 'ThemeTagsFolder' }
  & Pick<Types.ThemeTagsFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ThemingMode_Fragment = (
  { __typename?: 'ThemingMode' }
  & Pick<Types.ThemingMode, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ThemingModes_Fragment = (
  { __typename?: 'ThemingModes' }
  & Pick<Types.ThemingModes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Tile_Fragment = (
  { __typename?: 'Tile' }
  & Pick<Types.Tile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TileLink_Fragment = (
  { __typename?: 'TileLink' }
  & Pick<Types.TileLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TileParametersTemplate_Fragment = (
  { __typename?: 'TileParametersTemplate' }
  & Pick<Types.TileParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TileSizeOption_Fragment = (
  { __typename?: 'TileSizeOption' }
  & Pick<Types.TileSizeOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TileSizeOptionFolder_Fragment = (
  { __typename?: 'TileSizeOptionFolder' }
  & Pick<Types.TileSizeOptionFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TilesFolder_Fragment = (
  { __typename?: 'TilesFolder' }
  & Pick<Types.TilesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TilesParametersTemplate_Fragment = (
  { __typename?: 'TilesParametersTemplate' }
  & Pick<Types.TilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Title_Fragment = (
  { __typename?: 'Title' }
  & Pick<Types.Title, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Title_A82e893105754175917de904ef7e6dbe_Fragment = (
  { __typename?: 'Title_a82e893105754175917de904ef7e6dbe' }
  & Pick<Types.Title_A82e893105754175917de904ef7e6dbe, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Toggle_Fragment = (
  { __typename?: 'Toggle' }
  & Pick<Types.Toggle, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_ToggleFolder_Fragment = (
  { __typename?: 'ToggleFolder' }
  & Pick<Types.ToggleFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment = (
  { __typename?: 'Toggle_8e4c968e9fa543a89ac4c0baf273ccde' }
  & Pick<Types.Toggle_8e4c968e9fa543a89ac4c0baf273ccde, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Transformation_Fragment = (
  { __typename?: 'Transformation' }
  & Pick<Types.Transformation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TrustArticleHeroParametersTemplate_Fragment = (
  { __typename?: 'TrustArticleHeroParametersTemplate' }
  & Pick<Types.TrustArticleHeroParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TrustFinder_Fragment = (
  { __typename?: 'TrustFinder' }
  & Pick<Types.TrustFinder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TrustFinderFilterOption_Fragment = (
  { __typename?: 'TrustFinderFilterOption' }
  & Pick<Types.TrustFinderFilterOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TrustRegion_Fragment = (
  { __typename?: 'TrustRegion' }
  & Pick<Types.TrustRegion, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TrustType_Fragment = (
  { __typename?: 'TrustType' }
  & Pick<Types.TrustType, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TrustTypesFolder_Fragment = (
  { __typename?: 'TrustTypesFolder' }
  & Pick<Types.TrustTypesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Twitter_Fragment = (
  { __typename?: 'Twitter' }
  & Pick<Types.Twitter, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TwitterApp_Fragment = (
  { __typename?: 'TwitterApp' }
  & Pick<Types.TwitterApp, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TwitterApps_Fragment = (
  { __typename?: 'TwitterApps' }
  & Pick<Types.TwitterApps, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TwitterFolder_Fragment = (
  { __typename?: 'TwitterFolder' }
  & Pick<Types.TwitterFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TwitterParametersTemplate_Fragment = (
  { __typename?: 'TwitterParametersTemplate' }
  & Pick<Types.TwitterParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_TwitterSettings_Fragment = (
  { __typename?: 'TwitterSettings' }
  & Pick<Types.TwitterSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_UnknownItem_Fragment = (
  { __typename?: 'UnknownItem' }
  & Pick<Types.UnknownItem, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_UnminifiedFile_Fragment = (
  { __typename?: 'UnminifiedFile' }
  & Pick<Types.UnminifiedFile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_UpgradeScript_Fragment = (
  { __typename?: 'UpgradeScript' }
  & Pick<Types.UpgradeScript, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_UpgradeScriptLibrary_Fragment = (
  { __typename?: 'UpgradeScriptLibrary' }
  & Pick<Types.UpgradeScriptLibrary, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantComponentField_Fragment = (
  { __typename?: 'VariantComponentField' }
  & Pick<Types.VariantComponentField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantDateField_Fragment = (
  { __typename?: 'VariantDateField' }
  & Pick<Types.VariantDateField, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment = (
  { __typename?: 'VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55' }
  & Pick<Types.VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantPlaceholder_Fragment = (
  { __typename?: 'VariantPlaceholder' }
  & Pick<Types.VariantPlaceholder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantReference_Fragment = (
  { __typename?: 'VariantReference' }
  & Pick<Types.VariantReference, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantSection_Fragment = (
  { __typename?: 'VariantSection' }
  & Pick<Types.VariantSection, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantTemplate_Fragment = (
  { __typename?: 'VariantTemplate' }
  & Pick<Types.VariantTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantText_Fragment = (
  { __typename?: 'VariantText' }
  & Pick<Types.VariantText, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VariantToken_Fragment = (
  { __typename?: 'VariantToken' }
  & Pick<Types.VariantToken, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Variants_Fragment = (
  { __typename?: 'Variants' }
  & Pick<Types.Variants, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VectorFolder_Fragment = (
  { __typename?: 'VectorFolder' }
  & Pick<Types.VectorFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VectorTile_Fragment = (
  { __typename?: 'VectorTile' }
  & Pick<Types.VectorTile, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VectorTileLink_Fragment = (
  { __typename?: 'VectorTileLink' }
  & Pick<Types.VectorTileLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VectorTilesFolder_Fragment = (
  { __typename?: 'VectorTilesFolder' }
  & Pick<Types.VectorTilesFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VectorTilesParametersTemplate_Fragment = (
  { __typename?: 'VectorTilesParametersTemplate' }
  & Pick<Types.VectorTilesParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment = (
  { __typename?: 'Version_95ebc23204774dc38ad3465d5fe8da2f' }
  & Pick<Types.Version_95ebc23204774dc38ad3465d5fe8da2f, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Video_Fragment = (
  { __typename?: 'Video' }
  & Pick<Types.Video, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoCountOption_Fragment = (
  { __typename?: 'VideoCountOption' }
  & Pick<Types.VideoCountOption, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoCountOptions_Fragment = (
  { __typename?: 'VideoCountOptions' }
  & Pick<Types.VideoCountOptions, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoFolder_Fragment = (
  { __typename?: 'VideoFolder' }
  & Pick<Types.VideoFolder, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment = (
  { __typename?: 'VideoFolder_bba49474673e468186ba8b1a20e067a9' }
  & Pick<Types.VideoFolder_Bba49474673e468186ba8b1a20e067a9, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoPage_Fragment = (
  { __typename?: 'VideoPage' }
  & Pick<Types.VideoPage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoParameters_Fragment = (
  { __typename?: 'VideoParameters' }
  & Pick<Types.VideoParameters, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoParametersTemplate_Fragment = (
  { __typename?: 'VideoParametersTemplate' }
  & Pick<Types.VideoParametersTemplate, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_VideoPressReleasePage_Fragment = (
  { __typename?: 'VideoPressReleasePage' }
  & Pick<Types.VideoPressReleasePage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base_Video_4bc649610a894242be2dc5026090cf49_Fragment = (
  { __typename?: 'Video_4bc649610a894242be2dc5026090cf49' }
  & Pick<Types.Video_4bc649610a894242be2dc5026090cf49, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__AssetsOptimization_Fragment = (
  { __typename?: '_AssetsOptimization' }
  & Pick<Types._AssetsOptimization, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__BackgroundImage_Fragment = (
  { __typename?: '_BackgroundImage' }
  & Pick<Types._BackgroundImage, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__CompatibleThemes_Fragment = (
  { __typename?: '_CompatibleThemes' }
  & Pick<Types._CompatibleThemes, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__CompositeTheme_Fragment = (
  { __typename?: '_CompositeTheme' }
  & Pick<Types._CompositeTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__CustomMetadata_Fragment = (
  { __typename?: '_CustomMetadata' }
  & Pick<Types._CustomMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__CustomRenderingViewPath_Fragment = (
  { __typename?: '_CustomRenderingViewPath' }
  & Pick<Types._CustomRenderingViewPath, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__DatasourceBehaviour_Fragment = (
  { __typename?: '_DatasourceBehaviour' }
  & Pick<Types._DatasourceBehaviour, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__Favicon_Fragment = (
  { __typename?: '_Favicon' }
  & Pick<Types._Favicon, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__FormsFolderLocation_Fragment = (
  { __typename?: '_FormsFolderLocation' }
  & Pick<Types._FormsFolderLocation, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__FundSettings_Fragment = (
  { __typename?: '_FundSettings' }
  & Pick<Types._FundSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__HasValidUrlName_Fragment = (
  { __typename?: '_HasValidUrlName' }
  & Pick<Types._HasValidUrlName, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__LocalDataLink_Fragment = (
  { __typename?: '_LocalDataLink' }
  & Pick<Types._LocalDataLink, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__Login_Fragment = (
  { __typename?: '_Login' }
  & Pick<Types._Login, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__OpenGraphMetadata_Fragment = (
  { __typename?: '_OpenGraphMetadata' }
  & Pick<Types._OpenGraphMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__PageDesignTheme_Fragment = (
  { __typename?: '_PageDesignTheme' }
  & Pick<Types._PageDesignTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__PageSearchScope_Fragment = (
  { __typename?: '_PageSearchScope' }
  & Pick<Types._PageSearchScope, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__SearchCriteria_Fragment = (
  { __typename?: '_SearchCriteria' }
  & Pick<Types._SearchCriteria, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__SearchableWithoutRelatedItems_Fragment = (
  { __typename?: '_SearchableWithoutRelatedItems' }
  & Pick<Types._SearchableWithoutRelatedItems, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__SeoMetadata_Fragment = (
  { __typename?: '_SeoMetadata' }
  & Pick<Types._SeoMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__SiteTheme_Fragment = (
  { __typename?: '_SiteTheme' }
  & Pick<Types._SiteTheme, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__SitemapSettings_Fragment = (
  { __typename?: '_SitemapSettings' }
  & Pick<Types._SitemapSettings, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__StickyNote_Fragment = (
  { __typename?: '_StickyNote' }
  & Pick<Types._StickyNote, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__Styleable_Fragment = (
  { __typename?: '_Styleable' }
  & Pick<Types._Styleable, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__TwitterMetadata_Fragment = (
  { __typename?: '_TwitterMetadata' }
  & Pick<Types._TwitterMetadata, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__Webinar_Fragment = (
  { __typename?: '_Webinar' }
  & Pick<Types._Webinar, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type Base__WildcardSource_Fragment = (
  { __typename?: '_WildcardSource' }
  & Pick<Types._WildcardSource, 'id' | 'name'>
  & { template: ArticleSearchSeriesQuery_search_ItemSearchResults_results_Accordion_template_ItemTemplate }
);

export type BaseFragment = Base_Accordion_Fragment | Base_AccordionFolder_Fragment | Base_AccordionFolder_03f88fb497884025b46f2cb249f4fcd6_Fragment | Base_AccordionItem_Fragment | Base_AccordionItem_8cf671721b2d489e809f4c23db5ab2da_Fragment | Base_AccordionParametersTemplate_Fragment | Base_AccordionPresentation_Fragment | Base_AccordionPresentationFolder_Fragment | Base_Accordion_02d060598cc14423a9ac9ff2365176b7_Fragment | Base_Accordion_705cc8b3bde54cb3bf1ce455a2a36ef1_Fragment | Base_AddItem_Fragment | Base_AddItem_1e1b739ec3784909941d171aca7362e5_Fragment | Base_AddItem_3aea335cd06d45b1841acbc8d2d1ce40_Fragment | Base_AddItem_De8c75222f3241288f20342f479894eb_Fragment | Base_AddItem_Ea8a3f269ccd443a95f571b868a94bd0_Fragment | Base_AddThisParameters_Fragment | Base_AggregatedFacetFilter_Fragment | Base_AlertMessage_Fragment | Base_AlertMessageFolder_Fragment | Base_AlertMessageParametersTemplate_Fragment | Base_AlertMessageType_Fragment | Base_AllertMessageTypeFolder_Fragment | Base_Archive_Fragment | Base_ArticleAuthor_Fragment | Base_ArticleAuthorsFolder_Fragment | Base_ArticleCategoriesFolder_Fragment | Base_ArticleCategory_Fragment | Base_ArticleChapter_Fragment | Base_ArticleChapters_Fragment | Base_ArticleContentType_Fragment | Base_ArticleContentTypesFolder_Fragment | Base_ArticleFilter_Fragment | Base_ArticleFilterOption_Fragment | Base_ArticleFootnote_Fragment | Base_ArticleFootnoteLink_Fragment | Base_ArticleFootnoteText_Fragment | Base_ArticleInfogramTile_Fragment | Base_ArticleInfogramTileParametersTemplate_Fragment | Base_ArticlePage_Fragment | Base_ArticleRegion_Fragment | Base_ArticleRegionsFolder_Fragment | Base_ArticleSearchPage_Fragment | Base_ArticleSearchPage_4d8bd0d1a07841dc96405ca1ed71d81c_Fragment | Base_ArticleSearchPage_22b7f7c7c37f4644a8eed9c32258b4a2_Fragment | Base_ArticleSearchPage_Be414ff574ac4203abb2694811443e25_Fragment | Base_ArticleSearchPage_C7ad44ac3cab45158b619465a552a82c_Fragment | Base_ArticleSearchPage_Cf31bd740a4b4363b03d1f7a88e39907_Fragment | Base_ArticleSeriesCollection_Fragment | Base_ArticleSeriesFolder_Fragment | Base_ArticleSettings_Fragment | Base_ArticleSubscriptionBanner_Fragment | Base_ArticleSubscriptionBannerFolder_Fragment | Base_ArticleTag_Fragment | Base_ArticleTagsFolder_Fragment | Base_ArticleTeamAuthor_Fragment | Base_ArticleTileParametersTemplate_Fragment | Base_ArticleTilesParametersTemplate_Fragment | Base_ArticleWildcardPage_4bf0be7a0c5c41d5973bb82f1ec73f8f_Fragment | Base_ArticleWildcardPage_8f17c5d3ea39491494916dbfe2410ad8_Fragment | Base_ArticleWildcardPage_84a63b4789ee4a3f82684b750a6a23ca_Fragment | Base_ArticleWildcardPage_95e7966e0da1412bafbf0e8a69392c8c_Fragment | Base_ArticleWildcardPage_405b20252077400383d3b47f09f88b47_Fragment | Base_ArticleWildcardPage_B037a577f5cb4ad3b79f07720a96985b_Fragment | Base_ArticlesGroupFolder_Fragment | Base_AttachThemeExtension_Fragment | Base_AutomaticDocumentListings_Fragment | Base_AutomaticDocumentListingsFolder_Fragment | Base_AvailableJsonRenderings_Fragment | Base_AvailableMetaRenderings_Fragment | Base_AvailableRenderings_Fragment | Base_AvailableRenderingsFolder_26ec1d1811b24dd98326f6115f4fd7eb_Fragment | Base_AwardsBanner_Fragment | Base_AwardsBannerFolder_Fragment | Base_AwardsBannerImage_Fragment | Base_AwardsBannerParametersTemplate_Fragment | Base_ByocWrapperRenderingParameters_Fragment | Base_BackgroundColorOption_Fragment | Base_BackgroundColorOptionFolder_Fragment | Base_BannerFolder_Fragment | Base_BannerType_Fragment | Base_BannerTypeFolder_Fragment | Base_BaseHeading_Fragment | Base_BaseHeadingFolder_Fragment | Base_BoolFacet_Fragment | Base_BranchesFolder_Fragment | Base_Breadcrumb_Fragment | Base_BrowserTitleDefinition_Fragment | Base_CorsEntry_Fragment | Base_CorsGrouping_Fragment | Base_CtaPresentationType_Fragment | Base_CtaPresentationTypeFolder_Fragment | Base_C__AbrdnPage_Fragment | Base_C__ActionBase_Fragment | Base_C__AdvancedParameter_Fragment | Base_C__App_Fragment | Base_C__ArticleSearchPage_47bc2dcb3d9f4b5d8e698d599780180c_Fragment | Base_C__ArticleWildcardPage_Fragment | Base_C__AvailableRenderingsFolder_Fragment | Base_C__ByocRenderingParameters_Fragment | Base_C__BackgroundParametersTemplate_Fragment | Base_C__BaseCta_Fragment | Base_C__BasePage_Fragment | Base_C__BasePage_037da552a5524fe4aeee331f57ac1378_Fragment | Base_C__BasePage_40cd6d0cef2a4231b0b4a74f30a23f5f_Fragment | Base_C__BasePage_315fd21bebf04c9d9f00bae191442f1d_Fragment | Base_C__BasePage_458c6cc442da4327b4d4d7d4ecd48cbd_Fragment | Base_C__BasePage_728c97b5c56146d9807e21018a972bb5_Fragment | Base_C__BasePage_6105875085f346729dfc8d133b481f26_Fragment | Base_C__BasePage_B08130ebd3314a3b9c0f2b5e9b66387b_Fragment | Base_C__BaseRenderingParameters_Fragment | Base_C__BaseTheme_Fragment | Base_C__BaseVariantField_Fragment | Base_C__Class_Fragment | Base_C__CompositeGroup_Fragment | Base_C__CompositeSection_Fragment | Base_C__EloquaForm_Fragment | Base_C__ErrorPage_D40dd5cadbf1461191b8f9e1071e557d_Fragment | Base_C__ExtendedOptions_Fragment | Base_C__ExtendedOptions_2964fb4257a6440fb192218443904c90_Fragment | Base_C__ExtendedOptions_F1850030f97848b4bdb5884b7e863160_Fragment | Base_C__FEaaSRenderingParameters_Fragment | Base_C__FacetSelectorConfigBase_Fragment | Base_C__FilteredArticlesParentPage_8196d9b5309f49f882f7918089b77845_Fragment | Base_C__FilteredArticlesWildcardPage_9f8fef04516e43b4bee71d5d39757a2b_Fragment | Base_C__FundDetailsWildcardPage_Fb127f7aeeba46458c5fbe9f7c589303_Fragment | Base_C__FundSearchPage_D83da2a5ce9042b6bd557aa8820c62c5_Fragment | Base_C__FundShareclassDetailsWildcardPage_E3590ad764a84980a419c4f1f926f9fc_Fragment | Base_C__GlobalDatasourceBehavior_Fragment | Base_C__GridDefinition_Fragment | Base_C__GridItemBase_Fragment | Base_C__GridParameters_Fragment | Base_C__HeadlessSite_Fragment | Base_C__HeadlessTenant_Fragment | Base_C__HelpArticleSearchPage_D1c4d91365c8401389dcde7b5fb2f28b_Fragment | Base_C__HelpArticleWildcardPage_C0a939305f6e47a38739f2a8f300e65d_Fragment | Base_C__HomePage_2899b95da7f346b7a1da7ef14d7ef84d_Fragment | Base_C__IAllowEmpty_Fragment | Base_C__IBaseVariantDefinition_Fragment | Base_C__IBoosting_Fragment | Base_C__ICacheable_Fragment | Base_C__ICompatibleRenderings_Fragment | Base_C__IComponentVariant_Fragment | Base_C__IControlType_Fragment | Base_C__IDynamicPlaceholder_Fragment | Base_C__IfEaaSComponentsDataSourceTemplates_Fragment | Base_C__IfEaaSComponentsEditorScriptUrl_Fragment | Base_C__IIcon_Fragment | Base_C__ILocation_Fragment | Base_C__IPaginable_Fragment | Base_C__IPagination_Fragment | Base_C__IPoi_Fragment | Base_C__IRenderingId_Fragment | Base_C__ISplitter_Fragment | Base_C__IStyling_Fragment | Base_C__IVariantDefinition_Fragment | Base_C__InvestmentTrustPage_Fragment | Base_C__JsonField_Fragment | Base_C__JsonReference_Fragment | Base_C__JssData_Fragment | Base_C__JssSettings_Fragment | Base_C__JssSiteFolder_Fragment | Base_C__JssRootFolder_Fragment | Base_C__LiteratureHubSearchPage_5378ef42e2c4488497ac7cc017b10086_Fragment | Base_C__Navigation_E6d98f24d01c419e871a4617125a49ed_Fragment | Base_C__Page_Fragment | Base_C__PageData_Fragment | Base_C__PageDesignFolder_Fragment | Base_C__PageDesignFolder_023f5d48979d4381bc5e149e36abd3bd_Fragment | Base_C__PageDesigns_Daaf41fd96db4892be99f62f16d036c4_Fragment | Base_C__PartialDesign_Fragment | Base_C__PartialDesignFolder_Fragment | Base_C__PartialDesignFolder_25f01f50553444f9b1babcbb60b2d13d_Fragment | Base_C__PartialDesigns_79c9fa015f6a48b2b45905bbaa826a9d_Fragment | Base_C__PlaceholderWrapper_Fragment | Base_C__PressReleaseSearchPage_4197f4d95d5f4fb3be77e0be695df7ac_Fragment | Base_C__PressReleaseWildcardPage_6a8c237f261d4a9891ef3e27afee2b9b_Fragment | Base_C__RedirectMapGrouping_Fragment | Base_C__ResizableIFramePage_6ff27d6556ff453393bbb3f7f568d973_Fragment | Base_C__Route_Fragment | Base_C__SimpleVideo_Fragment | Base_C__SiteSettingsFolder_Fragment | Base_C__SitemapSettings_Fragment | Base_C__StandardTemplate_Fragment | Base_C__TeamMembersParentPage_11fbd080aa844abca056f5caac316e4c_Fragment | Base_C__TeamMembersWildcardPage_8b12628190064b2980f0a054ead02a65_Fragment | Base_C__TrustFolder_Fragment | Base_C__VariantDefinition_Fragment | Base_C__VariantField_Fragment | Base_C__VariantsGrouping_Fragment | Base_C___AdvancedItem_Fragment | Base_C___Arguments_Fragment | Base_C___Arguments_33fab87cd52f44319a1f589ba7c1e287_Fragment | Base_C___Article_Fragment | Base_C___ArticlePageWorkflow_Fragment | Base_C___ArticleSearchPage_Fragment | Base_C___ArticleWildcard_Fragment | Base_C___AssetServiceThemeMode_Fragment | Base_C___BaseArticle_Fragment | Base_C___BaseDataFolder_Fragment | Base_C___BaseHelpArticle_Fragment | Base_C___BaseInvestmentTrust_Fragment | Base_C___BaseJssTenant_Fragment | Base_C___BasePage_Fragment | Base_C___BasePageDesign_Fragment | Base_C___BasePageDesignFolder_Fragment | Base_C___BasePartialDesign_Fragment | Base_C___BasePartialDesignFolder_Fragment | Base_C___BasePlaceholder_Fragment | Base_C___BasePlaceholderSettingsFolder_Fragment | Base_C___BasePresentation_Fragment | Base_C___BasePressRelease_Fragment | Base_C___BaseRenderingParameters_Fragment | Base_C___BaseSxaStandardValuesFolder_Fragment | Base_C___BaseSettings_Fragment | Base_C___BaseSharedSitesSettings_Fragment | Base_C___BaseSiteDefinition_Fragment | Base_C___BaseSiteFolder_Fragment | Base_C___BaseSiteGrouping_Fragment | Base_C___BaseSiteRoot_Fragment | Base_C___BaseTenant_Fragment | Base_C___BaseTenantFolder_Fragment | Base_C___BucketRules_Fragment | Base_C___Cors_Fragment | Base_C___Content_Fragment | Base_C___ContentType_Fragment | Base_C___DataAttributes_Fragment | Base_C___DatasourceWorkflow_Fragment | Base_C___Dependencies_Fragment | Base_C___Description_Fragment | Base_C___DesignTemplateMapping_Fragment | Base_C___Designable_Fragment | Base_C___EditType_Fragment | Base_C___EditType_8a9f84baaa124c5d9096935714809da4_Fragment | Base_C___EditingTheme_Fragment | Base_C___Enabled_Fragment | Base_C___ErrorHandling_Fragment | Base_C___ExternalArticle_Fragment | Base_C___Fields_Fragment | Base_C___FilteredArticlesParent_Fragment | Base_C___FilteredArticlesWildcard_Fragment | Base_C___Footnotes_Fragment | Base_C___FundDetailsWildcard_Fragment | Base_C___FundFormAvailability_Fragment | Base_C___FundMetadataPage_Fragment | Base_C___FundSearchPage_Fragment | Base_C___FundsFolder_Fragment | Base_C___FundsFormsFolder_Fragment | Base_C___FundsLiteratureFolder_Fragment | Base_C___FundsShareclassesDetailsWildcard_Fragment | Base_C___GridMapping_Fragment | Base_C___HelpArticle_Fragment | Base_C___HelpArticleSearchPage_Fragment | Base_C___HelpArticleWildcard_Fragment | Base_C___HorizonDatasourceGrouping_Fragment | Base_C___Icon_Fragment | Base_C___IncludeByDefault_Fragment | Base_C___IncludeIfInstalled_Fragment | Base_C___InternalArticle_Fragment | Base_C___InternetExplorerCompatibilityMode_Fragment | Base_C___IsSystemModule_Fragment | Base_C___JsonVariantPaging_Fragment | Base_C___JsonVariantsBase_Fragment | Base_C___LimitedDisplay_Fragment | Base_C___LinkAttributes_Fragment | Base_C___LinkSettings_Fragment | Base_C___LiteratureHubSearchPage_Fragment | Base_C___ManualKeyInformation_Fragment | Base_C___MemberOf_Fragment | Base_C___MetadataPage_Fragment | Base_C___Modules_Fragment | Base_C___Name_Fragment | Base_C___Name_0345fd2f95094dc7b0f56c73a9b6cd8d_Fragment | Base_C___Name_299cdb154745448a807868d401248eaa_Fragment | Base_C___Name_B88cf88159a54a19991e71038751cb60_Fragment | Base_C___Navigable_Fragment | Base_C___NavigablePage_Fragment | Base_C___PageContent_Fragment | Base_C___PageWorkflow_Fragment | Base_C___PerSiteStandardValues_Fragment | Base_C___Podcast_Fragment | Base_C___PodcastPressRelease_Fragment | Base_C___PremiumContentPage_Fragment | Base_C___PressRelease_Fragment | Base_C___PressReleaseContentType_Fragment | Base_C___PressReleaseSearchPage_Fragment | Base_C___PressReleaseWildcard_Fragment | Base_C___ProtectedTheme_Fragment | Base_C___PublishingGroupingTemplate_Fragment | Base_C___RenderingRelatedParameters_Fragment | Base_C___RenderingVariantsBase_Fragment | Base_C___RenderingsList_Fragment | Base_C___RobotsContent_Fragment | Base_C___RoleDomain_Fragment | Base_C___RoleName_Fragment | Base_C___RoleType_Fragment | Base_C___SalesforceCommonValidations_Fragment | Base_C___SalesforceFieldId_Fragment | Base_C___SalesforceFieldTitle_Fragment | Base_C___SalesforceFieldValue_Fragment | Base_C___Script_Fragment | Base_C___SearchSignature_Fragment | Base_C___Searchable_Fragment | Base_C___SecurityItemPointer_Fragment | Base_C___SharedArticles_Fragment | Base_C___SharedContent_Fragment | Base_C___SharedHelpArticles_Fragment | Base_C___SharedPage_Fragment | Base_C___SharedPressReleases_Fragment | Base_C___SharedRoot_Fragment | Base_C___SharedSettings_Fragment | Base_C___SiteContent_Fragment | Base_C___SiteFolder_Fragment | Base_C___SiteMediaLibrary_Fragment | Base_C___SiteSettings_Fragment | Base_C___SiteTemplate_Fragment | Base_C___SitecoreClientSiteManaging_Fragment | Base_C___Sitemap_Fragment | Base_C___SitemapMediaItems_Fragment | Base_C___SlidersRangeSettings_Fragment | Base_C___SolutionTemplateContent_Fragment | Base_C___SolutionTemplateDescription_Fragment | Base_C___SolutionTemplateName_Fragment | Base_C___SortOrder_Fragment | Base_C___StackBreakpoint_Fragment | Base_C___Statistics_Fragment | Base_C___SupportedLanguages_Fragment | Base_C___Taggable_Fragment | Base_C___TeamMembersParentPage_Fragment | Base_C___TeamMembersWildcard_Fragment | Base_C___TechzoneArticle_Fragment | Base_C___Template_Fragment | Base_C___Title_Fragment | Base_C___Type_Fragment | Base_C___Validation_Fragment | Base_C___VariantPaging_Fragment | Base_C___VectorTile_Fragment | Base_C___VectorTileLink_Fragment | Base_C___Video_Fragment | Base_C___VideoPressRelease_Fragment | Base_C___Width_Fragment | Base_C___WildcardPage_Fragment | Base_CacheSetting_Fragment | Base_Caching_26fce9bf0256458d8281a713a5bf5520_Fragment | Base_CalendarEvent_Fragment | Base_CallOutSection_Fragment | Base_CallOutSectionDropdownOption_Fragment | Base_CallOutSectionFolder_Fragment | Base_CallOutSectionParametersTemplate_Fragment | Base_CallToAction_Fragment | Base_CallToActionFolder_Fragment | Base_CapabilitiesFolder_Fragment | Base_Capability_Fragment | Base_CapabilityMap_Fragment | Base_CapabilityMappings_Fragment | Base_Carousel_Fragment | Base_CarouselFolder_Fragment | Base_CarouselSlide_Fragment | Base_Carousel_2b65f0d87ec54834b4aa1753c0f7036b_Fragment | Base_Checkbox_Fragment | Base_ChecklistFilter_Fragment | Base_ChecklistFilterFolder_Fragment | Base_ChecklistFilter_3cb40bd669c94976a9742120a5eba1ee_Fragment | Base_ColumnSplitter_Fragment | Base_ColumnSplitter_3e1016e56ecb4c19aa0117c18b42deb0_Fragment | Base_CompatibilityMode_Fragment | Base_ComponentConfiguration_Fragment | Base_ComponentThemeConfiguration_Fragment | Base_ComponentThemesConfiguration_Fragment | Base_ComponentsConfigurations_Fragment | Base_ConfigurationFolder_Fragment | Base_Container_Fragment | Base_ContainerOption_Fragment | Base_ContainerOptionsFolder_Fragment | Base_ContainerParametersTemplate_Fragment | Base_Container_45130bdbbae34edcaea87b68b9d94c7f_Fragment | Base_ContentBlock_Fragment | Base_ContentBlockFolder_Fragment | Base_ContentToken_Fragment | Base_ContentTokenFolder_Fragment | Base_ContentType_Fragment | Base_CorporateTheme_Fragment | Base_CorporateThemesFolder_Fragment | Base_Country_Fragment | Base_CountryIsoCode_Fragment | Base_CountryIsoCodesFolder_Fragment | Base_CustomerReviewFolder_Fragment | Base_CustomerReviewTile_Fragment | Base_CustomerReviewTileParametersTemplate_Fragment | Base_DataBridgeDocumentCategoryMap_Fragment | Base_DataBridgeFund_Fragment | Base_DataBridgeFundRangeName_Fragment | Base_DataBridgeSettingsFolder_Fragment | Base_DataBridgeShareClass_Fragment | Base_DataFolder_Fragment | Base_DatasourceConfiguration_Fragment | Base_DatasourceConfigurations_Fragment | Base_DatasourceWorkflowAction_Fragment | Base_DateFacet_Fragment | Base_DateFilter_Fragment | Base_DateFilterFolder_Fragment | Base_DateFilter_Ad89c1f1e99148ef865938ab13aa28f1_Fragment | Base_DefaultColumnLayout_Fragment | Base_DefaultShareclassMapping_Fragment | Base_DefaultShareclassMappings_Fragment | Base_DescriptiveHighlight_Fragment | Base_DescriptiveHighlightFolder_Fragment | Base_DescriptiveHighlightItem_Fragment | Base_DescriptiveHighlightParametersTemplate_Fragment | Base_Device_Fragment | Base_Device_7c27ec70f42e40428a0fabaa2f8eda18_Fragment | Base_Devices_Fragment | Base_DictionaryFolder_Fragment | Base_DisqusParameters_Fragment | Base_DistanceFacet_Fragment | Base_Divider_Fragment | Base_DocumentItem_Fragment | Base_DocumentListings_Fragment | Base_DocumentListingsFolder_Fragment | Base_DocumentTypeFolder_Fragment | Base_DominantLanguageMapping_Fragment | Base_Dropdown_Fragment | Base_DropdownFilter_Fragment | Base_DropdownFilterFolder_Fragment | Base_DropdownFilter_790c0f2c16214604a6c672b9f8ae830d_Fragment | Base_EditEditingTheme_Fragment | Base_EditFrame_Fragment | Base_EditModePanel_Fragment | Base_EditSiteItem_Fragment | Base_EditSiteItem_F040db0387fe4e10ae4053c63175e31b_Fragment | Base_EditSiteTheme_Fragment | Base_EditTenantTemplate_Fragment | Base_EditTenantTemplate_A7d9fcbcc8944274935f9b9659c000d3_Fragment | Base_EditType_Fragment | Base_EloquaFormFolder_Fragment | Base_EloquaFundForm_Fragment | Base_Enum_Fragment | Base_Enums_Fragment | Base_ErrorPage_Fragment | Base_ErrorPage_4b405ec4ef9f4c91a3ffb98c1ac81171_Fragment | Base_ErrorPage_4dbccce416d1491f94198496e3f77c6d_Fragment | Base_ErrorPage_45d797cc048740ffb693214883ff35c2_Fragment | Base_ErrorPage_76eb47b3f3a248bdbbdbb5bf7d8f9bf9_Fragment | Base_ErrorPage_A7dfa49761224679bf9949fffacd5fa1_Fragment | Base_EventCalendarParameters_Fragment | Base_EventList_Fragment | Base_EventListParameters_Fragment | Base_EventTypes_Fragment | Base_EventsFolder_Fragment | Base_ExecuteScript_Fragment | Base_ExecuteScript_3d4e4577ab334ca6ae43b98d1ec6472f_Fragment | Base_ExecuteScript_6545c81fc30f4b5897d9ef85b890f70a_Fragment | Base_ExecuteScript_B06460c28b7b47a59e2cf966f689b6ca_Fragment | Base_ExecuteScript_Bc9bb68436df4285888bd8b4d87b10de_Fragment | Base_ExecuteScript_E14c08721a97459eafef0acaaaf1ffbb_Fragment | Base_ExtendSiteTheme_Fragment | Base_ExternalLiterature_Fragment | Base_FEaaSWrapperRenderingParameters_Fragment | Base_FacebookCommentsParametersTemplate_Fragment | Base_FacetSlider_Fragment | Base_FacetSliderFolder_Fragment | Base_FacetSlider_995ce2c7319f478b84fe22053ac85bb7_Fragment | Base_FacetSummary_Fragment | Base_FacetSummaryFolder_Fragment | Base_FacetSummary_Cd5c935c1f604d899a6b88ce28305cf2_Fragment | Base_FacetsGrouping_Fragment | Base_FakeNavigationItem_Fragment | Base_FeatureBanner_Fragment | Base_FeatureBannerParametersTemplate_Fragment | Base_FeaturedArticles_Fragment | Base_FeaturedArticlesFolder_Fragment | Base_FeaturedTheme_Fragment | Base_FeaturedThemesFolder_Fragment | Base_Feed_Fragment | Base_FeedFolder_Fragment | Base_FeedParameters_Fragment | Base_FieldEditor_Fragment | Base_FieldRenderer_Fragment | Base_FileList_Fragment | Base_FileListFolder_Fragment | Base_FileListParametersTemplate_Fragment | Base_File_04129321770849c1801baee196e1c0a8_Fragment | Base_FilterCriteria_Fragment | Base_FilterCriteriaFolder_Fragment | Base_FilterTaxonomyOption_Fragment | Base_FilterTaxonomyOptions_Fragment | Base_FilteredArticlesParentPage_Fragment | Base_FilteredArticlesParentPage_6adc5be146ab4c7d97f64e5c3512177d_Fragment | Base_FilteredArticlesParentPage_7f5d344247eb446a8f147890b998e941_Fragment | Base_FilteredArticlesParentPage_A34845039cf1441f8c967a5bbbdd7616_Fragment | Base_FilteredArticlesParentPage_E4f65f074322485787460a4058d378f9_Fragment | Base_FilteredArticlesParentPage_F099104e87204d52a6ab75aa44d159ce_Fragment | Base_FilteredArticlesWildcardPage_Fragment | Base_FilteredArticlesWildcardPage_5d527e4033c048c6a474af1068db082e_Fragment | Base_FilteredArticlesWildcardPage_98c82b05868444df9fe806b5fb955835_Fragment | Base_FilteredArticlesWildcardPage_705b3bb7cecc447f910fa76bdc57ada2_Fragment | Base_FilteredArticlesWildcardPage_Ceac9aa72d344797adf00f73f9a55f96_Fragment | Base_FilteredArticlesWildcardPage_Da761c9a4e8f4a91b99040d8f5baa260_Fragment | Base_Flip_Fragment | Base_FlipFolder_Fragment | Base_Flip_5ef078504c044b839dafefd752cfaba8_Fragment | Base_Flipside_Fragment | Base_FloatFacet_Fragment | Base_Footer_Fragment | Base_FooterFolder_Fragment | Base_FooterLink_Fragment | Base_FormRenderingParameters_Fragment | Base_FundAssetClass_Fragment | Base_FundAssetClassesFolder_Fragment | Base_FundDetailsWildcardPage_Fragment | Base_FundDetailsWildcardPage_97df45d1e5294f6dbc2279895ee83734_Fragment | Base_FundDetailsWildcardPage_590b12426ab64f49990b2dd2c5fffd0f_Fragment | Base_FundDetailsWildcardPage_60069dbb81dc496b888fe2e38073a74b_Fragment | Base_FundFormsFolder_Fragment | Base_FundInFocus_Fragment | Base_FundInFocusShareClass_Fragment | Base_FundSearchPage_Fragment | Base_FundSearchPage_5505b84dba1f47c7b8054749d802d926_Fragment | Base_FundSearchPage_5806f83c03bc443380678ff955f4310f_Fragment | Base_FundSearchPage_7432205c04214a419ca064c4cb37501c_Fragment | Base_FundSearchPage_Edc9df02132e4c0a8435dd60057cbb0a_Fragment | Base_FundSettings_Fragment | Base_FundShareclassDetailsWildcardPage_Fragment | Base_FundShareclassDetailsWildcardPage_543d5f778ad443269e2384804031cb3c_Fragment | Base_FundShareclassDetailsWildcardPage_5827425c1b4246d19f1311387a5bd4b3_Fragment | Base_FundShareclassDetailsWildcardPage_Cf3f2635270b49779bb3822ab90f1dcc_Fragment | Base_FundShareclassDetailsWildcardPage_D7e686d9c3bc4ef9974e201972b59eee_Fragment | Base_FundSubAssetClass_Fragment | Base_FundSubAssetClassesFolder_Fragment | Base_FundsExternalLiteratureFolder_Fragment | Base_FundsFolder_Fragment | Base_FundsInFocusFolder_Fragment | Base_FundsInFocusParametersTemplate_Fragment | Base_FundsLiteratureFolder_Fragment | Base_FundsLiteratureMappingsFolder_Fragment | Base_Gallery_Fragment | Base_GalleryFolder_Fragment | Base_GalleryImage_Fragment | Base_GalleryParametersTemplate_Fragment | Base_GalleryVideo_Fragment | Base_GatedAccordionContainer_Fragment | Base_GlobalLanguageSelector_Fragment | Base_GlobalNavigationBar_Fragment | Base_GoogleAnalytics_Fragment | Base_GoogleTagManager_Fragment | Base_GoogleTagManagerFolder_Fragment | Base_GridSetup_Fragment | Base_GridTheme_Fragment | Base_HtmlCode_Fragment | Base_HtmlCodeFolder_Fragment | Base_HtmlInclude_Fragment | Base_HtmlIncludesFolder_Fragment | Base_HtmlSnippet_Fragment | Base_HtmlSnippetFolder_Fragment | Base_HtmlTag_Fragment | Base_Header_Fragment | Base_HeaderFolder_Fragment | Base_Heading_Fragment | Base_HeadlessSiteSetupRoot_Fragment | Base_HeadlessSite_00d050988bad49e5b65db1e08b03ca1b_Fragment | Base_HeadlessSite_0bb67daed5d04933a5ce1c0baa6c4df1_Fragment | Base_HeadlessSite_8ca001453c4b4715959d8a05292ecbc5_Fragment | Base_HeadlessSite_68ffa40c5aab45548f774742b163f318_Fragment | Base_HeadlessSite_89d464c8c03e4b0287e9a878d95d7149_Fragment | Base_HeadlessSite_229484893ca144958b9937167dfb5064_Fragment | Base_HeadlessSite_B28055626acc45a2913a9617398c9730_Fragment | Base_HeadlessSite_F1cab1661abb450d84d55d938e7699cb_Fragment | Base_HeadlessSite_F3884baa0e1548f59a6d7154a4559604_Fragment | Base_HeadlessSolutionTemplateFolder_Fragment | Base_HeadlessTenantSetupRoot_Fragment | Base_HeadlessTenant_07248c4700af499eb2a9cb7789f72372_Fragment | Base_HeadlessTenant_5b3d7ac5419343c697c722309a2ad4c8_Fragment | Base_HeadlessTenant_5d72df6049c74324969205b55767ad7b_Fragment | Base_HeadlessTenant_6abd3bf16bcb4f25ac5b2399ff7a92e3_Fragment | Base_HeadlessTenant_77a403a2094e48afafa60943d349d23d_Fragment | Base_HeadlessTenant_115c42029c0d4fbcb542a4a539c33ee2_Fragment | Base_HeadlessTenant_94824ac390d748499e5af0275d10811f_Fragment | Base_HeadlessTenant_4797571864fd40929cf2412c39757ec3_Fragment | Base_HeadlessTenant_C102fb48f40f49fb9c21f8e3e1b0c107_Fragment | Base_HeadlessTrustSite_Fragment | Base_HeadlessVariants_Fragment | Base_HeadlessVariantsGrouping_Fragment | Base_HelpArticlePage_Fragment | Base_HelpArticlePlatform_Fragment | Base_HelpArticlePlatformMap_Fragment | Base_HelpArticlePlatformMappings_Fragment | Base_HelpArticlePlatformsFolder_Fragment | Base_HelpArticleSearchPage_Fragment | Base_HelpArticleSearchPage_486d4c7432c64f9a929b595943c6fe77_Fragment | Base_HelpArticleTag_Fragment | Base_HelpArticleTagsFolder_Fragment | Base_HelpArticleWildcardPage_Fragment | Base_HelpArticleWildcardPage_E4e2d58c853341deaa6b2a2a136421c4_Fragment | Base_HelpArticlesGroupFolder_Fragment | Base_HelpTagMap_Fragment | Base_HelpTagMappings_Fragment | Base_HeroBanner_Fragment | Base_Highlight_Fragment | Base_HighlightBlock_Fragment | Base_HighlightBlockFolder_Fragment | Base_HighlightBlockParametersTemplate_Fragment | Base_HighlightFolder_Fragment | Base_HighlightItem_Fragment | Base_HighlightParametersTemplate_Fragment | Base_Home_Fragment | Base_HomePage_Fragment | Base_HomePage_0d3963a8171d4080b5f808618578b631_Fragment | Base_HomePage_6d95c7d946c74a70be07304cc73a2010_Fragment | Base_HomePage_B407f259b4e34c7db9a06e8907a56b17_Fragment | Base_HomePage_Cde13c51062d426b95569e8202edc963_Fragment | Base_HomePage_De9353283a3e41c495ba386aed0540c6_Fragment | Base_IFrame_Fragment | Base_IFrameFolder_Fragment | Base_IFrameFolder_21366ebf5fda4ff4a4dac7b1f4d7ada2_Fragment | Base_IFrameParametersTemplate_Fragment | Base_IFrame_0da12d476de24dfeb4d0f513489bfea1_Fragment | Base_IFrame_88a6f65f2b78491bb3770b06e48883e1_Fragment | Base_Icon_Fragment | Base_IconFolder_Fragment | Base_Image_Fragment | Base_ImageFolder_Fragment | Base_ImageFolder_Edc00e86cef24d0cbfa264460becc323_Fragment | Base_ImageFolder_F7a4527687f14ea5bf25e3c7cb7aa993_Fragment | Base_ImageParametersTemplate_Fragment | Base_Image_83bc563c6320490092f8204bff81586a_Fragment | Base_Image_15185b0e641844499f934ff03b7ee032_Fragment | Base_Image_D885df8cb2d64007b34b2bbafb527304_Fragment | Base_Infographics_Fragment | Base_InfographicsFolder_Fragment | Base_InputValidationStep_Fragment | Base_InputValidationStep_088928cf558e40ec87f3342aa9e66757_Fragment | Base_InputValidationStep_9eded2f7f84748938a0bf69e7fcf3593_Fragment | Base_InputValidationStep_D028fef2babf4ad1bbe74d62a977992f_Fragment | Base_IntegerFacet_Fragment | Base_IntroCopy_Fragment | Base_IntroCopyFolder_Fragment | Base_InvestmentTrustAssetClass_Fragment | Base_InvestmentTrustAssetClassFolder_Fragment | Base_InvestmentTrustPage_8f108193367d41dcb4dc3a71722c2b73_Fragment | Base_InvestmentTrustPage_79a99ec28fe841f0a929356fe3a6aaeb_Fragment | Base_InvestmentTrustRegion_Fragment | Base_InvestmentTrustRegionFolder_Fragment | Base_InvestmentTrustStyle_Fragment | Base_InvestmentTrustStyleFolder_Fragment | Base_InvestorType_Fragment | Base_InvestorTypesFolder_Fragment | Base_ItemQueriesFolder_Fragment | Base_ItemRights_Fragment | Base_JsBeaconSettings_Fragment | Base_JsonCheckbox_Fragment | Base_JsonContent_Fragment | Base_JsonDate_Fragment | Base_JsonFile_Fragment | Base_JsonImage_Fragment | Base_JsonLayout_Fragment | Base_JsonList_Fragment | Base_JsonMultilistReference_Fragment | Base_JsonPlaceholder_Fragment | Base_JsonQuery_Fragment | Base_JsonResults_Fragment | Base_JsonRichText_Fragment | Base_JsonScriban_Fragment | Base_JsonSection_Fragment | Base_JsonTemplate_Fragment | Base_JsonText_Fragment | Base_JsonToken_Fragment | Base_JsonVariantDefinition_Fragment | Base_JsonVariants_Fragment | Base_JssLayout_Fragment | Base_JssSettings_1a6fb678eca242c09ae77a9e7f72a6d0_Fragment | Base_JssSettings_6b328292f8314ab79885d89a054ca10a_Fragment | Base_JssSettings_457c9d0b61b84adfaf7f82561ed275ff_Fragment | Base_JssSettings_5045bf85d2ea430b9f41c2e348436e5d_Fragment | Base_JssSettings_A767f80d5ad44bfbb8b750a8da144cb5_Fragment | Base_JssSettings_B001fd725bb1476496825a8cb9e995cd_Fragment | Base_JssSettings_C643bc8630d14d61a173c7870f5dbbad_Fragment | Base_JssSettings_Ce3dfd340df34b2d8715e54f85dfcce2_Fragment | Base_JssSettings_Ef855d0ba8b04a8e87851d1298266d90_Fragment | Base_JssSiteGrouping_Fragment | Base_JssTenantFolder_Fragment | Base_JavaScriptRendering_Fragment | Base_JsonRendering_Fragment | Base_JurisdictionStatus_Fragment | Base_JurisdictionsFolder_Fragment | Base_KeyHighlightItem_Fragment | Base_KeyHighlights_Fragment | Base_KeyHighlightsFolder_Fragment | Base_KeyHighlightsParametersTemplate_Fragment | Base_Language_Fragment | Base_LanguageSelector_Fragment | Base_LanguagesFolder_Fragment | Base_LatestPressReleasesParametersTemplate_Fragment | Base_LayoutServiceVariants_Fragment | Base_LimitedDisplayFolder_Fragment | Base_LimitedDisplayOption_Fragment | Base_Link_Fragment | Base_LinkList_Fragment | Base_LinkListFolder_Fragment | Base_LinkListFolder_C237d144647a4afeaa7b1570f3e3f139_Fragment | Base_LinkList_33c9207e3b0446068ef54ca99a97c776_Fragment | Base_LinkList_97a593ad273141dc80bfceb5ef6a33b7_Fragment | Base_LinkList_F7561ffcc0d8477fb53d2703a4060be1_Fragment | Base_Link_68bd1cb5a7624a969ac6cb16ab5882a3_Fragment | Base_Link_930f134d56784b35bfd1b77f9d0115f1_Fragment | Base_Link_E24e0789a05848bfabb6c69c0e60b6b7_Fragment | Base_LinksFolder_Fragment | Base_List_Fragment | Base_ListFacet_Fragment | Base_ListFolder_Fragment | Base_ListItem_Fragment | Base_ListParametersTemplate_Fragment | Base_ListStyle_Fragment | Base_ListStyleItem_Fragment | Base_ListingHeroBanner_Fragment | Base_ListingHeroParametersTemplate_Fragment | Base_LiteratureAuthorization_Fragment | Base_LiteratureAuthorizationsFolder_Fragment | Base_LiteratureHubSearchPage_Fragment | Base_LiteratureHubSearchPage_62f4748b81db49ee9be8b674a7f42d9d_Fragment | Base_LiteratureHubSearchPage_94278fe5377a4665bccbd1d4cef5e30e_Fragment | Base_LiteratureHubSearchPage_D2b2958263564ba8bba5922add46a0ea_Fragment | Base_LoadMore_Fragment | Base_LoadMoreFolder_Fragment | Base_LoadMore_7a3a53e06a0144ff8ba52be46e201fe6_Fragment | Base_LocationFilter_Fragment | Base_LocationFilterFolder_Fragment | Base_LocationFilter_Aaad4aad290744dc90b69e4e83a661ec_Fragment | Base_Log_Fragment | Base_Login_Fragment | Base_Login_Abed54dc4f7840ddac562289c9c849d8_Fragment | Base_LogoTextBlockItem_Fragment | Base_LogoTextBlocks_Fragment | Base_LogoTextBlocksFolder_Fragment | Base_Logout_Fragment | Base_Logout_C2294d8235a6452a94b15eb5e543b602_Fragment | Base_ManagedRangeFilter_Fragment | Base_ManagedRangeFilterFolder_Fragment | Base_ManagedRangeFilter_14c6033e186b49088bb925aba0da4d91_Fragment | Base_ManagedRangeItem_Fragment | Base_Map_Fragment | Base_MapParameters_Fragment | Base_MapsFolder_Fragment | Base_MapsProvider_Fragment | Base_MediaBlock_Fragment | Base_MediaBlockFolder_Fragment | Base_MediaBlockParametersTemplate_Fragment | Base_MediaFolder_81150e5837f5443fa3c075e14a9321e7_Fragment | Base_MediaLinkParameters_Fragment | Base_MediaVirtualFolder_Fragment | Base_MegaNavigation_Fragment | Base_MegaNavigationFolder_Fragment | Base_MetaBranding_Fragment | Base_MetaRenderingParameters_Fragment | Base_MetadataPartialDesign_Fragment | Base_Model_Fragment | Base_ModelIterator_Fragment | Base_MyLocationPoi_Fragment | Base_Navigation_Fragment | Base_NavigationCategory_Fragment | Base_NavigationFilter_Fragment | Base_NavigationFilterFolder_Fragment | Base_NavigationLink_Fragment | Base_NavigationSubcategory_Fragment | Base_Navigation_9ce34bf95c934dff841d8f649c2bd6c8_Fragment | Base_OneTrustSettings_Fragment | Base_OptimiserConfiguration_Fragment | Base_OptimiserConfigurationSection_Fragment | Base_OptimizedFile_Fragment | Base_OracleCdpSettings_Fragment | Base_OverlayContent_Fragment | Base_OverlayFolderTemplate_Fragment | Base_Ownership_Fragment | Base_OwnershipFolder_Fragment | Base_Poi_Fragment | Base_PoiFolder_Fragment | Base_PoiType_Fragment | Base_PoIs_Fragment | Base_PageBranchesFolder_Fragment | Base_PageContent_Fragment | Base_PageContentFolder_Fragment | Base_PageContent_Ef87e73bc7ff49a2ac599b0be83755c3_Fragment | Base_PageDesign_Fragment | Base_PageDesignFolder_1aa9bc8250a94e4eb15003b55b4dfed0_Fragment | Base_PageDesignFolder_27d4f8be63b045769a4ef3163c935b47_Fragment | Base_PageDesignFolder_352ce40ee6e1457a8bf225d8771894e8_Fragment | Base_PageDesignFolder_446a7eadeb894ed6b48c7f1862f29d7b_Fragment | Base_PageDesignFolder_720d01f11e5046fa9c4a697f9321f662_Fragment | Base_PageDesignFolder_771a0de7e83f44338c5d78727ead93bc_Fragment | Base_PageDesignFolder_14161ec204984aa7a2a46decadf669f5_Fragment | Base_PageDesignFolder_C691c2c4e0dd4fedb84a3c29de7002cb_Fragment | Base_PageDesignFolder_D84605f786ea482da6ff683f6572821c_Fragment | Base_PageDesign_1105b8f81e00426bbf1fc840742d827b_Fragment | Base_PageDesigns_Fragment | Base_PageDesigns_3af52e70e982424b9c85e355542500c9_Fragment | Base_PageDesigns_9b34083e890b467d8e76b8c3dbbb712d_Fragment | Base_PageDesigns_48d2d50a150c4f6283603a4fed5646e0_Fragment | Base_PageDesigns_99a71bba507746729c3fb29b04abee23_Fragment | Base_PageDesigns_A0f265b42d6241968b65d3ede7cb59c3_Fragment | Base_PageDesigns_Abe5ce6a82ff4433b4973bc50f192e11_Fragment | Base_PageDesigns_B8d9b352c1694b31bd506848b47ca884_Fragment | Base_PageDesigns_D3b2e1466f744df0900bec314f699ef3_Fragment | Base_PageDesigns_Fd4b9b54f7474f01abdeba569d4b5bbe_Fragment | Base_PageLevelTabs_Fragment | Base_PageLevelTabsFolder_Fragment | Base_PageList_Fragment | Base_PageSelector_Fragment | Base_PageSelectorConfiguration_Fragment | Base_PageSelectorFolder_Fragment | Base_PageSelector_59a7bb775f8c435ab810291abde80e63_Fragment | Base_PageSize_Fragment | Base_PageSizeFolder_Fragment | Base_PageSize_B682562e0af64b3e9e3b45273bbe152d_Fragment | Base_PageTheme_Fragment | Base_PageThemesFolder_Fragment | Base_Page_4f49a81db3664f198b89cab92f377d7a_Fragment | Base_Page_5e66d86353544fe6a27d3b894984d50f_Fragment | Base_Page_84f342ad2d0646b9aa9a818201145ca2_Fragment | Base_Page_718df200be51463d93edf4d77ab7a49e_Fragment | Base_Page_B61d5babe46f4ef39f27b57c4ccefdf7_Fragment | Base_Page_Cfd6e04697e24f3cb9eb41b79afc35dc_Fragment | Base_Page_Dae7821153e14dbabb0ddf0b53a90aaf_Fragment | Base_Page_Fa608b3e6aeb426388a059d89caabada_Fragment | Base_Pagging_Fragment | Base_Pagination_Fragment | Base_PaginationFolder_Fragment | Base_Paragraph_Fragment | Base_PartialDesignFolder_8cf20a4412b746ee801218122c955b2d_Fragment | Base_PartialDesignFolder_42eb57ecaa474923b3ddbfb72818f00b_Fragment | Base_PartialDesignFolder_766d4de859a0419292de1898fe0ac4e8_Fragment | Base_PartialDesignFolder_827d4d2f2a84408e8f0ff1d6869a441b_Fragment | Base_PartialDesignFolder_828b5ff144cd4150bcdfe54084165112_Fragment | Base_PartialDesignFolder_89098e3089aa4062a77346d608caac90_Fragment | Base_PartialDesignFolder_1695576fb93647d7842ed17730278c32_Fragment | Base_PartialDesignFolder_F16ae56fb78845639407c88edaffcbcc_Fragment | Base_PartialDesignFolder_Fb58558a3ec946d18524cd30805ab21a_Fragment | Base_PartialDesign_Fd2059fd60434dfe8c04e2437ce87634_Fragment | Base_PartialDesigns_Fragment | Base_PartialDesigns_043d3ad0ac4445dba03afc3550d088ec_Fragment | Base_PartialDesigns_0310a4bf20d1441c886a0418c53e30f4_Fragment | Base_PartialDesigns_36c869ded22040929ce829f6ed643c66_Fragment | Base_PartialDesigns_1943dc73710a430895515a342c84b037_Fragment | Base_PartialDesigns_B1e2a6790a1442d8bafa66317b8be117_Fragment | Base_PartialDesigns_Cc6d8635f3e2440ab8ebb93dc1030e9e_Fragment | Base_PartialDesigns_D52704ed3b704a53abb4292105f687ad_Fragment | Base_PartialDesigns_D216303f58d8425688da8cd30d00afab_Fragment | Base_PartialDesigns_Facda26791204fa9a0363344348f2c42_Fragment | Base_PerformanceChartSettings_Fragment | Base_PerformanceChartTimePeriod_Fragment | Base_PerformanceChartTimePeriodFolder_Fragment | Base_PlaceholderSettingsFolder_0339bac078c143c1b930f8c26a5fdf80_Fragment | Base_PlaceholderSettingsFolder_3d281bf8533646869dd6ab4ab5b3fd5d_Fragment | Base_PlaceholderSettingsFolder_52288e3978304694b62d32a54c6ef7ba_Fragment | Base_Placeholder_1ca0304be5b64810821154426f1752c2_Fragment | Base_Placeholder_D2a6884c04d54089a64ed27ca9d68d4c_Fragment | Base_PlainHtmlParametersTemplate_Fragment | Base_Playlist_Fragment | Base_PlaylistFolder_Fragment | Base_PlaylistParametersTemplate_Fragment | Base_Podcast_Fragment | Base_PodcastFolder_Fragment | Base_PodcastPage_Fragment | Base_PodcastPressReleasePage_Fragment | Base_PoiTypes_Fragment | Base_PostDeleteStep_Fragment | Base_PostDeleteStep_7a7e57b99c6d4a22b5fdf7b214dde574_Fragment | Base_PostDeleteStep_78d6ec9b66e34763987003cf314ee37a_Fragment | Base_PostDeleteStep_B20857895385413883f096f3767cb156_Fragment | Base_PostSetupStep_Fragment | Base_PostSetupStep_6fac654e22154a419a1d59197bebc0fe_Fragment | Base_PostSetupStep_8ff2febff6d2461d9ed38b0cb5d9d86f_Fragment | Base_PostSetupStep_341738aa44fe490e90ff7010a3c2463b_Fragment | Base_PreDeleteStep_Fragment | Base_PreDeleteStep_51437c06212c4c0fb3b2fa5b0486ab49_Fragment | Base_PreDeleteStep_52510f549ec5464cb075ef44b5c2f96b_Fragment | Base_PreDeleteStep_F0daf401190f45468bda8568d08e161d_Fragment | Base_PreDeleteValidationStep_Fragment | Base_PreDeleteValidationStep_408fd8ab1667440ba6051370ddf0a51f_Fragment | Base_PreDeleteValidationStep_Edf1fa4206c44703ab1af23495bc6d8f_Fragment | Base_PreDeleteValidationStep_F8c52120d0ea4d009de3b49fe12a3f1e_Fragment | Base_Presentation_Fragment | Base_Presentation_0a70fa7389234a6eabf34134f25f3221_Fragment | Base_PressReleaseContentType_Fragment | Base_PressReleaseContentTypesFolder_Fragment | Base_PressReleaseFilter_Fragment | Base_PressReleasePage_Fragment | Base_PressReleasePlatform_Fragment | Base_PressReleasePlatformsFolder_Fragment | Base_PressReleaseSearchPage_Fragment | Base_PressReleaseSearchPage_1b2f7a53709a4c62b381dae5f1280b7f_Fragment | Base_PressReleaseSearchPage_A6c344ca7c6946009de2ca92e27d7b72_Fragment | Base_PressReleaseSearchPage_B9cd16f585ea4405a1ceda10cb20f64d_Fragment | Base_PressReleaseSearchPage_C97027442df647cf9c36eedfc6787f58_Fragment | Base_PressReleaseWildcardPage_Fragment | Base_PressReleaseWildcardPage_2c028bdb02874051b629a7b7d422cc1e_Fragment | Base_PressReleaseWildcardPage_5a72be834c654d70a591cef7e9ce9d79_Fragment | Base_PressReleaseWildcardPage_B337d30403c642d2b9757e23d08223a1_Fragment | Base_PressReleaseWildcardPage_E55e9d5bf9614e30b0a2a90327428258_Fragment | Base_PressReleasesGroupFolder_Fragment | Base_PrivacyWarning_Fragment | Base_ProjectFolder_Fragment | Base_Promo_Fragment | Base_PromoFolder_Fragment | Base_PromoFolder_F07cbe8973ae4de692172570260cac6e_Fragment | Base_Promo_7f21f14d096b4f27bbccf115c6e6f6f1_Fragment | Base_Promo_881869ca7f5845ea8b34ad1bfd3551a8_Fragment | Base_Promo_Dfed4457d760457abec1c0dccdc44381_Fragment | Base_PromotedContent_Fragment | Base_PromotedContentFolder_Fragment | Base_PropertyListingCard_Fragment | Base_PropertyListingCards_Fragment | Base_PropertyListingCategory_Fragment | Base_PropertyListingFolder_Fragment | Base_Query_98b413525a4b4067b92418a4b50f0a53_Fragment | Base_QuickLinks_Fragment | Base_QuickLinksFolder_Fragment | Base_QuickLinksParametersTemplate_Fragment | Base_QuotationBlockItem_Fragment | Base_QuotationBlocks_Fragment | Base_QuotationBlocksFolder_Fragment | Base_QuotationBlocksParametersTemplate_Fragment | Base_Quote_Fragment | Base_QuoteFolder_Fragment | Base_QuoteParametersTemplate_Fragment | Base_RadiusFilter_Fragment | Base_RadiusFilterFolder_Fragment | Base_RadiusFilter_De3fa58eef9d45449f77dcd1dbb05b64_Fragment | Base_RadiusScheme_Fragment | Base_RadiusSchemeValue_Fragment | Base_RangeSliderFilter_Fragment | Base_RangeSliderFilterFolder_Fragment | Base_RangeSliderFilter_0a1787c296b54d40828522564a5d8e03_Fragment | Base_RecentArticles_Fragment | Base_Redirect_Fragment | Base_RedirectMap_Fragment | Base_RedirectMaps_Fragment | Base_Region_Fragment | Base_RegionLanguages_Fragment | Base_RegionLanguagesFolder_Fragment | Base_RelatedArticles_Fragment | Base_RelatedArticlesParametersTemplate_Fragment | Base_RenderEngineType_Fragment | Base_RenderingFolder_840d4a46550349ecbf9dbd090946c63d_Fragment | Base_RenderingHost_Fragment | Base_ResizableIFramePage_Fragment | Base_ResizableIFramePage_8ab2ae106350452ca0e7b06d6d859067_Fragment | Base_ResizableIFramePage_92674815f3f74a879c0874bcb72c9b68_Fragment | Base_ResizableIFramePage_B58eacfb27f5417bb536141f94b92521_Fragment | Base_ResizableIFramePage_D8d76a2407084147bf3900cd5e12e401_Fragment | Base_ResizableIFramePage_F460ab055585441892023750e7cef6b7_Fragment | Base_ResponsiveImage_Fragment | Base_ResultsCount_Fragment | Base_ResultsCountFolder_Fragment | Base_ResultsCount_F3c0661ef9a9444ca26d44bf2a68a186_Fragment | Base_ResultsVariantSelector_Fragment | Base_RichText_Fragment | Base_RichTextFolder_Fragment | Base_RichText_0f3b73366112418c8bbab0526f3887ce_Fragment | Base_RichText_Efcfd8f6596745f48f85b5421928205d_Fragment | Base_RiskImageMapping_Fragment | Base_RiskImageMappings_Fragment | Base_RiskLevelOption_Fragment | Base_RiskLevelOptionFolder_Fragment | Base_RiskWarning_Fragment | Base_RiskWarningFolder_Fragment | Base_RiskWarningParametersTemplate_Fragment | Base_RolePlaceholder_Fragment | Base_RowSplitter_Fragment | Base_RowSplitter_340c887da1d1415b9678c763af74ea97_Fragment | Base_Rule_Fragment | Base_SdrLogoMapping_Fragment | Base_SdrLogoMappings_Fragment | Base_SdrTypeOption_Fragment | Base_SdrTypeOptionFolder_Fragment | Base_SxajssLayout_Fragment | Base_SxaRole_Fragment | Base_SxaStandardValuesFolder_Fragment | Base_SalesforceAlertMessage_Fragment | Base_SalesforceCheckBox_Fragment | Base_SalesforceCheckBoxType_Fragment | Base_SalesforceConditionalRadioButton_Fragment | Base_SalesforceConditionalRadioButtons_Fragment | Base_SalesforceDateInput_Fragment | Base_SalesforceDropdown_Fragment | Base_SalesforceDropdownOption_Fragment | Base_SalesforceHiddenField_Fragment | Base_SalesforceInput_Fragment | Base_SalesforceInputType_Fragment | Base_SalesforceIntegratedForm_Fragment | Base_SalesforceIntegratedFormTypesFolder_Fragment | Base_SalesforceRepeatableSubSection_Fragment | Base_SalesforceRichTextArea_Fragment | Base_SalesforceSection_Fragment | Base_SalesforceSortCodeInput_Fragment | Base_SalesforceSubmissionType_Fragment | Base_Scope_Fragment | Base_ScopesFolder_Fragment | Base_Scriban_Fragment | Base_Scripts_Fragment | Base_SearchBox_Fragment | Base_SearchBoxFolder_Fragment | Base_SearchBox_1c04fd611d874590acfe9cc186865ab3_Fragment | Base_SearchFolder_Fragment | Base_SearchResults_Fragment | Base_SearchResultsFolder_Fragment | Base_SearchResults_A06f7130041d46bb8c2995a2dc00c26a_Fragment | Base_SecondaryHeroBannerParametersTemplate_Fragment | Base_SectionHeading_Fragment | Base_SectionHeadingFolder_Fragment | Base_SectionHeadingParametersTemplate_Fragment | Base_SectionHeadingType_Fragment | Base_SectionHeadingTypeFolder_Fragment | Base_SectionSelector_Fragment | Base_SectionSelectorFolder_Fragment | Base_SectionSelectorTab_Fragment | Base_Security_33077d51ebad4d1cb4a83b79f51dba13_Fragment | Base_Series_Fragment | Base_SeriesFolder_Fragment | Base_Settings_Fragment | Base_SettingsFolder_Fragment | Base_Settings_6c82caca67dc464195698faad083230e_Fragment | Base_SharePriceSettings_Fragment | Base_SharedArticlesFolder_Fragment | Base_SharedContentFolder_Fragment | Base_SharedFolder_Fragment | Base_SharedHelpArticlesFolder_Fragment | Base_SharedPressReleasesFolder_Fragment | Base_SharedSettingsFolder_Fragment | Base_SharedSitesSettings_Fragment | Base_SharedSitesSettings_C14bf746030f4e598594395f6d299e61_Fragment | Base_Showcase_Fragment | Base_ShowcaseFolder_Fragment | Base_ShowcaseItem_Fragment | Base_ShowcaseParametersTemplate_Fragment | Base_Site_Fragment | Base_SiteContentFolder_Fragment | Base_SiteDefinition_Fragment | Base_SiteEntryDisclaimer_Fragment | Base_SiteFolder_Fragment | Base_SiteGrouping_Fragment | Base_SiteManagement_Fragment | Base_SiteSecurityItemPointer_Fragment | Base_SiteSelector_Fragment | Base_SiteSelector_A44632f56dcd4d10b4892f4e35e193c3_Fragment | Base_SiteSetupRoot_Fragment | Base_SiteTheme_Fragment | Base_Site_E46f3af239fa4866a1577017c4b2a40c_Fragment | Base_SitecoreFormWrapperParametersTemplate_Fragment | Base_SitecoreRole_Fragment | Base_SitemapSettings_C71d856635c849b7a84d9d176e9cbd05_Fragment | Base_SkipLink_Fragment | Base_SkipLinkParameters_Fragment | Base_SkipLinksFolder_Fragment | Base_Snippet_Fragment | Base_SnippetItem_Fragment | Base_SnippetsFolder_Fragment | Base_SocialLoginWrapper_Fragment | Base_SocialMediaButtons_Fragment | Base_SocialMediaFolder_Fragment | Base_SocialMediaShare_Fragment | Base_SocialMediaTemplate_Fragment | Base_SocialNetwork_Fragment | Base_SocialNetworkFolder_Fragment | Base_SocialNetworkLink_Fragment | Base_SolutionTemplate_Fragment | Base_SortResults_Fragment | Base_SortResultsFolder_Fragment | Base_Sorting_Fragment | Base_SortingGroups_Fragment | Base_SpotifyPodcast_Fragment | Base_SpotifyPodcastFolder_Fragment | Base_StickyCta_Fragment | Base_StickyCtaFolder_Fragment | Base_StickyCtaParametersTemplate_Fragment | Base_StrategiesInFocusFolder_Fragment | Base_StrategyInFocus_Fragment | Base_Style_Fragment | Base_Styles_Fragment | Base_Styles_9c0dac2808aa4b44bc2153363206f6a5_Fragment | Base_SubscriptionBannerParametersTemplate_Fragment | Base_Tab_Fragment | Base_TabItem_Fragment | Base_TableOfContents_Fragment | Base_TableOfContentsFolder_Fragment | Base_TableOfContentsSection_Fragment | Base_TableOfContentsSubsection_Fragment | Base_Tabs_Fragment | Base_TabsFolder_Fragment | Base_Tabs_F26a9560ccf148c59542800e837caf7a_Fragment | Base_Tag_Fragment | Base_TagCloud_Fragment | Base_TagFolder_Fragment | Base_TagList_Fragment | Base_TeamBiographySettings_Fragment | Base_TeamListingCards_Fragment | Base_TeamListingCardsFolder_Fragment | Base_TeamMember_Fragment | Base_TeamMemberCard_Fragment | Base_TeamMembers_Fragment | Base_TeamMembersParentPage_Fragment | Base_TeamMembersParentPage_0dfb40140ba44abe8a480904ff1eff1e_Fragment | Base_TeamMembersParentPage_2e9df92fe936461987fd0ea8ad08bd9e_Fragment | Base_TeamMembersParentPage_47f304d629a84648a0e2b942513133ff_Fragment | Base_TeamMembersParentPage_75c911bd18704434ad7adcca64dfb089_Fragment | Base_TeamMembersParentPage_B4311697c06c4d58b88dca047c0a72b0_Fragment | Base_TeamMembersWildcardPage_Fragment | Base_TeamMembersWildcardPage_6c0a7b262ac64e1ba92ab20013a5a00e_Fragment | Base_TeamMembersWildcardPage_9c436bbf177d481da8bdfdc12a53d450_Fragment | Base_TeamMembersWildcardPage_52ba0118982f400fb80e1fee787f1d3a_Fragment | Base_TeamMembersWildcardPage_54e4118770954f8abdfb908c88ce2f29_Fragment | Base_TeamMembersWildcardPage_Ea27a3d835fd49a3a4c797d2a6d52745_Fragment | Base_TeamProfileCards_Fragment | Base_TeamProfileCardsFolder_Fragment | Base_TechzoneArticlePage_Fragment | Base_Tenant_Fragment | Base_TenantFolder_Fragment | Base_TenantSecurityItemPointer_Fragment | Base_TenantSetupRoot_Fragment | Base_TertieryHeroBanner_Fragment | Base_TertieryHeroBannerParametersTemplate_Fragment | Base_Text_Fragment | Base_TextBlock_Fragment | Base_TextBlockHeadingParametersTemplate_Fragment | Base_TextBlockHeadingType_Fragment | Base_TextBlockHeadingTypeFolder_Fragment | Base_TextBlockLinkType_Fragment | Base_TextBlockLinkTypeFolder_Fragment | Base_TextBlocks_Fragment | Base_TextBlocksFolder_Fragment | Base_TextBlocksParametersTemplate_Fragment | Base_TextFolder_Fragment | Base_TextFolder_B762d56787f5493cbb480c455d834457_Fragment | Base_Text_B8f5894cb4934016bf784090b0a2fd16_Fragment | Base_Theme_Fragment | Base_ThemeTag_Fragment | Base_ThemeTagsFolder_Fragment | Base_ThemingMode_Fragment | Base_ThemingModes_Fragment | Base_Tile_Fragment | Base_TileLink_Fragment | Base_TileParametersTemplate_Fragment | Base_TileSizeOption_Fragment | Base_TileSizeOptionFolder_Fragment | Base_TilesFolder_Fragment | Base_TilesParametersTemplate_Fragment | Base_Title_Fragment | Base_Title_A82e893105754175917de904ef7e6dbe_Fragment | Base_Toggle_Fragment | Base_ToggleFolder_Fragment | Base_Toggle_8e4c968e9fa543a89ac4c0baf273ccde_Fragment | Base_Transformation_Fragment | Base_TrustArticleHeroParametersTemplate_Fragment | Base_TrustFinder_Fragment | Base_TrustFinderFilterOption_Fragment | Base_TrustRegion_Fragment | Base_TrustType_Fragment | Base_TrustTypesFolder_Fragment | Base_Twitter_Fragment | Base_TwitterApp_Fragment | Base_TwitterApps_Fragment | Base_TwitterFolder_Fragment | Base_TwitterParametersTemplate_Fragment | Base_TwitterSettings_Fragment | Base_UnknownItem_Fragment | Base_UnminifiedFile_Fragment | Base_UpgradeScript_Fragment | Base_UpgradeScriptLibrary_Fragment | Base_VariantComponentField_Fragment | Base_VariantDateField_Fragment | Base_VariantDefinition_4d50cdaec2d94de8b0808f992bfb1b55_Fragment | Base_VariantPlaceholder_Fragment | Base_VariantReference_Fragment | Base_VariantSection_Fragment | Base_VariantTemplate_Fragment | Base_VariantText_Fragment | Base_VariantToken_Fragment | Base_Variants_Fragment | Base_VectorFolder_Fragment | Base_VectorTile_Fragment | Base_VectorTileLink_Fragment | Base_VectorTilesFolder_Fragment | Base_VectorTilesParametersTemplate_Fragment | Base_Version_95ebc23204774dc38ad3465d5fe8da2f_Fragment | Base_Video_Fragment | Base_VideoCountOption_Fragment | Base_VideoCountOptions_Fragment | Base_VideoFolder_Fragment | Base_VideoFolder_Bba49474673e468186ba8b1a20e067a9_Fragment | Base_VideoPage_Fragment | Base_VideoParameters_Fragment | Base_VideoParametersTemplate_Fragment | Base_VideoPressReleasePage_Fragment | Base_Video_4bc649610a894242be2dc5026090cf49_Fragment | Base__AssetsOptimization_Fragment | Base__BackgroundImage_Fragment | Base__CompatibleThemes_Fragment | Base__CompositeTheme_Fragment | Base__CustomMetadata_Fragment | Base__CustomRenderingViewPath_Fragment | Base__DatasourceBehaviour_Fragment | Base__Favicon_Fragment | Base__FormsFolderLocation_Fragment | Base__FundSettings_Fragment | Base__HasValidUrlName_Fragment | Base__LocalDataLink_Fragment | Base__Login_Fragment | Base__OpenGraphMetadata_Fragment | Base__PageDesignTheme_Fragment | Base__PageSearchScope_Fragment | Base__SearchCriteria_Fragment | Base__SearchableWithoutRelatedItems_Fragment | Base__SeoMetadata_Fragment | Base__SiteTheme_Fragment | Base__SitemapSettings_Fragment | Base__StickyNote_Fragment | Base__Styleable_Fragment | Base__TwitterMetadata_Fragment | Base__Webinar_Fragment | Base__WildcardSource_Fragment;

export type ArticleCardsFragment = (
  { __typename?: 'ArticlePage' | 'C___Article' | 'C___BaseArticle' | 'C___ExternalArticle' | 'C___InternalArticle' | 'C___Podcast' | 'C___TechzoneArticle' | 'C___Video' | 'PodcastPage' | 'TechzoneArticlePage' | 'VideoPage' | '_Webinar' }
  & { articleCategory: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleCategory_LookupField>, articleTitle: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleTitle_TextField>, articleStrapline: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleStrapline_TextField>, articlePublicationDate: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articlePublicationDate_DateField>, articleImage: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_articleImage_ImageField> }
);

export type VideoDurationFragment = (
  { __typename?: 'C___Video' | 'VideoPage' }
  & { duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Video_duration_IntegerField> }
);

export type PodcastDurationFragment = (
  { __typename?: 'C___Podcast' | 'PodcastPage' }
  & { duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_C___Podcast_duration_IntegerField> }
);

export type ArticleDurationFragment = (
  { __typename?: 'ArticlePage' | 'C___Article' }
  & { duration: Types.Maybe<ArticleSearchSeriesQuery_search_ItemSearchResults_results_ArticlePage_duration_IntegerField> }
);

export const BaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Base"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<BaseFragment, unknown>;
export const ArticleCardsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_1e4c2734dc754d528af8084e6c400e1f"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleStrapline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articlePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"articleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}}]} as unknown as DocumentNode<ArticleCardsFragment, unknown>;
export const VideoDurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<VideoDurationFragment, unknown>;
export const PodcastDurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<PodcastDurationFragment, unknown>;
export const ArticleDurationFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ArticleDurationFragment, unknown>;
export const ArticleSearchSeriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArticleSearchSeries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"language"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"search"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"AND"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_path","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"2567876566B044428C3DB5C9D0E53D76","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_templates","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"70945527D09E4CC5A30A364324CBFCCF","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"_language","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"language"}}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"shareTo","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"OR"},"value":{"kind":"ListValue","values":[{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"limitedDisplay","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"StringValue","value":"1","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"LT"}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"limitedDisplayExceptions","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"siteId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]}]}}]},{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"articleSeries","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"value"},"value":{"kind":"Variable","name":{"kind":"Name","value":"seriesId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"operator"},"value":{"kind":"EnumValue","value":"CONTAINS"}}]}]}}]}},{"kind":"Argument","name":{"kind":"Name","value":"first"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pageSize"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"name"},"value":{"kind":"StringValue","value":"articlePublicationDate","block":false}},{"kind":"ObjectField","name":{"kind":"Name","value":"direction"},"value":{"kind":"EnumValue","value":"DESC"}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"total"}},{"kind":"Field","name":{"kind":"Name","value":"pageInfo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endCursor"}},{"kind":"Field","name":{"kind":"Name","value":"hasNext"}}]}},{"kind":"Field","name":{"kind":"Name","value":"results"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Base"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCards"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoDuration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PodcastDuration"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleDuration"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Base"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Item"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"template"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCards"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_BaseArticle"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleCategory"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"targetItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ArticleCategory"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name_1e4c2734dc754d528af8084e6c400e1f"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleTitle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleStrapline"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articlePublicationDate"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"formattedDateValue"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"yyyy-MM-ddTHH:mm:ssZ","block":false}}]}]}},{"kind":"Field","name":{"kind":"Name","value":"articleImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Video"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PodcastDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Podcast"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleDuration"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"_Article"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"duration"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]}}]} as unknown as DocumentNode<ArticleSearchSeriesQuery, ArticleSearchSeriesQueryVariables>;